<template>
  <main id="newMain">

    <!-- 공지팝업모달 -->
    <NoticeModal_hp
      v-for="(modal, idx) in filteredNoticeModals"
      :key="modal.id"
      :content="modal.content"
      :idx="idx"
      @close="handleNoticeClose(modal.id)"
    />

    <div id="app" class="main-container" v-if="!this.mobileDisplay">

      <div class="adBar" v-if="showAdBar_pc" style="position: relative; display: inline-block;">
        <button class="adBar_closeBtn_pc" aria-label="Close adBar" @click="closeAdBar">
          <i class="bi bi-x-square text-danger"></i>
        </button>        
        
        <div class="adBar" style="padding-top: 0px !important;">
          <a href="/lp_AppOpenEvent_pc">
            <img src="../../src/assets/img/main/adBar/top_add_point_pc.jpg" style="width: 100%; height: auto;">
          </a>
        </div>
      </div>

      <!-- Header Section -->
      <header class="d-flex justify-content-between align-items-center py-3 top-menu">
        <div class="mlogo">
          <a href="/">
            <img src="../../src/assets/img/ci_bi/Ntabi.png"  class="logo" alt="Ntabi" />
          </a>
        </div>

        <nav>
          <ul class="nav" style="display: flex; align-items: center">
            <li class="nav-item" v-if="user.email == undefined">
              <a href="javascript:void(0)" class="nav-link text-secondary" @click="toB2CLoginPage" >로그인</a>
            </li>

            <li class="nav-item" v-else>
              <a href="javascript:void(0)" class="nav-link text-secondary" @click="toB2CLogout" >로그아웃</a>
            </li>
            <li class="nav-item">
              <a href="javascript:void(0)" class="nav-link text-secondary" @click="toMyPage">마이페이지</a>
            </li> 
            <li class="nav-item">
              <a href="https://smartstore.naver.com/ntabi" target="_blank" class="nav-link blink fw-bold" style="color: green" >네이버예약</a>
            </li>
          </ul>
        </nav>
      </header>

      <section id="topBanner" class="topBanner" ref="mainBanner">
        <div id="carouselExampleControls" class="topCarousel carousel slide" data-bs-ride="carousel" data-bs-interval="3000" data-bs-touch="true">
          <div class="carousel-inner" style="scroll-behavior: smooth">
            <div class="carousel-item" v-for="(slide, index) in slides" :key="index" :class="{ active: index === 0 }">
              <div class="carousel-image-container">
                <img 
                  :src="slide.image"
                  class="d-block"
                  :alt="slide.alt"
                  style="cursor: pointer"
                  @click="goLink(slide.type, slide.link, slide.pId, slide.sRoute)"
                />
              </div>
            </div>

            <div class="carousel-indicators thumbnail-indicators">
              <button
                v-for="(slide, index) in slides"
                :key="index"
                type="button"
                :data-bs-target="'#carouselExampleControls'"
                :data-bs-slide-to="index"
                :class="{ active: index === 0 }"
                :aria-current="index === 0 ? 'true' : 'false'"
                :aria-label="'Slide ' + (index + 1)"
              >
                <img :src="slide.image" :alt="slide.alt" class="thumbnail-image"/>
              </button>
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </section>

      <!-- 상단메뉴 -->
      <div class="pc-container">
        <div class="side left"></div>

        <div class="center">
          <section class="menu_backgorund_color w-100 mt-3">
            <div class="justify-content-center">
              <table class="w-100 text-center">
                <!-- 1st Line -->
                <tr>
                  <!-- 엔데이트립멤버십 -->
                  <td class="mainCategory">
                    <button type="btn" @click="goToPage('MShip')" style="border: none; padding: 0" class="cateButton">
                      <img src="../assets/img/main/cateBtn/membership_mt.gif" alt="" style="width: 100%; height: 100%"/>
                    </button>
                  </td>
                  <!-- 엔데이트립현지투어 -->
                  <td class="mainCategory">
                    <button type="btn" @click="goToPage('BsTour');" style="border: none; padding: 0" class="cateButton" >
                      <img src="../assets/img/main/cateBtn/ndaytrip_mt.png" alt="" style="width: 100%; height: 100%"/>
                    </button>
                  </td>
                  <td class="mainCategory">
                    <!-- 부산일본승선권 -->
                    <button type="btn" @click="goToPage('JShip')" style="border: none; padding: 0" class="cateButton">
                      <img src="../assets/img/main/cateBtn/japanship_mt.jpg" alt="" style="width: 100%; height: 100%"/>
                    </button>
                  </td>
                </tr>

                <!-- 2nd Line -->
                <tr>
                  <!-- 버라이어티팩 -->
                  <td class="mainCategory">
                    <button type="btn" @click="goToPage('NtVr');" style="border: none; padding: 0" class="cateButton">
                      <img src="../assets/img/main/cateBtn/veriety_mt.png" alt="" style="width: 100%; height: 100%"/>
                    </button>
                  </td>
                  <!-- 엔버스 -->
                  <td class="mainCategory">
                    <button type="btn" @click="goToPage('NBus')" style="border: none; padding: 0" class="cateButton">
                      <img src="../assets/img/main/cateBtn/nbus_mt.png" alt="" style="width: 100%; height: 100%"/>
                    </button>
                  </td>
                  <!-- 패키지여행 -->
                  <td class="mainCategory">
                    <button type="btn" @click="goToPage('PKG')" style="border: none; padding: 0" class="cateButton">
                      <img src="../assets/img/main/cateBtn/packagetour_mt.png" alt="" style="width: 100%; height: 100%"/>
                    </button>
                  </td>
                </tr>

                <!-- 3rd Line -->
                <tr>
                  <!-- 티켓패스 -->
                  <td class="mainCategory">
                    <button type="btn" @click="goToPage('TkPass')" style="border: none; padding: 0" class="cateButton" >
                      <img src="../assets/img/main/cateBtn/ticketpass_mt.png" alt="" style="width: 100%; height: 100%"/>
                    </button>
                  </td>
                  <!-- 일본골프여행 -->
                  <td class="mainCategory">
                    <button type="btn" @click="goToPage('Golf')" style="border: none; padding: 0" class="cateButton" >
                      <img src="../assets/img/main/cateBtn/golftour_mt.png" alt="" style="width: 100%; height: 100%"/>
                    </button>
                  </td>
                  <td colspan="2" class="mainCategory"> 
                    <button type="btn" @click="goToPage('EVT')" style="border: none; padding: 0" class="cateButton">
                    <img src="../assets/img/main/cateBtn/blood_event_line.gif" style="width: 100%; height: 100%;" alt="">
                    </button>
                  </td>
          
                </tr>
              </table>
            </div>
          </section>

          <!-- *********************************** 
            **라쿠텐 호텔검색영역 (2026-05-15) **
            **************************************** -->
          <section class="w-100 mt-5 hotel-search-section" v-if="this.AccHotel === 'OK'">
            <div class="px-2 mb-3">
              <h2 class="rakuten-logo">Rakuten Travel</h2>
              <p class="section-description">
                일본 라쿠텐트래블과 제휴하여, 일본 전역의 호텔을 검색하고 예약할 수 있습니다.
                원하는 지역과 날짜를 입력하여 편리하게 호텔을 찾아보세요.
              </p>
            </div>
            <HotelSearchBar />
          </section>


          <!-- 엔데이트립 상품리스트 (상단연동중단: 20250311 / 네이버가격데이타 호환: 20250714) -->
          <section class="mt-5 w-100 L" id="saleitemSection">
            <div>
              <div class="justify-content-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="section-title">
                    <h2 class="section-title">일본에서 최고의 1일, 엔데이트립 현지투어</h2>
                    <p class="section-description">
                      현지전문 한국인가이드와 알차게, 전용버스로 편안하게, 각종 특전으로 여행을 더욱 실속있고 즐겁게
                    </p>
                  </div>
                  <div class="text-end">
                    <a href="/bustour" ><i class="bi bi-luggage-fill"></i> 전체상품보기</a>
                  </div>
                </div>
              </div>

              <div class="justify-content-center">
                <table class="w-100 text-center">
                  <tr>
                    <td class="col-6 saleitemTable" rowspan="2">
                      <div class="nday">
                        <div class="card product-detail">
                          <!-- 선택없은 초기화면 -->
                          <div v-if = "this.selFlag === 'N'">
                            <img v-if="this.selectedPdtInfo.imgName != 'noImage'" :src="`/download/${this.selectedPdtInfo.pdtCode}/${this.selectedPdtInfo.imgName}`" class="card-img-top rightPdtImage" alt="..."/>
                            <img v-else :src="`/download/noImage/noSelectedPDT.png`" class="card-img-top rightPdtImage" alt="no image"/>

                            <!-- 뱃지 -->
                            <div class="badge">
                              <div class="badge-wrapper">
                                <div v-if="selectedPdtInfo.badgeFlag == 'Y'" class="badge1">
                                  <span class="badge1-text" style="font-size: 1.5rem">{{ selectedPdtInfo.badge }}</span>
                                </div>
                                <div v-if="selectedPdtInfo.badge2Flag == 'Y'" class="badge2">
                                  <span class="badge2-text" style="font-size: 1.5rem">{{ selectedPdtInfo.badge2 }}</span>
                                </div>
                              </div>
                            </div>

                            <h5 class="nday-body">
                              <h5 class="nday-title">{{ this.selectedPdtInfo.arName }}</h5>
                              <p class="showPdtName">{{ this.selectedPdtInfo.pdtNameKor }}</p>
                            </h5>
                          </div>

                          <!-- 우측상품선택 후 -->
                          <div v-else-if="this.selFlag === 'Y'">
                            <img v-if="this.pImgName != 'noImage'" :src="`/download/${this.pCode}/${this.pImgName}`" class="card-img-top rightPdtImage" alt="..."/>
                            <img v-else :src="`/download/noImage/noSelectedPDT.png`" class="card-img-top rightPdtImage" alt="no image"/>

                            <!-- 뱃지표시 -->
                            <div class="badge">
                              <div class="badge-wrapper">
                                <div v-if="badgeF1 == 'Y'" class="badge1">
                                  <span class="badge1-text" style="font-size: 1.5rem">{{ badge1 }}</span>
                                </div>
                                <div v-if="badgeF2 == 'Y'" class="badge2">
                                  <span class="badge2-text" style="font-size: 1.5rem">{{ badge2 }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="nday-body">
                              <h5 class="nday-title">{{ pArName }}</h5>
                              <p class="showPdtName">{{ pName }}</p>
                            </div>
                          </div>

                          <div class="card-body">
                            <div class="nday-price">
                              <!-- 네이버가격/옵션호환 -->

                              <!-- 상품가격 표시 -->
                              <div class="my-1 d-flex align-items-center flex-wrap" v-if="selectedPdtInfo.basic_PdtPrice > 0 && selectedPdtInfo.displayFlag == 'Y' && selectedPdtInfo.saleFlag == 'Y'"  @click="goToDetail(selectedPdtInfo.pdtCode, selectedPdtInfo.salesRoute)" style="cursor: pointer;">
                                <!-- 가격이 할인 없음 -->
                                <b class="fs-4 fw-bolder ndayPrice" v-if="selectedPdtInfo.discountPercent == 0" >
                                  {{ getCurrencyFormat(selectedPdtInfo.pdtPrice) }} 원
                                </b>

                                <!-- 할인 있음 -->
                                <template v-else>
                                  <!-- 원래 가격 -->
                                  <b class="text-muted text-decoration-line-through mx-2 ndayPrice">
                                    {{ getCurrencyFormat(selectedPdtInfo.pdtPrice) }} 원
                                  </b>

                                  <!-- 아이콘 -->
                                  <i class="bi bi-caret-right-fill"></i>

                                  <!-- 할인율 -->
                                  <span class="mx-2 ndayPrice text-danger fs-5 fw-bolder" style="padding-left: 8px;"    >
                                    {{ getCurrencyFormat(selectedPdtInfo.discountPercent) }}%
                                  </span>

                                  <!-- 최종가격 -->
                                  <span class="ndayPrice fs-4 fw-bolder">
                                    {{ getCurrencyFormat((selectedPdtInfo.basic_PdtPrice*1) + (selectedPdtInfo.minOptPrice*1)) }}
                                  </span>
                                  <span class="fs-5"> 원~</span>
                                </template>
                              </div>

                              <!-- 준비중 -->
                              <div class="my-1 d-flex align-items-center" v-else>
                                <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                                <span class="ndayPrice fs-4 fw-bold mx-2">상품을 준비 중입니다</span>
                                <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(selectedPdtInfo.pdtCode, selectedPdtInfo.salesRoute)"></i>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td style="vertical-align: top; height: 480px; margin: 0px; padding-top: 0px;" class="col-6 saleitemTable-1">
                      <div class="saleList">
                        <div class="product-list">
                          <transition :name="animationDirection">
                            <div v-if="this.pagedProductList.mid.length > 0" key="product-list">
                              <div class="row" :key="i" v-for="(pdt, i) in this.pagedProductList.mid">
                                <div class="col-lg-3" style="padding-bottom: 5px">
                                  <img v-if="pdt.imgName != 'noImage'" :src="`/download/${pdt.pdtCode}/${pdt.imgName}`" class="img-fluid hover-zoom pdt-img" style="width: 195px; height: 120px; border-radius: 5%;" alt="..." @mouseover="setHoveredProduct(pdt.pdtCode, pdt.pdtNameKor, pdt.arName, pdt.imgName, pdt.badgeFlag, pdt.badge, pdt.badge2Flag, pdt.badge2)" />
                                  <img v-else :src="`/download/noImage/noImage.jpg`" class="img-fluid pdt-img" style="width: 195px; height: 120px; border-radius: 5%;" alt="no image"/>
                                </div>
                                <div class="c-content col-lg-9 text-start align-self-center" style="padding-top: 0px; padding-left: 10px; cursor: pointer" @click="goToDetail(pdt.pdtCode, pdt.salesRoute)">
                                  <div style="padding-top: 0px; margin-top: 0px">
                                    <h5 class="product-title" style="margin-top: 0; padding-top: 0px">{{ pdt.pdtNameKor }}</h5>
                                    <p class="product-description">{{ pdt.pdtRemarks }}</p>  
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <div>
                                <div class="col-lg-3"></div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 100px" class="col-6 saleitemTable-2">
                      <div class="pagination text-end">
                        <button @click="changePage('prev')" :disabled="currentPage === 1">
                          <i class="bi bi-arrow-left-square-fill"></i>
                        </button>
                        <span>{{ currentPage }} / {{ totalPages.mid }}</span>
                        <button @click="changePage('next')" :disabled="currentPage === totalPages.mid">
                          <i class="bi bi-arrow-right-square-fill"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </section>

          <!-- 지금 뜨는 여행 -->
          <!-- <section class="mt-5 w-100 nwItem G" id="nwItemSection">
            <div>
              <div class="justify-content-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="section-title">
                    <h2 class="section-title">지금 뜨는 여행</h2>
                    <p class="section-description">
                      트렌드를 담은 특별한 여행, 지금 만나보세요
                    </p>
                  </div>
                </div>
              </div>

              <div class="justify-content-center">
                <div class="container scrolling-wrapper" ref="scrollingContent_NW">
                  <button @click="scrollLeft_btn('NW')" class="scroll-btn left">
                    <b><i class="bi bi-chevron-left" style="color: white; font-weight: 900; font-size: 2rem"></i></b>
                  </button>
                  <div class="row gx-2 mt-3 scrolling-content">
                    <div class="col-12 col-md-6 col-lg-4 my-2 nwItems" :key="i" v-for="(product, i) in this.new_productListForSales_now">
                      <a class="card">
                        <img v-if="product.imgName != 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="card-img-top gfPdtImage" alt="..." @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer"/>
                        <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top gfPdtImage"/>

                        <div class="badge">
                          <div class="badge-wrapper">
                            <div v-if="product.badgeFlag === 'Y'" class="badge1">
                              <small class="badge1-text" style="font-size: 0.8rem">{{ product.badge }}</small>
                            </div>
                            <div v-if="product.badge2Flag === 'Y'" class="badge2">
                              <small class="badge2-text" style="font-size: 0.8rem">{{ product.badge2 }}</small>
                            </div>
                          </div>
                        </div>
                        
                        <div class="card-body">
                          <h5 class="card-title">
                            <div class="b-height" v-if="product.cityName != undefined" @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer">
                              <div class="pdtName">
                                {{ product.pdtNameKor }}
                              </div>
                              <div class="pdtRemarks">
                                {{ product.pdtRemarks }}
                              </div>
                            </div>
                            <div class="b-height" v-else @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer">
                              <div>
                                {{ product.pdtNameKor }}
                              </div>
                              <div>
                                {{ product.pdtRemarks }}
                              </div>
                            </div>

                            <div class="mt-3 priceSection">


                              <div class="my-1 d-flex align-items-center flex-wrap" v-if="product.basic_PdtPrice > 0 && product.displayFlag == 'Y' && product.saleFlag == 'Y'"  @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer;">
                                <b class="fs-4 fw-bolder ndayPrice" v-if="product.discountPercent == 0" >
                                  {{ getCurrencyFormat(product.pdtPrice) }} 원
                                </b>

                                <template v-else>
                                  <b class="text-muted text-decoration-line-through mx-2 ndayPrice">
                                    {{ getCurrencyFormat(product.pdtPrice) }} 원
                                  </b>

                                  <i class="bi bi-caret-right-fill" style="color: rgba(255,255,255,0.75);"></i>

                                  <span class="mx-2 ndayPrice text-danger fs-5 fw-bolder" style="padding-left: 8px;"    >
                                    {{ getCurrencyFormat(product.discountPercent) }}%
                                  </span>

                                  <span class="ndayPrice fs-4 fw-bolder">
                                    {{ getCurrencyFormat((product.basic_PdtPrice*1) + (product.minOptPrice*1)) }}
                                  </span>
                                  <span class="fs-5"> 원~</span>
                                </template>
                              </div>

                              <div class="my-1 d-flex align-items-center" v-else>
                                <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                                <span class="ndayPrice fs-4 fw-bold mx-2">상품을 준비 중입니다</span>
                                <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(product.pdtCode, product.salesRoute)"></i>
                              </div>

                            </div>
                          </h5>
                        </div>
                      </a>
                    </div>
                  </div>

                  <button @click="scrollRight_btn('NW')" class="scroll-btn right">
                    <b><i class="bi bi-chevron-right" style="color: white; font-weight: 900; font-size: 2rem" ></i></b>
                  </button>
                </div>
              </div>
            </div>
          </section> -->

          <!-- *********************************** 
          ** 엔타비 인스타그램 컨텐츠 (2026-10-13) **
          **************************************** -->
          <section class="mt-5 w-100 igItem" id="igItemSection" v-if="instaPosts.length > 0">
            <div>
              <div class="justify-content-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="section-title">
                    <h2 class="section-title">인스타그램으로 만나는 엔타비</h2>
                    <p class="section-description">
                      현지에서 직접 전하는 생생한 여행 이야기, 엔타비 인스타그램에서 먼저 만나보세요
                    </p>
                  </div>
                  <div class="text-end">
                    <a :href=instaProfileUrl target="_blank" rel="noopener">
                      <i class="bi bi-instagram"></i> 인스타그램 바로가기
                    </a>
                  </div>
                </div>
              </div>

              <div class="justify-content-center">
                <div class="container scrolling-wrapper" ref="scrollingContent_IG">
                  <!-- 3개 초과일 때만 스크롤버튼 노출 -->
                  <button v-if="instaPosts.length > 3" @click="scrollLeft_btn('IG')" class="scroll-btn left">
                    <b><i class="bi bi-chevron-left" style="color: white; font-weight: 900; font-size: 2rem"></i></b>
                  </button>

                  <div class="row gx-2 mt-3 scrolling-content">
                    <div class="col-12 col-md-6 col-lg-4 my-2 igItems" v-for="post in instaPosts" :key="post.id">
                      <div class="ig-card">
                        <!-- 높이 고정 프레임 (넘치는 하단은 잘림) -->
                        <div class="ig-frame">
                          <blockquote
                            class="instagram-media"
                            :data-instgrm-permalink="`${post.url}?utm_source=ig_embed&utm_campaign=loading`"
                            data-instgrm-version="14"
                          >
                            <a :href="post.url" target="_blank" rel="noopener" class="ig-fallback">
                              <i class="bi bi-instagram"></i> Instagram에서 게시물 보기
                            </a>
                          </blockquote>
                        </div>
                        <!-- 하단 페이드 + 전체보기 버튼 -->
                        <a :href="post.url" target="_blank" rel="noopener" class="ig-more-overlay">
                          <span><i class="bi bi-instagram"></i> Instagram에서 전체 보기</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <button v-if="instaPosts.length > 3" @click="scrollRight_btn('IG')" class="scroll-btn right">
                    <b><i class="bi bi-chevron-right" style="color: white; font-weight: 900; font-size: 2rem"></i></b>
                  </button>
                </div>
              </div>
            </div>
          </section>


          <!-- NEW엔타비+버라이어티팩 상품리스트 -->
          <section class="mt-5 w-100 vrItem T" id="vrItemSection">
            <div>
              <div class="justify-content-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="section-title">
                    <h2 class="section-title">엔타비 단독기획! 버라이티한 패키지 여행상품</h2>
                    <p class="section-description">
                      시즌별, 기간별 한정! 엔타비가 단독기획한 이벤트 테마여행
                    </p>
                  </div>
                  <div class="text-end">
                    <a href="/exhibitionEvent" ><i class="bi bi-luggage-fill"></i> 전체상품보기</a>
                  </div>
                </div>
              </div>

              <div class="justify-content-center">
                <div class="container scrolling-wrapper" ref="scrollingContent_VR">
                  <button @click="scrollLeft_btn('VR')" class="scroll-btn left">
                    <b><i class="bi bi-chevron-left" style="color: white; font-weight: 900; font-size: 2rem"></i></b>
                  </button>
                  <div class="row gx-2 mt-3 scrolling-content">
                    <div class="col-12 col-md-6 col-lg-4 my-2 vrItems" :key="i" v-for="(product, i) in this.new_productListForSales_ntabi">
                      <a class="card">
                        <img v-if="product.imgName != 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="card-img-top vrPdtImage" alt="..." />
                        <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top vrPdtImage" />

                        <!-- 뱃지표시 -->
                        <div class="badge">
                          <div class="badge-wrapper">
                            <div v-if="product.badgeFlag === 'Y'" class="badge1">
                              <small class="badge1-text" style="font-size: 0.8rem">{{ product.badge }}</small>
                            </div>
                            <div v-if="product.badge2Flag === 'Y'" class="badge2">
                              <small class="badge2-text" style="font-size: 0.8rem">{{ product.badge2 }}</small>
                            </div>
                          </div>
                        </div>

                        <!-- 카드 제목 -->
                        <div class="card-body">
                          <h5 class="card-title">
                            <div class="b-height" v-if="product.cityName != undefined" @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer">
                              <div class="pdtName">
                                {{ product.pdtNameKor }}
                              </div>
                              <div class="pdtRemarks">
                                {{ product.pdtRemarks }}
                              </div>
                            </div>
                            <div class="b-height" v-else @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer">
                              <div>
                                {{ product.pdtNameKor }}
                              </div>
                              <div>
                                {{ product.pdtRemarks }}
                              </div>
                            </div>

                            <div class="mt-3 priceSection">
                              <!-- 네이버가격/옵션호환 -->


                              <!-- 상품가격 표시 -->
                              <div class="my-1 d-flex align-items-center flex-wrap" v-if="product.basic_PdtPrice > 0 && product.displayFlag == 'Y' && product.saleFlag == 'Y'"  @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer;">
                                <!-- 가격이 할인 없음 -->
                                <b class="fs-4 fw-bolder ndayPrice" v-if="product.discountPercent == 0" >
                                  {{ getCurrencyFormat(product.pdtPrice) }} 원
                                </b>

                                <!-- 할인 있음 -->
                                <template v-else>
                                  <!-- 원래 가격 -->
                                  <b class="text-muted text-decoration-line-through mx-2 ndayPrice">
                                    {{ getCurrencyFormat(product.pdtPrice) }} 원
                                  </b>

                                  <!-- 아이콘 -->
                                  <i class="bi bi-caret-right-fill" style="color: rgba(255,255,255,0.75);"></i>

                                  <!-- 할인율 -->
                                  <span class="mx-2 ndayPrice text-danger fs-5 fw-bolder" style="padding-left: 8px;"    >
                                    {{ getCurrencyFormat(product.discountPercent) }}%
                                  </span>

                                  <!-- 최종가격 -->
                                  <span class="ndayPrice fs-4 fw-bolder">
                                    {{ getCurrencyFormat((product.basic_PdtPrice*1) + (product.minOptPrice*1)) }}
                                  </span>
                                  <span class="fs-5"> 원~</span>
                                </template>
                              </div>

                              <!-- 준비중 -->
                              <div class="my-1 d-flex align-items-center" v-else>
                                <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                                <span class="ndayPrice fs-4 fw-bold mx-2">상품을 준비 중입니다</span>
                                <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(product.pdtCode, product.salesRoute)"></i>

                              </div>
                            </div>
                          </h5>
                        </div>
                      </a>
                    </div>
                  </div>

                  <button @click="scrollRight_btn('VR')" class="scroll-btn right">
                    <b><i class="bi bi-chevron-right" style="color: white; font-weight: 900; font-size: 2rem" ></i></b>
                  </button>
                </div>
              </div>
            </div>
          </section>


          <!-- NEW일본선박 상품리스트 -->
          <section class="mt-5 w-100 shItem F" id="shItemSection">
            <div>
              <div class="justify-content-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="section-title">
                    <h2 class="section-title">부산출발 선박특가 모음</h2>
                    <p class="section-description">
                      시모노세키 부관훼리 왕복, 후쿠오카 뉴카멜리아 왕복, 엔타비에서 가장 저렴하게!
                    </p>
                  </div>
                  <div class="text-end">
                    <a href="/shipTour" ><i class="bi bi-luggage-fill"></i> 전체상품보기</a>
                  </div>
                </div>
              </div>

              <div class="justify-content-center">
                <div class="container scrolling-wrapper" ref="scrollingContent_SH">
                  <button @click="scrollLeft_btn('SH')" class="scroll-btn left">
                    <b><i class="bi bi-chevron-left" style="color: white; font-weight: 900; font-size: 2rem"></i></b>
                  </button>
                  <div class="row gx-2 mt-3 scrolling-content">
                    <div class="col-12 col-md-6 col-lg-4 my-2 shItems" :key="i" v-for="(product, i) in this.new_productListForSales_ship">
                      <a class="card">
                        <img v-if="product.imgName != 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="card-img-top shPdtImage" alt="..."/>
                        <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top shPdtImage" />
                        <!-- 뱃지표시 -->
                        <div class="badge">
                          <div class="badge-wrapper">
                            <div v-if="product.badgeFlag === 'Y'" class="badge1">
                              <small class="badge1-text" style="font-size: 0.8rem">{{ product.badge }}</small>
                            </div>
                            <div v-if="product.badge2Flag === 'Y'" class="badge2">
                              <small class="badge2-text" style="font-size: 0.8rem">{{ product.badge2 }}</small>
                            </div>
                          </div>
                        </div>

                        <!-- 카드 제목 -->
                        <div class="card-body">
                          <h5 class="card-title">
                            <div class="b-height" v-if="product.cityName != undefined" @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer">
                              <div class="pdtName">
                                {{ product.pdtNameKor }}
                              </div>
                              <div class="pdtRemarks">
                                {{ product.pdtRemarks }}
                              </div>
                            </div>
                            <div class="b-height" v-else @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer">
                              <div>
                                {{ product.pdtNameKor }}
                              </div>
                              <div>
                                {{ product.pdtRemarks }}
                              </div>
                            </div>

                            <div class="mt-3 priceSection">
                              <!-- 네이버가격/옵션호환 -->

                              <!-- 상품가격 표시 -->
                              <div class="my-1 d-flex align-items-center flex-wrap" v-if="product.basic_PdtPrice > 0 && product.displayFlag == 'Y' && product.saleFlag == 'Y'"  @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer;">
                                <!-- 가격이 할인 없음 -->
                                <b class="fs-4 fw-bolder ndayPrice" v-if="product.discountPercent == 0" >
                                  {{ getCurrencyFormat(product.pdtPrice) }} 원
                                </b>

                                <!-- 할인 있음 -->
                                <template v-else>
                                  <!-- 원래 가격 -->
                                  <b class="text-muted text-decoration-line-through mx-2 ndayPrice">
                                    {{ getCurrencyFormat(product.pdtPrice) }} 원
                                  </b>

                                  <!-- 아이콘 -->
                                  <i class="bi bi-caret-right-fill" style="color: rgba(255,255,255,0.75);"></i>

                                  <!-- 할인율 -->
                                  <span class="mx-2 ndayPrice text-danger fs-5 fw-bolder" style="padding-left: 8px;"    >
                                    {{ getCurrencyFormat(product.discountPercent) }}%
                                  </span>

                                  <!-- 최종가격 -->
                                  <span class="ndayPrice fs-4 fw-bolder">
                                    {{ getCurrencyFormat((product.basic_PdtPrice*1) + (product.minOptPrice*1)) }}
                                  </span>
                                  <span class="fs-5"> 원~</span>
                                </template>
                              </div>

                              <!-- 준비중 -->
                              <div class="my-1 d-flex align-items-center" v-else>
                                <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                                <span class="ndayPrice fs-4 fw-bold mx-2">상품을 준비 중입니다</span>
                                <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(product.pdtCode, product.salesRoute)"></i>
                              </div>
                            </div>
                          </h5>
                        </div>
                      </a>
                    </div>
                  </div>

                  <button @click="scrollRight_btn('SH')" class="scroll-btn right">
                    <b><i class="bi bi-chevron-right" style="color: white; font-weight: 900; font-size: 2rem" ></i></b>
                  </button>
                </div>
              </div>
            </div>
          </section>


          <!-- NEW 골프상품리스트 -->
          <section class="mt-5 w-100 gfItem G" id="gfItemSection">
            <div>
              <div class="justify-content-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="section-title">
                    <h2 class="section-title">일본골프여행</h2>
                    <p class="section-description">
                      맞춤 패키지부터 프리미엄까지!
                    </p>
                  </div>
                  <div class="text-end">
                    <a href="/golfTour" ><i class="bi bi-luggage-fill"></i> 전체상품보기</a>
                  </div>
                </div>
              </div>

              <div class="justify-content-center">
                <div class="container scrolling-wrapper" ref="scrollingContent_GF">
                  <button @click="scrollLeft_btn('GF')" class="scroll-btn left">
                    <b><i class="bi bi-chevron-left" style="color: white; font-weight: 900; font-size: 2rem"></i></b>
                  </button>
                  <div class="row gx-2 mt-3 scrolling-content">
                    <div class="col-12 col-md-6 col-lg-4 my-2 gfItems" :key="i" v-for="(product, i) in this.new_productListForSales_golf">
                      <a class="card">
                        <img v-if="product.imgName != 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="card-img-top gfPdtImage" alt="..." @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer"/>
                        <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top gfPdtImage"/>

                        <!-- 뱃지표시 -->
                        <div class="badge">
                          <div class="badge-wrapper">
                            <div v-if="product.badgeFlag === 'Y'" class="badge1">
                              <small class="badge1-text" style="font-size: 0.8rem">{{ product.badge }}</small>
                            </div>
                            <div v-if="product.badge2Flag === 'Y'" class="badge2">
                              <small class="badge2-text" style="font-size: 0.8rem">{{ product.badge2 }}</small>
                            </div>
                          </div>
                        </div>
                        
                        <!-- 카드 제목 -->
                        <div class="card-body">
                          <h5 class="card-title">
                            <div class="b-height" v-if="product.cityName != undefined" @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer">
                              <div class="pdtName">
                                {{ product.pdtNameKor }}
                              </div>
                              <div class="pdtRemarks">
                                {{ product.pdtRemarks }}
                              </div>
                            </div>
                            <div class="b-height" v-else @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer">
                              <div>
                                {{ product.pdtNameKor }}
                              </div>
                              <div>
                                {{ product.pdtRemarks }}
                              </div>
                              <!-- {{ product.pdtNameKor }} -->
                            </div>

                            <div class="mt-3 priceSection">


                              <!-- 네이버가격/옵션호환 -->
                              <!-- 상품가격 표시 -->
                              <div class="my-1 d-flex align-items-center flex-wrap" v-if="product.basic_PdtPrice > 0 && product.displayFlag == 'Y' && product.saleFlag == 'Y'"  @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer;">
                                <!-- 가격이 할인 없음 -->
                                <b class="fs-4 fw-bolder ndayPrice" v-if="product.discountPercent == 0" >
                                  {{ getCurrencyFormat(product.pdtPrice) }} 원
                                </b>

                                <!-- 할인 있음 -->
                                <template v-else>
                                  <!-- 원래 가격 -->
                                  <b class="text-muted text-decoration-line-through mx-2 ndayPrice">
                                    {{ getCurrencyFormat(product.pdtPrice) }} 원
                                  </b>

                                  <!-- 아이콘 -->
                                  <i class="bi bi-caret-right-fill" style="color: rgba(255,255,255,0.75);"></i>

                                  <!-- 할인율 -->
                                  <span class="mx-2 ndayPrice text-danger fs-5 fw-bolder" style="padding-left: 8px;"    >
                                    {{ getCurrencyFormat(product.discountPercent) }}%
                                  </span>

                                  <!-- 최종가격 -->
                                  <span class="ndayPrice fs-4 fw-bolder">
                                    {{ getCurrencyFormat((product.basic_PdtPrice*1) + (product.minOptPrice*1)) }}
                                  </span>
                                  <span class="fs-5"> 원~</span>
                                </template>
                              </div>

                              <!-- 준비중 -->
                              <div class="my-1 d-flex align-items-center" v-else>
                                <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                                <span class="ndayPrice fs-4 fw-bold mx-2">상품을 준비 중입니다</span>
                                <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(product.pdtCode, product.salesRoute)"></i>
                              </div>

                            </div>
                          </h5>
                        </div>
                      </a>
                    </div>
                  </div>

                  <button @click="scrollRight_btn('GF')" class="scroll-btn right">
                    <b><i class="bi bi-chevron-right" style="color: white; font-weight: 900; font-size: 2rem" ></i></b>
                  </button>
                </div>
              </div>
            </div>
          </section>


          <!-- Video Banner Section (PC) -->
          <section class="video-section w-100" v-if="!mobileDisplay">
            <div id="videoCarousel" class="carousel slide" data-bs-ride="false">
              
              <!-- 인디케이터 -->
              <div class="carousel-indicators">
                <button v-for="(v, i) in videos" :key="i" type="button" data-bs-target="#videoCarousel" :data-bs-slide-to="i" :class="{ active: i === 0 }">
                </button>
              </div>

              <!-- 영상 슬라이드 -->
              <div class="carousel-inner">
                <div v-for="(v, i) in videos" :key="i" class="carousel-item" :class="{ active: i === 0 }">
                  <video class="video-carousel-item" muted playsinline :ref="`videoRef_${i}`" @ended="onVideoEnded">
                    <source :src="v.src" type="video/mp4" />
                  </video>
                </div>
              </div>

              <!-- 이전/다음 버튼 -->
              <button class="carousel-control-prev" type="button" data-bs-target="#videoCarousel" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#videoCarousel" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
              </button>
            </div>
          </section>


          <!-- New그룹핑상품판매 -->
          <section id="groupProducts" class="w-100 mt-3" style="background-color: rgba(179, 218, 238, 0.095)">
            <div class="image-rotator">
              <transition-group name="blur-transition" tag="div" class="image-container">
                <img v-for="(image, index) in grSlides" :key="index" :src="image.image" :class="['group-image', { active: activeIndex === index }]" @mouseover="handleMouseOver(index)" @mouseleave="handleMouseLeave"/>
              </transition-group>
            </div>

            <div class="progress-indicator mt-0">
              <div v-for="(_, index) in grSlides" :key="index" :class="['progress-dot', { active: activeIndex === index }]"></div>
            </div>
          </section>

          <section id="grProductList" class="w-100 mt-4 grProductList mb-5" style="background-color: rgba(179, 218, 238, 0.095); height:480px">

            <!-- group1 -->
            <div class="row grProductLsitContainer" v-if="this.currentIndex === 0">
              <div class="grProductCard col-3" :key="i" v-for="(gr1, i) in this.productListForSales_gr">
                <div class="card" style="height: 450px;">
                  <img v-if="gr1.imgName != 'noImage'" :src="`/download/${gr1.pdtCode}/${gr1.imgName}`" class="card-img-top" alt="..." style="height:200px; cursor:pointer;" @click="goToDetail(gr1.pdtCode, gr1.salesRoute)"/>
                  <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top" @click="goToDetail(gr1.pdtCode, gr1.salesRoute)"/>
                  
                  <!-- 카드제목+내용 -->
                  <div class="card-body mt-1 grCardBody" style="height: 250px;">
                    <div class="text-decoration-none">
                      <h5 class="card-title">
                        <!-- <div v-if="gr1.cityName != undefined">
                          <span class="align-top grProductTitle">{{ gr1.pdtNameKor }}</span>
                        </div> -->
                        <div>
                          <span class="align-top grProductTitle">{{ gr1.pdtNameKor }}</span>
                        </div>
                      </h5>
                      <div class="card-text">
                        <span class="grProductRemarks">{{ gr1.pdtRemarks }}</span>
                      </div>
                    </div>

                    <!-- 상품카드 금액 -->
                    <div class="card-price">
                      <!-- 네이버 데이타호환 표시 -->
                      <div>
                        <div class="my-1">                          
                            <div class="mt-3 priceSection">
                              <!-- 네이버가격/옵션호환 -->
                              <div>
                                
                                <!-- 상품가격표시 -->
                                <div class="my-1" v-if="gr1.basic_PdtPrice > 0 && gr1.displayFlag == 'Y' && gr1.saleFlag == 'Y'">
                                  <b class="mx-2 ndayPrice fs-4 fw-bold" v-if="gr1.discountPercent == 0"> {{ getCurrencyFormat(gr1.pdtPrice) }}</b>
                                  <b class="text-muted text-decoration-line-through mx-2 ndayPrice" v-else> {{ getCurrencyFormat(gr1.pdtPrice) }}</b>

                                  <i class="bi bi-caret-right-fill" v-if="gr1.discountPercent != 0"></i>
                                  <span class="mx-2 ndayPrice text-danger fs-6 fw-bolder" style="padding-left: 4px;" v-if="gr1.discountPercent != 0"> {{ getCurrencyFormat(gr1.discountPercent) }}%</span>
                                  <span class="ndayPrice fs-5 fw-bolder" v-if="gr1.discountPercent != 0">{{ getCurrencyFormat((gr1.basic_PdtPrice*1) + (gr1.minOptPrice*1)) }}</span>
                                  <!-- <span class="fs-6" v-if="gr1.discountPercent != 0"> 원~</span> -->
                                  <span class="fs-6">원~</span>
                                </div>
                                <div class="my-1" style="display:flex;" v-else>
                                  <span class="ndayPrice fs-5 fw-bold">상품을 준비 중입니다</span> 
                                  <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(gr1.pdtCode, gr1.salesRoute)"></i>
                                </div>

                              </div>

                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- group2 -->
            <div class="row grProductLsitContainer" v-if="this.currentIndex === 1">
              <div class="grProductCard col-3" :key="j" v-for="(gr2, j) in this.productListForSales_gr2">
                <div class="card" style="height: 450px;">
                  <img v-if="gr2.imgName != 'noImage'" :src="`/download/${gr2.pdtCode}/${gr2.imgName}`" class="card-img-top" alt="..." style="height:200px; cursor:pointer;" @click="goToDetail(gr2.pdtCode, gr2.salesRoute)"/>
                  <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top" @click="goToDetail(gr2.pdtCode, gr2.salesRoute)"/>
                  
                  <!-- 카드제목+내용 -->
                  <div class="card-body mt-1 grCardBody" style="height: 250px;">
                    <div class="text-decoration-none">
                      <h5 class="card-title">
                        <!-- <div v-if="gr2.cityName != undefined">
                          <span class="align-top grProductTitle">{{ gr2.pdtNameKor }}</span>
                        </div> -->
                        <div>
                          <span class="align-top grProductTitle">{{ gr2.pdtNameKor }}</span>
                        </div>
                      </h5>
                      <div class="card-text">
                        <span class="grProductRemarks">{{ gr2.pdtRemarks }}</span>
                      </div>
                    </div>

                    <!-- 상품카드 금액 -->
                    <div class="card-price">
                      <!-- 네이버 데이타호환 표시 -->
                      <div>
                        <div class="my-1">                          
                          <div class="mt-3 priceSection">
                            <!-- 네이버가격/옵션호환 -->
                            <div>

                                <!-- 상품가격표시 -->
                                <div class="my-1" v-if="gr2.basic_PdtPrice > 0 && gr2.displayFlag == 'Y' && gr2.saleFlag == 'Y'">
                                  <b class="mx-2 ndayPrice fs-4 fw-bold" v-if="gr2.discountPercent == 0"> {{ getCurrencyFormat(gr2.pdtPrice) }}</b>
                                  <b class="text-muted text-decoration-line-through mx-2 ndayPrice" v-else> {{ getCurrencyFormat(gr2.pdtPrice) }}</b>

                                  <i class="bi bi-caret-right-fill" v-if="gr2.discountPercent != 0"></i>
                                  <span class="mx-2 ndayPrice text-danger fs-6 fw-bolder" style="padding-left: 4px;" v-if="gr2.discountPercent != 0"> {{ getCurrencyFormat(gr2.discountPercent) }}%</span>
                                  <span class="ndayPrice fs-5 fw-bolder" v-if="gr2.discountPercent != 0">{{ getCurrencyFormat((gr2.basic_PdtPrice*1) + (gr2.minOptPrice*1)) }}</span>
                                  <span class="fs-6">원~</span>
                                </div>
                                <div class="my-1" style="display:flex;" v-else>
                                  <span class="ndayPrice fs-5 fw-bold">상품을 준비 중입니다</span> 
                                  <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(gr2.pdtCode, gr2.salesRoute)"></i>
                                </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- group3 -->
            <div class="row grProductLsitContainer" v-if="this.currentIndex === 2">
              <div class="grProductCard col-3" :key="k" v-for="(gr3, k) in this.productListForSales_gr3">
                <div class="card" style="height: 450px;">
                  <img v-if="gr3.imgName != 'noImage'" :src="`/download/${gr3.pdtCode}/${gr3.imgName}`" class="card-img-top" alt="..." style="height:200px; cursor:pointer;" @click="goToDetail(gr3.pdtCode, gr3.salesRoute)"/>
                  <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top" @click="goToDetail(gr3.pdtCode, gr3.salesRoute)"/>
                  
                  <!-- 카드제목+내용 -->
                  <div class="card-body mt-1 grCardBody" style="height: 250px;">
                    <div class="text-decoration-none">
                      <h5 class="card-title">
                        <!-- <div v-if="gr3.cityName != undefined">
                          <span class="align-top grProductTitle">{{ gr3.pdtNameKor }}</span>
                        </div> -->
                        <div>
                          <span class="align-top grProductTitle">{{ gr3.pdtNameKor }}</span>
                        </div>
                      </h5>
                      <div class="card-text">
                        <span class="grProductRemarks">{{ gr3.pdtRemarks }}</span>
                      </div>
                    </div>

                    <!-- 상품카드 금액 -->
                    <div class="card-price">
                      <!-- 네이버 데이타호환 표시 -->
                      <div>
                        <div class="my-1">                          
                            <div class="mt-3 priceSection">
                              <!-- 네이버가격/옵션호환 -->
                              <div>
                              
                              <div>
                                <!-- 상품가격표시 -->
                                <div class="my-1" v-if="gr3.basic_PdtPrice > 0 && gr3.displayFlag == 'Y' && gr3.saleFlag == 'Y'">
                                  <b class="mx-2 ndayPrice fs-5 fw-bold" v-if="gr3.discountPercent == 0"> {{ getCurrencyFormat(gr3.pdtPrice) }}</b>
                                  <b class="text-muted text-decoration-line-through mx-2 ndayPrice" v-else> {{ getCurrencyFormat(gr3.pdtPrice) }}</b>

                                  <i class="bi bi-caret-right-fill" v-if="gr3.discountPercent != 0"></i>
                                  <span class="mx-2 ndayPrice text-danger fs-6 fw-bolder" style="padding-left: 4px;" v-if="gr3.discountPercent != 0"> {{ getCurrencyFormat(gr3.discountPercent) }}%</span>
                                  <span class="ndayPrice fs-5 fw-bolder" v-if="gr3.discountPercent != 0">{{ getCurrencyFormat((gr3.basic_PdtPrice*1) + (gr3.minOptPrice*1)) }}</span>
                                  <span class="fs-6">원~</span>
                                </div>
                                <div class="my-1" style="display:flex;" v-else>
                                  <span class="ndayPrice fs-5 fw-bold">상품을 준비 중입니다</span> 
                                  <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(gr3.pdtCode, gr3.salesRoute)"></i>
                                </div>
                              </div>


                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>

          </section>
          <!-- </section> -->


          <!-- 여행자보험 & 와이파이 배너 -->
          <section id="midBanner" class="midBanner w-100 mt-5" style="padding-top: 50px; padding-bottom: 50px">
            <div class="mid-banner1">
              <a href="https://travelmedic.co.kr/mypage/event_view.php?idx=44" target="_blank">
                <img src="../assets/img/main/banner4.jpg" class="img-fluid" />
              </a>
            </div>
            <div class="mid-banner2">
              <a href="https://ap.wifidosirak.com/ApIntro.aspx?ntabi" target="_blank">
                <img src="../assets/img/main/banner5.jpg" class="img-fluid" />
              </a>
            </div>
          </section>

          <!-- ======= New베스트아이템 ======= -->
          <section id="best-item" class="bestitem w-100 mt-5">
            <div class="section-title">
              <p>
                <b class="text-danger" style="font-family: Impact Black, Verdana, Geneva, Tahoma,sans-serif;font-size: 2.5rem; letter-spacing: 0.2rem;">
                  <i>BEST <span class="text-primary">SELLER</span></i>
                </b>
              </p>
            </div>
            <div class="container scrolling-wrapper" ref="scrollingContent_best">
              <button @click="scrollLeft_btn('BE')" class="scroll-btn left">
                <b><i class="bi bi-chevron-left" style="color: white; font-weight: 900; font-size: 2rem"></i></b>
              </button>

              <div class="row gx-2 mt-3 scrolling-content">
                <div class="col-12 col-md-6 col-lg-4 my-2 bestItems" :key="i" v-for="(product, i) in this.new_productListForSales_best">
                  <div class="card">
                    <img v-if="product.imgName != 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="card-img-top bestPdtImage" alt="..." @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer" />
                    <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top bestPdtImage" @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer"/>

                    <!-- 뱃지표시 -->
                    <div class="badge">
                      <div class="badge-wrapper">
                        <div v-if="product.badgeFlag === 'Y'" class="badge1">
                          <small class="badge1-text" style="font-size: 0.8rem">{{ product.badge }}</small>
                        </div>
                        <div v-if="product.badge2Flag === 'Y'" class="badge2">
                          <small class="badge2-text" style="font-size: 0.8rem">{{ product.badge2 }}</small>
                        </div>
                      </div>
                    </div>
                    
                    <!-- 카드제목+내용 -->
                    <div class="card-body">
                      <h5 class="card-title">
                        <div class="b-height">
                          <div class="pdtName">
                            {{ product.pdtNameKor }}
                          </div>
                          <div class="pdtRemarks">
                            {{ product.pdtRemarks }}
                          </div>
                        </div>
                        <div class="mt-3 priceSection">
                          <!-- 네이버가격/옵션호환 -->
                          <div>

                            <!-- 상품가격 표시 -->
                            <div class="my-1 d-flex align-items-center flex-wrap" v-if="product.basic_PdtPrice > 0 && product.displayFlag == 'Y' && product.saleFlag == 'Y'"  @click="goToDetail(product.pdtCode, product.salesRoute)" style="cursor: pointer;">
                              <!-- 가격이 할인 없음 -->
                              <b class="fs-4 fw-bolder ndayPrice" v-if="product.discountPercent == 0" >
                                {{ getCurrencyFormat(product.pdtPrice) }} 원
                              </b>

                              <!-- 할인 있음 -->
                              <template v-else>
                                <!-- 원래 가격 -->
                                <b class="text-decoration-line-through mx-2 ndayPrice" style="color: lightgray;">
                                  {{ getCurrencyFormat(product.pdtPrice) }} 원
                                </b>

                                <!-- 아이콘 -->
                                <i class="bi bi-caret-right-fill"></i>

                                <!-- 할인율 -->
                                <span class="mx-2 ndayPrice fs-5 fw-bolder" style="padding-left: 8px; color: tomato;">
                                  {{ getCurrencyFormat(product.discountPercent) }}%
                                </span>

                                <!-- 최종가격 -->
                                <span class="ndayPrice fs-4 fw-bolder" style="color: gold;">
                                  {{ getCurrencyFormat((product.basic_PdtPrice*1) + (product.minOptPrice*1)) }}
                                </span>
                                <span class="fs-5">&nbsp;원~</span>
                              </template>
                          </div>

                          <!-- 준비중 -->
                          <div class="my-1 d-flex align-items-center" v-else>
                            <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                              <span class="ndayPrice fs-4 fw-bold mx-2">상품을 준비 중입니다</span>
                              <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(product.pdtCode, product.salesRoute)"></i>
                            </div>

                            
                          </div>
                        </div>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>

              <button @click="scrollRight_btn('BE')" class="scroll-btn right">
                <b><i class="bi bi-chevron-right" style="color: white; font-weight: 900; font-size: 2rem" ></i></b>
              </button>
            </div>
          </section>

          <!-- Live Section -->
          <section id="liveSection" class="live-section w-100 mt-5">
            <h3 class="text-start">
              <img src="../assets/img/main/live_logo.png" style="width: 12%" />
            </h3>
            <div class="section-title">
              <div class="mt-0 mb-0" style="font-size: 1.2rem; font-weight: 600; margin-top: 20px">
                <span>
                  실제 엔데이트립 일본 현지 직원 가이드가 전하는 생생한 현장 라이브!
                  <br>
                  파격적인 <span class="text-danger">할인 혜택</span>도 놓치지 마세요!
                </span>
              </div>
              <div id="more">
                <a href="https://smartstore.naver.com/ntabi/lives?cp=1" target="_blank" ><i class="bi bi-broadcast"></i> 전체보기</a>
              </div>
            </div>
            <div class="row">
              <div class="iframe-container">
                <iframe src="https://smartstore.naver.com/ntabi/lives?cp=1" frameborder="0" scrolling="no" ></iframe>
              </div>
            </div>
          </section>


          <!-- 이벤트/홍보/공지사항 -->
          <section id="notice" class="notice w-100 mt-5 mb-5">
            <div class="row">
              <div class="section-title">
                <a href="/customerNotice">
                  <h3 class="text-start text-touch" style="font-weight: 800; cursor: pointer; color: #333;" @touchstart="handleTouchStart" @touchend="handleTouchEnd" :class="{ touchable: isTouched }">
                    이벤트 <i class="bi bi-dot"></i> 홍보 & 공지사항
                  </h3>
                </a>
                <div id="more"><a href="/customerNotice"><i class="bi bi-box-arrow-up-right"></i> 더보기</a></div>
              </div>
            </div>

            <div class="justify-content-center mt-5">
              <table class="w-100 text-center noticeTable">
                <tr>
                  <td style="background-color: transparent; width: 600px; height: 600px;" rowspan="2" v-if="this.ingEvent.length > 0">
                    <div id="carouselvarietyControls" class="carousel slide notice-new" data-bs-ride="carousel" data-bs-interval="3000" data-bs-touch="true">
                      <div class="carousel-inner">
                        <div :class="`carousel-item ${i == '0' ? 'active' : ''}`" :key="i" v-for="(ev, i) in this.ingEvent">
                          <div class="img-container">
                            <div v-if="ev.ctCd === 'NT'">
                              <img :src="`/download/notice/NT/${ev.noticeCode}.jpg`" class="card-img-top leftImg" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                            </div>
                            <div v-else-if="ev.ctCd === 'EV'">
                              <img :src="`/download/notice/EV/${ev.noticeCode}.jpg`" class="card-img-top leftImg" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                            </div>
                            <div v-else-if="ev.ctCd === 'TR'">
                              <img :src="`/download/notice/TR/${ev.noticeCode}.jpg`" class="card-img-top leftImg" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                            </div>
                            <div v-else-if="ev.ctCd === 'MO'">
                              <img :src="`/download/notice/MO/${ev.noticeCode}.jpg`" class="card-img-top leftImg" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                            </div>
                            <div v-else-if="ev.ctCd === 'PR'">
                              <img :src="`/download/notice/PR/${ev.noticeCode}.jpg`" class="card-img-top leftImg" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                            </div>                            
                          </div>
                        </div>
                      </div>

                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselvarietyControls" data-bs-slide="prev">
                        <div class="back">
                          <span class="noticePrev"><i class="bi bi-arrow-left-circle text-warning fw-bolder"></i></span>
                          <span class="visually-hidden">Previous</span>
                        </div>
                      </button>
                      <button class="carousel-control-next" type="button" data-bs-target="#carouselvarietyControls" data-bs-slide="next">
                        <div class="back">
                          <span class="noticeNext"><i class="bi bi-arrow-right-circle text-warning fw-bolder"></i></span>
                          <span class="visually-hidden">Next</span>
                        </div>
                      </button>
                    </div>
                  </td>
                  <td v-else></td>

                  <!-- 공지사항 리스트 -->
                  <td style="width: 600px; height: 500px; vertical-align: top" v-if="this.ingEvent.length > 0">
                    <div class="row">
                      <div :key="j" v-for="(notice, j) in this.noticeList.slice(0, 11)">
                        <div class="post-entry d-flex">
                          <div class="row contents order-md-1 pl-0">
                            <div style="width: 440px">
                              <a href="javascript:void(0)" @click="showArea(notice.noticeCode)">
                                <h5 v-if="notice.ctCd === 'NT'" class="notice-header">
                                  <b style="color: dimgray">[공지사항]</b> &nbsp;
                                  <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                                </h5>
                                <h5 v-else-if="notice.ctCd === 'EV'" class="notice-header">
                                  <b style="color: darkgreen">[이 &nbsp;벤&nbsp; 트]</b> &nbsp;
                                  <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                                </h5>
                                <h5 v-else-if="notice.ctCd === 'TR'" class="notice-header">
                                  <b style="color: darkred">[여행관련]</b> &nbsp;
                                  <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                                </h5>
                                <h5 v-else-if="notice.ctCd === 'MO'" class="notice-header">
                                  <b style="color: darkblue">[항공선박]</b> &nbsp;
                                  <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                                </h5>
                                <h5 v-else-if="notice.ctCd === 'PR'" class="notice-header">
                                  <b style="color: darkorange">[홍보안내]</b> &nbsp;
                                  <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                                </h5>
                                <h5 v-else class="notice-header">
                                  <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                                </h5>
                              </a>
                            </div>
                            <div class="text-end" style="width: 70px; margin-left: 5px;">
                              <span class="date-read"> {{this.getDateFormat(notice.insDate)}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td v-else></td>
                </tr>
                <!-- 퀵메뉴 -->
                <tr>
                  <td style="width: 600px; height: 100px; vertical-align: bottom;" v-if="this.ingEvent.length > 0">
                    <div class="container quick" style="padding-left: 25px;">
                      <div class="row contents">
                        <div class="col-3 text-center">
                          <a href="/customerAsk" class="d-flex flex-column align-items-center">
                            <img src="../assets/img/new-test/m-ask.png" class="mb-2"/>
                            <p class="quickTitle">1:1 문의</p>
                          </a>
                        </div>
                        <div class="col-3 text-center">
                          <a href="/requestQuotation" class="d-flex flex-column align-items-center">
                            <img src="../assets/img/new-test/m-group.png" class="mb-2"/>
                            <p class="quickTitle">기업/단체 문의</p>
                          </a>
                        </div>
                        <div class="col-3 text-center">
                          <a href="/customerService" class="d-flex flex-column align-items-center">
                            <img src="../assets/img/new-test/m-question.png" class="mb-2"/>
                            <p class="quickTitle">자주하는 질문</p>
                          </a>
                        </div>
                        <div class="col-3 text-center">
                          <div class="d-flex flex-column align-items-center">
                            <img src="../assets/img/new-test/m-point.png" class="mb-2" style="cursor: pointer" @click="goLink('page', 'pointList_client', '', '')"/>
                            <p class="quickTitle">포인트 안내</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </section>

          <div id="bannerEnd"></div>
        </div>

        <div class="side right">
          <!-- Remote Control Section -->
          <div ref="rtRemoteContainer" class="rt-remote-container not-hidden-remote">
            <MainRtRemote :is-hidden="isHidden" />
          </div>
        </div>
      </div>
    </div>


    <!-- ******************* *******************  ************************************** -->
    <!-- ******************* 모바일 디바이스 대응  ************************************** -->
    <!-- ******************* *******************  ************************************** -->
    <div id="main-app" v-else-if="this.mobileDisplay">
      <!-- 모바일 메뉴체계(햄버거) -->
      <div class="mobile-menu" id="userM">
        <div class="adBar" v-if="showAdBar_mo && !this.isApp" style="position: relative; display: inline-block;">
          <div style="padding-top: 0px !important;" v-if="this.iosFlag">
            <a href="https://apps.apple.com/kr/app/%EC%97%94%ED%83%80%EB%B9%84-%EC%9D%BC%EB%B3%B8-%EA%B0%88-%EB%95%90-%EC%97%94%ED%83%80%EB%B9%84-%EC%9D%BC%EB%B3%B8-%EB%B2%84%EC%8A%A4%ED%88%AC%EC%96%B4-%EC%97%94%EB%8D%B0%EC%9D%B4%ED%8A%B8%EB%A6%BD/id6745860846" target="_blank">
              <img src="../../src/assets/img/main/adBar/top_add_point_mo.jpg" style="width: 100%; height: auto; display: block;">
            </a>
          </div>
          <div style="padding-top: 0px !important;" v-else>
            <a href="https://play.google.com/store/apps/details?id=com.eUoPfDyrvZ.ZBqPiAIqvO" target="_blank">
              <img src="../../src/assets/img/main/adBar/top_add_point_mo.jpg" style="width: 100%; height: auto; display: block;">
            </a>
          </div>
          <button class="adBar_closeBtn_mo" aria-label="Close adBar" @click="closeAdBar">
            <i class="bi bi-x-square text-danger"></i>
          </button>
        </div>


        <nav id="navbarExample" class="navbar navbar-expand-lg navbar-light" aria-label="Main navigation">
          <div class="container d-flex justify-content-between align-items-center" style="position: relative; padding: 4px 12px;">
            <!-- 왼쪽 끝: blood_event_mobile -->
            <div style="position: absolute; left: 12px;">
              <a href="/bloodevent">
                <img src="../../src/assets/img/main/blood_event_mobile.gif" alt="Event" style="width: 70px;">
              </a>
            </div>

            <!-- 정중앙: 로고 -->
            <div style="margin: 0 auto;">
              <a href="/">
                <img src="../../src/assets/img/ci_bi/Ntabi.png" class="logo" alt="Logo" style="width: 70px;">
              </a>
            </div>

            <!-- 오른쪽 끝: 두 개 이미지 차례대로 -->
            <div style="position: absolute; right: 12px; display: flex; align-items: center; gap: 10px;">
              <a href="/pushCenter" v-if="this.isApp">
                <img src="../../src/assets/img/main/push/noPush.png" alt="Event" style="width: 25px;" v-if="!this.pushAri">
                <img src="../../src/assets/img/main/push/yesPush.png" alt="Event" style="width: 25px;" v-else>
              </a>
              <button class="navbar-toggler border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileCollapseMenu" aria-controls="mobileCollapseMenu">
                <span class="navbar-toggler-icon"></span>
              </button>
            </div>

          </div>
        </nav>


        <!-- 모바일 메뉴 -->
        <div class="row mmenu">
          <div class="offcanvas offcanvas-start" tabindex="-1" id="mobileCollapseMenu" aria-labelledby="mobileCollapseMenuLabel">
            <div class="offcanvas-header">
              <!-- 로그인 -->
              <div class="toolbar-login">
                <a class="b2cTag" href="javascript: void(0)" style="text-decoration-line: none; font-weight: normal" @click="toB2CLoginPage" v-if="user.email == undefined">
                  로그인
                </a>
                <a class="b2cTag text-danger" href="javascript: void(0)" style="text-decoration-line: none; font-weight: normal" @click="toB2CLogout" v-else>
                  로그아웃
                </a>
                <a class="b2cTag" href="javascript: void(0)" style="text-decoration-line: none; font-weight: normal" @click="toMyPage" v-if="user.email != undefined">
                  마이페이지
                </a>
                <a class="b2cTag" href="javascript: void(0)" style="text-decoration-line: none; font-weight: normal" @click="toReqQuotation" v-if="user.email != undefined">
                  기업/단체문의
                </a>
                <a href="/customerService">고객센터</a>
              </div>
              <!-- 닫기 -->
              <button type="button" class="btn-close text-reset mbtn-close" data-bs-dismiss="offcanvas" aria-label="Close" ></button>
            </div>

            <!-- 메뉴 -->
            <div class="offcanvas-body text-start">
              <ul class="navbar-nav ms-auto navbar-nav-scroll">
                <li class="nav-item dropdown" v-if="user.handlerId == undefined">
                  <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="dropdown01" data-bs-toggle="dropdown" aria-expanded="false" style="text-decoration-line: none">
                    엔데이트립현지투어
                  </a>
                  <ul class="dropdown-menu" aria-labelledby="dropdown01">
                    <li class="nav-item2 dropdown">
                      <div class="n-country text-start" style="margin-left: 10px; margin-right: auto" :key="ntCd" v-for="(ba, ntCd) in this.ntToAr">
                        <div>
                          <a :href="`/bustour?nt=${ba[0].ntCd}&ar=`" class="fw-bold">
                            {{ ba[0].NT }}
                          </a>
                        </div>
                        <div class="mssun-menu">
                          <a :href="`/bustour?nt=${info.ntCd}&ar=${info.arCd}`" :key="info.arCd" v-for="info in ba" class="mt-0 p-0">
                            &nbsp;&nbsp;&nbsp;{{ info.AR }}
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li  class="nav-item dropdown one" v-if="user.handlerId == undefined">
                  <a class="nav-link dropdown-toggle" href="javascript: void(0)" id="dropdown03" data-bs-toggle="dropdown" aria-expanded="false" style="text-decoration-line: none" onclick="location.href='subList?nt=JP'">
                    패키지여행
                  </a>
                </li>

                <li class="nav-item dropdown one" v-if="user.handlerId == undefined">
                  <a class="nav-link dropdown-toggle" href="javascript: void(0)" id="dropdown04" data-bs-toggle="dropdown" aria-expanded="false" style="text-decoration-line: none" onclick="location.href='/exhibitionEvent'">
                    버라이어티팩 (테마기획상품)
                  </a>
                </li>

                <li class="nav-item dropdown" v-if="user.handlerId == undefined">
                  <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="dropdown01" data-bs-toggle="dropdown" aria-expanded="false" style="text-decoration-line: none">
                    일본승선권
                  </a>
                  <ul class="dropdown-menu" aria-labelledby="dropdown01">
                    <li class="nav-item2 dropdown">
                      <div class="n-country text-start" style="margin-left: 10px; margin-right: auto" :key="dtCd" v-for="(ba, dtCd) in this.spToDt">
                        <div>
                          <a :href="`/shipTour?dt=${ba[0].dtCd}&tr=`" class="fw-bold">
                            {{ ba[0].DT }}
                          </a>
                        </div>
                        <div class="mssun-menu">
                          <a :href="`/shipTour?dt=${info.dtCd}&tr=${info.trCd}`" :key="info.trCd" v-for="info in ba" class="mt-0 p-0">
                            &nbsp;&nbsp;&nbsp;{{ info.TR }}
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li
                  class="nav-item dropdown" v-if="user.handlerId == undefined">
                  <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="dropdown01" data-bs-toggle="dropdown" aria-expanded="false" style="text-decoration-line: none">티켓/패스</a>
                  <ul class="dropdown-menu" aria-labelledby="dropdown01">
                    <li class="nav-item2 dropdown">
                      <div class="n-country text-start" style="margin-left: 10px; margin-right: auto" :key="ntCd" v-for="(ba, ntCd) in this.tkNtToAr">
                        <div>
                          <a
                            :href="`/tktPass?nt=${ba[0].ntCd}&ar=`"
                            class="fw-bold"
                            >{{ ba[0].NT }}</a
                          >
                        </div>
                        <div class="mssun-menu">
                          <a
                            :href="`/tktPass?nt=${info.ntCd}&ar=${info.arCd}`"
                            :key="info.arCd"
                            v-for="info in ba"
                            class="mt-0 p-0"
                          >
                            &nbsp;&nbsp;&nbsp;{{ info.AR }}
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li class="nav-item dropdown one" v-if="user.handlerId == undefined">
                  <a class="nav-link dropdown-toggle" href="javascript: void(0)" id="dropdown04" data-bs-toggle="dropdown" aria-expanded="false" style="text-decoration-line: none" onclick="location.href='/golfTour'">
                    일본골프여행
                  </a>
                </li>

                <li class="nav-item dropdown one" v-if="user.handlerId == undefined">
                  <a class="nav-link dropdown-toggle" href="javascript: void(0)" id="dropdown04" data-bs-toggle="dropdown" aria-expanded="false" style="text-decoration-line: none" onclick="location.href='/ndaytrip_membership_page'">
                    멤버십
                  </a>
                </li>

                <li class="nav-item dropdown one" v-if="user.handlerId == undefined">
                  <a class="nav-link dropdown-toggle blink" href="https://smartstore.naver.com/ntabi" target="_blank">
                    <span style="color: green">네이버예약</span>
                  </a>
                </li>

                <!-- <li class="nav-item dropdown one" v-if="user.handlerId == undefined">
                  <a class="nav-link dropdown-toggle" href="https://smartstore.naver.com/somen" target="_blank">
                    <span style="color: green">소면공방</span>
                  </a>
                </li> -->
              </ul>
            </div>
          </div>
        </div>

        <!-- 모바일 최근 본 상품 -->
        <div class="row mrecent" id="recent-item-m">
          <div class="offcanvas off-recent offcanvas-top" tabindex="-1" id="mobileCollapseRecent" aria-labelledby="mobileCollapseRecentLabel">
            <div class="offcanvas-header">
              <h5 class="offcanvas-title">최근 본 상품</h5>
              <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <!-- 메뉴 -->
            <div class="offcanvas-body">
              <div class="recent-items"
                :style="{ 
                  height: this.recentFlag === 'Y' ? 'auto' : '0',
                  overflow: 'hidden',
                  transition: 'height 0.3s ease',
                }"
                :key="i" v-for="(rv, i) in this.recentViewInfo">
                <a href="javascript:void(0)" @click="goToDetail(rv.pdtCode, rv.salesRoute)">
                  <div class="row item recent">
                    <div class="col-4">
                      <img v-if="rv.imgName != 'noImage'" :src="`/download/${rv.pdtCode}/${rv.imgName}`" class="card-img-top" alt="상품이미지"/>
                    </div>
                    <div class="col-8 align-self-center">
                      <p class="name">{{ rv.pdtNameKor }}</p>
                    </div>
                  </div>
                </a>
                <hr style="margin: 20px 3px" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TOP배너 -->
      <section id="topBanner-m" class="topBanner" ref="mainBanner" :style="showAdBar_mo && !isApp ? {paddingTop: '2.75rem'} : {paddingTop: '0'}">
        <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel" data-bs-touch="true" data-bs-interval="3000">
          <div class="carousel-indicators">
            <button
              v-for="(slide, index) in topSlides"
              :key="'indicator-' + index"
              type="button"
              :data-bs-target="'#carouselExampleControls'"
              :data-bs-slide-to="index"
              :class="{ active: index === 0 }"
              :aria-current="index === 0 ? 'true' : 'false'"
              :aria-label="'Slide ' + (index + 1)"
            ></button>
          </div>
          <div class="carousel-inner">
            <div v-for="(slide, index) in topSlides" :key="index" class="carousel-item" :class="{ active: index === 0 }">
              <img :src="slide.image" class="d-block w-100" :alt="slide.alt" style="height: 350px" @click="goLink2(slide.type, slide.link, slide.pId, slide.sRoute)"/>
              <div class="carousel-caption d-none d-md-block">
                <h5 v-html="slide.text1"></h5>
                <p>{{ slide.text2 }}</p>
              </div>
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </section>

      <!-- <div class="hr-line mt-3"></div> -->

      <!-- 모바일 메인 메뉴 -->
      <section class="main-menu">
        <div class="icon-menu" style="margin-top: 0px;">
          <!-- 엔데이트립멤버십 -->
          <div class="icon-item">
            <img src="../assets/img/AppImg/membership_new.gif" alt="멤버십" @click="goLink2('page', 'ndaytrip_membership_page', '', '')"/>
            <p class="icon-text">엔데이트립<br/>멤버십</p>
          </div>

          <!-- 현지투어 -->
          <div class="icon-item">
            <img src="../assets/img/AppImg/ndaytrip.png" alt="현지투어" @click="goLink2('page', 'bustour', '', '')"/>
            <p class="icon-text" style="padding-top: 5px;">엔데이트립<br/>현지투어</p>
          </div>

          <div class="icon-item">
            <img src="../assets/img/AppImg/japanship.png" alt="일본선박" @click="goLink2('page', 'shipTour', '', '')"/>
            <p class="icon-text">일본승선권</p>
          </div>

          <div class="icon-item">
            <img src="../assets/img/AppImg/variety.png" alt="버라이어티팩" @click="goLink2('page', 'exhibitionEvent', '', '')"/>
            <p class="icon-text">버라이어티팩</p>
          </div>
        </div>

        <div class="icon-menu mt-3">
          <div class="icon-item">
            <img src="../assets/img/AppImg/nbus.png" alt="엔버스" @click="goLink2('page', 'nbus_mainpage', '', '')"/>
            <p class="icon-text">엔버스</p>
          </div>

          <div class="icon-item">
            <img src="../assets/img/AppImg/package.png" alt="페키지여행" @click="goLink2('Ntabi', '', '', '')"/>
            <p class="icon-text">패키지여행</p>
          </div>
          
          <div class="icon-item">
            <img src="../assets/img/AppImg/ticket.png" alt="티켓패스" @click="goLink2('page', 'tktPass', '', '')"/>
            <p class="icon-text">티켓&패스</p>
          </div>

          <div class="icon-item">
            <img src="../assets/img/AppImg/golf.png" alt="골프여행" @click="goLink2('page', 'GolfTour', '', '')"/>
            <p class="icon-text">일본골프여행</p>
          </div>

          <!-- <div class="icon-item">
            <a href="https://smartstore.naver.com/ntabi" target="_blank">
              <img src="../assets/img/AppImg/naver.png" alt="네이버예약" />
            </a>
            <p class="icon-text">네이버예약</p>
          </div> -->
        
        </div>
      </section>

      <!-- <div class="hr-line mb-3"></div> -->

      <!-- *********************************** 
        **라쿠텐 호텔검색영역 (2026-05-15) **
        **************************************** -->
      <section class="hotel-search-section-mo mt-3 mx-2" v-if="this.AccHotel === 'OK'">
        <div class="px-1">
          <h3 class="rakuten-logo">Rakuten Travel</h3>
        </div>
        <HotelSearchBar />
      </section>

      <!-- Mid배너 -->
      <section id="midBanner-m" class="midBanner" ref="mainBanner">
        <div id="midCsControls" class="carousel slide" data-bs-ride="carousel" data-bs-touch="true">
          <div class="carousel-indicators">
            <button
              v-for="(slide, index) in midSlides"
              :key="'indicator-' + index"
              type="button"
              :data-bs-target="'#midCsControls'"
              :data-bs-slide-to="index"
              :class="{ active: index === 0 }"
              :aria-current="index === 0 ? 'true' : 'false'"
              :aria-label="'Slide ' + (index + 1)"
            ></button>
          </div>
          <div class="carousel-inner">
            <div v-for="(slide, index) in midSlides" :key="index" class="carousel-item" :class="{ active: index === 0 }">
              <img :src="slide.image" class="d-block w-100" :alt="slide.alt" style="width: 100%; height: 250px; object-fit: cover" @click="goLink2(slide.type, slide.link, slide.pId, slide.sRoute)"/>
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#midCsControls" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#midCsControls" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </section>


      <!-- 지금 뜨는 여행 : 모바일용 -->
      <!-- <section class="ts-section d-block d-md-none mt-5 mb-3">
        <div class="ts-header">
          <h5>
            <span style="font-weight: 600">🎇&nbsp;지금 뜨는 여행</span>
          </h5>
        </div>

        <div class="ts-scroll-wrap" ref="tsScroll" @scroll="updatePage">
          <div class="ts-card" :key="i" v-for="(product, i) in new_productListForSales_now">
            <img v-if="product.imgName !== 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="ts-card-img" 
            @click="goToDetail(product.pdtCode, product.salesRoute)" alt="" />
            <img v-else src="/download/noImage/noImage.jpg" class="ts-card-img" alt="" />

            <div class="ts-card-body">
              <div class="ts-pdt-name" @click="goToDetail(product.pdtCode, product.salesRoute)" >{{ product.pdtNameKor }}</div>

              <div class="ts-pdt-tags">{{ product.pdtRemarks }}</div>

              <template v-if="product.basic_PdtPrice > 0 && product.displayFlag === 'Y' && product.saleFlag === 'Y'">
                <div class="ts-price-row" @click="goToDetail(product.pdtCode, product.salesRoute)">
                  <template v-if="product.discountPercent == 0">
                    <span class="ts-final-price">
                      {{ getCurrencyFormat(product.pdtPrice) }}<span class="ts-won">원</span>
                    </span>
                  </template>
                  <template v-else>
                    <span class="ts-discount">{{ product.discountPercent }}%</span>
                    <span class="ts-final-price">
                      {{ getCurrencyFormat((product.basic_PdtPrice * 1) + (product.minOptPrice * 1)) }}<span class="ts-won">원~</span>
                    </span>
                    <span class="ts-original">{{ getCurrencyFormat(product.pdtPrice) }}원</span>
                  </template>
                </div>

                <div class="ts-badge-wrapper">
                  <div class="ts-coupon-badge" v-if="product.badgeFlag === 'Y'">
                    {{ product.badge }}
                  </div>
                  <div class="ts-coupon-badge2" v-if="product.badge2Flag === 'Y'">
                    {{ product.badge2 }}
                  </div>
                </div>
              </template>

              <div class="ts-no-price" v-else>
                <i class="bi bi-hourglass-split"></i> 상품 준비 중
              </div>
            </div>
          </div>
        </div>

        <div class="ts-pagination">
          <button class="ts-page-btn" @click="movePage(-1)">
            <i class="bi bi-chevron-left"></i>
          </button>
          <span class="ts-page-info">{{ tsCurrentPage + 1 }} / {{ new_productListForSales_now.length }}</span>
          <button class="ts-page-btn" @click="movePage(1)">
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </section> -->

      <!-- *********************************** 
        ** 모바일 엔타비 인스타그램 컨텐츠 (2026-10-13) **
        **************************************** -->
        <section id="igSection-m" class="ig-section-m" v-if="instaPosts.length > 0">
        <div class="ig-header-m">
          <h2>
            <i class="bi bi-instagram ig-icon-m"></i>
            <span style="color: #dc2743; font-weight: 800">인스타그램</span>으로 만나는 엔타비
          </h2>
          <a :href="instaProfileUrl" target="_blank" rel="noopener" class="ig-more-m">
            <i class="bi bi-instagram"></i> 바로가기
          </a>
        </div>

        <div class="ig-scroll-wrap-m" ref="igScroll_m" @scroll="igUpdatePage">
          <div class="ig-card-m" v-for="post in instaPosts" :key="'m_' + post.id">
            <!-- 높이 고정 프레임 (넘치는 하단은 잘림) -->
            <div class="ig-frame">
              <blockquote
                class="instagram-media"
                :data-instgrm-permalink="`${post.url}?utm_source=ig_embed&utm_campaign=loading`"
                data-instgrm-version="14"
              >
                <a :href="post.url" target="_blank" rel="noopener" class="ig-fallback-m">
                  <i class="bi bi-instagram"></i> Instagram에서 게시물 보기
                </a>
              </blockquote>
            </div>
            <!-- 하단 페이드 + 전체보기 버튼 -->
            <a :href="post.url" target="_blank" rel="noopener" class="ig-more-overlay">
              <span><i class="bi bi-instagram"></i> Instagram에서 전체 보기</span>
            </a>
          </div>
        </div>

        <div class="ig-pagination-m" v-if="instaPosts.length > 1">
          <button class="ig-page-btn-m" @click="igMovePage(-1)" :disabled="igCurrentPage === 0">
            <i class="bi bi-chevron-left"></i>
          </button>
          <span class="ig-page-info-m">{{ igCurrentPage + 1 }} / {{ instaPosts.length }}</span>
          <button class="ig-page-btn-m" @click="igMovePage(1)" :disabled="igCurrentPage === instaPosts.length - 1">
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </section>

      <!-- Mobile grouping 상품리스트 -->
      <section id="groupProducts" class="groupProduct" style="background-color: rgba(182, 185, 188, 0.2)" >
        <!-- 그루핑 테마이미지 캐러셀 -->
        <div id="carouselExampleControls_gr" class="carousel slide" data-bs-ride="carousel" data-bs-interval="7000"  data-bs-touch="true">
          <div class="carousel-indicators">
            <button v-for="(slide, grIndex) in grSlides" 
              :key="'indicator-' + grIndex"
              type="button"
              :data-bs-target="'#carouselExampleControls_gr'"
              :data-bs-slide-to="grIndex"
              :class="{ active: currentSlideIndex === grIndex }"
              :aria-current="grIndex === 0 ? 'true' : 'false'"
              :aria-label="'Slide ' + (grIndex + 1)"
            ></button>
          </div>
          <div class="carousel-inner">
            <div v-for="(slide, grIndex) in grSlides" :key="grIndex" class="carousel-item" :class="{ active: currentSlideIndex === grIndex }">
              <img :src="slide.image" class="d-block w-100" :alt="slide.alt" style="height: 400px" />
            </div>
          </div>

          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls_gr" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls_gr" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>


        <!-- New 모바일 그룹별 상품리스트 -->
        <div class="product-list mt-2" v-if="this.currentSlideIndex == 0 && this.productListForSales_grFin.length <= 0">
          <div key="product-list">
            <div class="row" :key="i" v-for="(pdt, i) in this.productListForSales_gr">
              <div class="col-4 mt-4" style="cursor:pointer;"  @click="goToDetail(pdt.pdtCode, pdt.salesRoute)">
                <img v-if="pdt.imgName != 'noImage'" :src="`/download/${pdt.pdtCode}/${pdt.imgName}`" class="img-fluid pdt-img" style="width: 125px; height: 124px;  border-radius: 8%; padding-top: 0px;" alt="..."/>
                <img v-else :src="`/download/noImage/noImage.jpg`" class="img-fluid pdt-img" style="width: 500px; border-radius: 10%; padding-top: 0px;" alt="no image" />
              </div>
              <div class="col-8 mt-3" style="padding-left: 10px; padding-top: 8px; cursor:pointer;"  @click="goToDetail(pdt.pdtCode, pdt.salesRoute)">
                <h6 class="product-title_mo">{{ pdt.pdtNameKor }}</h6>
                <span class="grProductRemarks_mo">{{ pdt.pdtRemarks }}</span>
                <div class="product-container-m">
                  <span class="price">
                    <!-- new 가격옵션정책 -->
                    <div>
                      <div class="my-0">

                        <div class="mt-1 priceSection_mo">
                          <!-- 네이버가격/옵션호환 -->
                          <div>

                            <!-- 상품가격표시 -->
                            <div class="my-1" v-if="pdt.basic_PdtPrice > 0 && pdt.displayFlag == 'Y' && pdt.saleFlag == 'Y'">
                              <b class="mx-2 ndayPrice fw-bold" v-if="pdt.discountPercent == 0"> {{ getCurrencyFormat(pdt.pdtPrice) }}</b>
                              <b class="text-muted text-decoration-line-through mx-2 ndayPrice" v-else> {{ getCurrencyFormat(pdt.pdtPrice) }}</b>

                              <i class="bi bi-caret-right-fill" v-if="pdt.discountPercent != 0"></i>
                              <span class="mx-2 ndayPrice text-danger fw-bolder" style="padding-left: 8px;" v-if="pdt.discountPercent != 0"> {{ getCurrencyFormat(pdt.discountPercent) }}%</span>
                              <span class="ndayPrice fw-bolder" v-if="pdt.discountPercent != 0">{{ getCurrencyFormat((pdt.basic_PdtPrice*1) + (pdt.minOptPrice*1)) }}</span>
                              <span>원~</span>
                            </div>
                            <div class="my-1" style="display:flex;" v-else>
                              <span class="ndayPrice fw-bold">상품을 준비 중입니다</span> 
                              <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(pdt.pdtCode, pdt.salesRoute)"></i>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="product-list mt-2" v-else>
          <div key="product-list">
            <div class="row" :key="j" v-for="(pdt, j) in this.productListForSales_grFin">
              <div class="col-4 mt-4" style="cursor:pointer;"  @click="goToDetail(pdt.pdtCode, pdt.salesRoute)">
                <img v-if="pdt.imgName != 'noImage'" :src="`/download/${pdt.pdtCode}/${pdt.imgName}`" class="img-fluid pdt-img" style="width: 125px; height: 124px;  border-radius: 8%; margin: 0;" alt="..."/>
                <img v-else :src="`/download/noImage/noImage.jpg`" class="img-fluid pdt-img" style="width: 500px; border-radius: 10%; padding-top: 0px;" alt="no image" />
              </div>
              <div class="col-8 mt-3" style="padding-left: 10px; padding-top: 8px; cursor:pointer;"  @click="goToDetail(pdt.pdtCode, pdt.salesRoute)">
                <h6 class="product-title_mo">{{ pdt.pdtNameKor }}</h6>
                <span class="grProductRemarks_mo">{{ pdt.pdtRemarks }}</span>
                <div class="product-container-m">
                  <span class="price">
                    <!-- new 가격옵션정책 -->
                    <div>
                      <div class="my-0">
                        <div class="mt-1 priceSection_mo">
                          <!-- 네이버가격/옵션호환 -->
                          <div>

                            <!-- 상품가격표시 -->
                            <div class="my-1" v-if="pdt.basic_PdtPrice > 0 && pdt.displayFlag == 'Y' && pdt.saleFlag == 'Y'">
                              <b class="mx-2 ndayPrice fw-bold" v-if="pdt.discountPercent == 0"> {{ getCurrencyFormat(pdt.pdtPrice) }}</b>
                              <b class="text-muted text-decoration-line-through mx-2 ndayPrice" v-else> {{ getCurrencyFormat(pdt.pdtPrice) }}</b>

                              <i class="bi bi-caret-right-fill" v-if="pdt.discountPercent != 0"></i>
                              <span class="mx-2 ndayPrice text-danger fw-bolder" style="padding-left: 8px;" v-if="pdt.discountPercent != 0"> {{ getCurrencyFormat(pdt.discountPercent) }}%</span>
                              <span class="ndayPrice fw-bolder" v-if="pdt.discountPercent != 0">{{ getCurrencyFormat((pdt.basic_PdtPrice*1) + (pdt.minOptPrice*1)) }}</span>
                              <span>원~</span>
                            </div>
                            <div class="my-1" style="display:flex;" v-else>
                              <span class="ndayPrice fw-bold">상품을 준비 중입니다</span> 
                              <i class="bi bi-question-circle-fill text-danger fs-5" style="cursor: pointer; padding-left: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요" @click="inquiryProduct(pdt.pdtCode, pdt.salesRoute)"></i>
                            </div>
                          </div>
                        </div> 

                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Video Section (Mobile) -->
      <section class="video-section mx-auto main-left" v-if="mobileDisplay">
        <div id="videoCarousel_m" class="carousel slide" data-bs-ride="false">
          
          <div class="carousel-indicators">
            <button v-for="(v, i) in videos" :key="i" type="button" data-bs-target="#videoCarousel_m" :data-bs-slide-to="i" :class="{ active: i === 0 }"></button>
          </div>

          <div class="carousel-inner">
            <div v-for="(v, i) in videos" :key="i" class="carousel-item" :class="{ active: i === 0 }">
              <video class="video-carousel-item" muted playsinline :ref="`videoRef_m_${i}`" @ended="onVideoEnded_m" >
                <source :src="v.src" type="video/mp4" />
              </video>
            </div>
          </div>

          <button class="carousel-control-prev" type="button" data-bs-target="#videoCarousel_m" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#videoCarousel_m" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
          </button>
        </div>
      </section>

      <!-- 모바일스마트스토어 라이브 -->
      <!-- <section id="liveSection-m" class="live-section-m">
        <div class="section-title">
          <div class="col-7">
            <img src="../assets/img/main/live_logo.png" style="width: 50%;"/>
          </div>
          <div id="more">
            <a href="https://m.smartstore.naver.com/ntabi/lives?cp=1" target="_blank">
              <i class="bi bi-broadcast"></i> 전체보기
            </a>
          </div>
        </div>
        <div class="row mt-2">
          <div class="iframe-container-m">
            <iframe src="https://m.smartstore.naver.com/ntabi/lives?cp=1" frameborder="0" scrolling="yes"></iframe>
          </div>
        </div>
      </section> -->

      <section class="ndaytrip-recommend mt-5">
        <h2>
          <span style="color: darkblue; font-weight: 800">엔데이트립</span>이 추천하는 현지투어
        </h2>
        <div class="scrolling-wrapper" ref="scrollingContent_nday" @touchstart="onTouchStart_nday" @touchmove="onTouchMove_nday" @touchend="onTouchEnd_nday">
          <div class="scrolling-content">
            <div class="ntabi-pdt" v-for="(product, i) in new_productListForSales_ndaytrip_mdChoice" :key="i">
              <div class="ntabi">
                <a class="text-decoration-none link-dark stretched-link" href="javascript: void(0)" @click="goToDetail(product.pdtCode, product.salesRoute)">
                  <img v-if="product.imgName !== 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="img-fluid hover-zoom" alt="..." />
                  <img v-else src="/download/noImage/noImage.jpg" class="img-fluid" alt="No Image" />
                  <!-- <span class="recommendation-badge outlined-badge">
                    <img src="../assets/img/icons/nday.png" class="iconBadge" style="width: 40px; height: auto"/>
                  </span> -->
                  <div class="ntabi-body">
                    <h5 class="ntabi-title">{{ product.arName }}</h5>
                    <p class="showPdtName">{{ product.pdtNameKor }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ship-recommend mt-2">
        <h2>
          부산출발 <span style="color:deepskyblue ; font-weight: 800">특가 승선권</span>
        </h2>
        <div class="scrolling-wrapper" ref="scrollingContent_ship" @touchstart="onTouchStart_ship" @touchmove="onTouchMove_ship" @touchend="onTouchEnd_ship">
          <div class="scrolling-content">
            <div class="ntabi-pdt" v-for="(product, i) in new_productListForSales_ship" :key="i">
              <div class="ntabi">
                <a class="text-decoration-none link-dark stretched-link" href="javascript: void(0)" @click="goToDetail(product.pdtCode, product.salesRoute)" >
                  <img v-if="product.imgName !== 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="img-fluid hover-zoom" alt="..."/>
                  <img v-else src="/download/noImage/noImage.jpg" class="img-fluid" alt="No Image"/>
                  <!-- <span class="new-badge outlined-badge">
                    <img src="../assets/img/icons/good.png" class="iconBadge" style="width: 35px; height: auto" />
                  </span> -->
                  <div class="ntabi-body">
                    <h5 class="ntabi-title">{{ product.arName }}</h5>
                    <p class="showPdtName">{{ product.pdtNameKor }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="product-banner">
        <div class="border" style="height: 150px; border-radius: 10px">
          <img
            style="width: 100%; height: 150px; object-fit: fill"
            src="../assets/img/AppImg/shinkansen_mid_banner2.png"
            alt=""
            @click="goLink2('product', '', 'F-2681372XZC', 'F')"
          />
        </div>
      </section>

      <section class="ntabi-recommend">
        <h2>
          <span style="color: darkgreen; font-weight: 800">엔타비</span>가 만든 버라이어티 팩
        </h2>
        <div class="scrolling-wrapper" ref="scrollingContent_m" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
          <div class="scrolling-content">
            <div class="ntabi-pdt" v-for="(product, i) in new_productListForSales_ntabi_mdChoice" :key="i">
              <div class="ntabi">
                <a class="text-decoration-none link-dark stretched-link" href="javascript: void(0)" @click="goToDetail(product.pdtCode, product.salesRoute)">
                  <img v-if="product.imgName !== 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="img-fluid hover-zoom" alt="..."/>
                  <img v-else src="/download/noImage/noImage.jpg" class="img-fluid" alt="No Image"/>
                  <!-- <span class="recommendation-badge outlined-badge">
                    <img src="../assets/img/icons/ntb.png" class="iconBadge" style="width: 40px; height: auto"/>
                  </span> -->
                  <div class="ntabi-body">
                    <h5 class="ntabi-title">{{ product.arName }}</h5>
                    <p class="showPdtName">{{ product.pdtNameKor }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ndaytrip-recommend mt-2">
        <h2>
          일본여행에 유익한 <span style="color: darkred; font-weight: 800">패스모음</span>
        </h2>
        <div class="scrolling-wrapper" ref="scrollingContent_new" @touchstart="onTouchStart_new" @touchmove="onTouchMove_new" @touchend="onTouchEnd_new">
          <div class="scrolling-content">
            <div class="ntabi-pdt" v-for="(product, i) in new_productListForSales_new" :key="i">
              <div class="ntabi">
                <a class="text-decoration-none link-dark stretched-link" href="javascript: void(0)" @click="goToDetail(product.pdtCode, product.salesRoute)" >
                  <img v-if="product.imgName !== 'noImage'" :src="`/download/${product.pdtCode}/${product.imgName}`" class="img-fluid hover-zoom" alt="..."/>
                  <img v-else src="/download/noImage/noImage.jpg" class="img-fluid" alt="No Image"/>
                  <!-- <span class="new-badge outlined-badge">
                    <img src="../assets/img/icons/good.png" class="iconBadge" style="width: 35px; height: auto" />
                  </span> -->
                  <div class="ntabi-body">
                    <h5 class="ntabi-title">{{ product.arName }}</h5>
                    <p class="showPdtName">{{ product.pdtNameKor }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="liveSection-m" class="live-section-m mt-5">
        <div class="section-title">
          <div class="col-7">
            <img
              src="../assets/img/main/live_logo.png"
              style="width: 50%;"
            />
          </div>
          <div id="more">
            <a
              href="https://m.smartstore.naver.com/ntabi/lives?cp=1"
              target="_blank"
              ><i class="bi bi-broadcast"></i> 전체보기</a
            >
          </div>
        </div>

        <div class="row ndayliveTable mt-2">
          <table>
            <tr>
              <td class="ndayliveThumb" style="width: 50%">
                <div class="cardImg">
                  <a href="https://view.shoppinglive.naver.com/replays/1730584?fm=store&offFeature=contentLayer&sn=ltlim&swipe=%7B%22sortType%22%3A%22LATEST%22%2C%22pagerType%22%3A%22ALL%22%2C%22channelId%22%3A144805%2C%22referrerType%22%3A%22STORE%22%2C%22referrerKey%22%3A%22144805%22%7D&tr=ltlim" target="_blank">
                    <img src="../assets/img/ndayLiveThumbnail/오사카사슴.jpg" class="nliveThumb"/>
                  </a>
                </div>
              </td>
              <td class="ndayliveThumb" style="width: 50%">
                <div class="cardImg">
                  <a href="https://view.shoppinglive.naver.com/replays/1683352?fm=store&offFeature=contentLayer&sn=ltlim&swipe=%7B%22sortType%22%3A%22LATEST%22%2C%22pagerType%22%3A%22ALL%22%2C%22channelId%22%3A144805%2C%22referrerType%22%3A%22STORE%22%2C%22referrerKey%22%3A%22144805%22%7D&tr=ltlim" target="_blank">
                    <img src="../assets/img/ndayLiveThumbnail/다카야마라이브.jpg" class="nliveThumb"/>
                  </a>
                </div>
              </td>
            </tr>
            <tr>
              <td class="ndayliveThumb" style="width: 50%">
                <div class="cardText">
                  <p class="p1">
                    [즉시확정] 귀여운 사슴과 함께하는 나라공원 현지 실황라이브
                  </p>
                  <p class="p2 mt-0">
                    <span class="dcRate">28%</span> 49,000원
                  </p>
                </div>
              </td>
              <td class="ndayliveThumb" style="width: 50%">
                <div class="cardText">
                  <p class="p1">
                    [NdayLIVE] 나고야출발 작은도쿄 다카야마 현지라이브
                  </p>
                  <p class="p2 mt-0">
                    <span class="dcRate">50%</span> 59,000원
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <td class="ndayliveThumb" style="width: 50%">
                <div class="cardImg">
                  <a href="https://view.shoppinglive.naver.com/replays/1683349?fm=store&offFeature=contentLayer&sn=ltlim&swipe=%7B%22sortType%22%3A%22LATEST%22%2C%22pagerType%22%3A%22ALL%22%2C%22channelId%22%3A144805%2C%22referrerType%22%3A%22STORE%22%2C%22referrerKey%22%3A%22144805%22%7D&tr=ltlim" target="_blank">
                    <img src="../assets/img/ndayLiveThumbnail/삿뽀로맥주.jpg" class="nliveThumb"/>
                  </a>
                </div>
              </td>
              <td class="ndayliveThumb" style="width: 50%">
                <div class="cardImg">
                  <a href="https://view.shoppinglive.naver.com/replays/1683344?fm=store&offFeature=contentLayer&sn=ltlim&swipe=%7B%22sortType%22%3A%22LATEST%22%2C%22pagerType%22%3A%22ALL%22%2C%22channelId%22%3A144805%2C%22referrerType%22%3A%22STORE%22%2C%22referrerKey%22%3A%22144805%22%7D&tr=ltlim" target="_blank">
                    <img src="../assets/img/ndayLiveThumbnail/오사카먹방.jpg" class="nliveThumb"/>
                  </a>
                </div>
              </td>
            </tr>
            <tr>
              <td class="ndayliveThumb" style="width: 50%">
                <div class="cardText">
                  <p class="p1">
                    [NdayLIVE] 삿포로 맥주축제 1일차 현지 실황라이브
                  </p>
                  <p class="p2 mt-0">
                    <span class="dcRate">33%</span> 59,000원
                  </p>
                </div>
              </td>
              <td class="ndayliveThumb" style="width: 50%">
                <div class="cardText">
                  <p class="p1">
                    [NdayLIVE] 오사카 현지 실황 먹방라이브
                  </p>
                  <p class="p2 mt-0">
                    <span class="dcRate">37%</span> 49,000원
                  </p>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </section>


      <!-- 모바일 이벤트와 공지사항 -->
      <section id="notice-m" class="notice-m; mt-5">
        <div class="section-title">
          <div class="col-8">
            <a href="/customerNotice">
              <h2>
                <span style="font-weight: 800; padding-left: 15px; color: #333;">이벤트 & 공지사항</span>
              </h2>
            </a>
          </div>
          <div id="more" style="font-size: 0.8rem">
            <div id="more">
              <a href="/customerNotice" ><i class="bi bi-box-arrow-up-right"></i> 전체보기</a>
            </div>
          </div>
        </div>
        <div class="justify-content-center mt-3">
          <table class="w-100 noticeTable-m">
            <tr>
              <td style="background-color: transparent;">
                <div id="carouselvarietyControls" class="carousel slide notice-new" data-bs-ride="carousel" data-bs-interval="3000" data-bs-touch="true">
                  <div class="carousel-inner">
                    <div :class="`carousel-item ${i == '0' ? 'active' : ''}`" :key="i" v-for="(ev, i) in this.ingEvent">
                      <div class="img-container">
                        <div v-if="ev.ctCd === 'NT'">
                          <img :src="`/download/notice/NT/${ev.noticeCode}.jpg`" class="card-img-top ntImg_m" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                        </div>
                        <div v-else-if="ev.ctCd === 'EV'">
                          <img :src="`/download/notice/EV/${ev.noticeCode}.jpg`" class="card-img-top ntImg_m" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                        </div>
                        <div v-else-if="ev.ctCd === 'TR'">
                          <img :src="`/download/notice/TR/${ev.noticeCode}.jpg`" class="card-img-top ntImg_m" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                        </div>
                        <div v-else-if="ev.ctCd === 'MO'">
                          <img :src="`/download/notice/MO/${ev.noticeCode}.jpg`" class="card-img-top ntImg_m" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                        </div>
                        <div v-else-if="ev.ctCd === 'PR'">
                          <img :src="`/download/notice/PR/${ev.noticeCode}.jpg`" class="card-img-top ntImg_m" @click="showArea(ev.noticeCode)" style="cursor: pointer"/>
                        </div>                            
                      </div>
                    </div>
                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target="#carouselvarietyControls" data-bs-slide="prev">
                    <div class="back">
                      <span class="noticePrev"><i class="bi bi-arrow-left-circle text-warning fw-bolder"></i></span>
                      <span class="visually-hidden">Previous</span>
                    </div>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target="#carouselvarietyControls" data-bs-slide="next">
                    <div class="back">
                      <span class="noticeNext"><i class="bi bi-arrow-right-circle text-warning fw-bolder"></i></span>
                      <span class="visually-hidden">Next</span>
                    </div>
                  </button>
                </div>
              </td>
            </tr>
          </table>

          <table class="w-100 noticeTable-m">
            <tr>
              <td>
                <div class="row">
                  <div :key="j" v-for="(notice, j) in this.noticeList.slice(0, 6)">
                    <div class="post-entry d-flex">
                      <div class="row contents order-md-1 pl-0">
                        <div style="width: 230px;">
                          <a href="javascript:void(0)" @click="showArea(notice.noticeCode)">
                            <span v-if="notice.ctCd === 'NT'" class="notice-header">
                              <b style="color: dimgray">[공지사항]</b> &nbsp;
                              <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                            </span>
                            <span v-else-if="notice.ctCd === 'EV'" class="notice-header">
                              <b style="color: darkgreen">[이 &nbsp;벤&nbsp; 트]</b> &nbsp;
                              <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                            </span>
                            <span v-else-if="notice.ctCd === 'TR'" class="notice-header">
                              <b style="color: darkred">[여행관련]</b> &nbsp;
                              <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                            </span>
                            <span v-else-if="notice.ctCd === 'MO'" class="notice-header">
                              <b style="color: darkblue">[항공선박]</b> &nbsp;
                              <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                            </span>
                            <span v-else-if="notice.ctCd === 'PR'" class="notice-header">
                              <b style="color: darkorange">[홍보안내]</b> &nbsp;
                              <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                            </span>
                            <span v-else class="notice-header">
                              <span class="noticeTitle" :title="notice.nTitle">{{ this.formatTitle(notice.nTitle) }}</span>
                            </span>
                          </a>
                        </div>
                        <div style="width: 80px; text-align: end;">
                          <span class="date-read"> {{this.getDateFormat(notice.insDate)}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <!-- 공지관련 리스트 / 빠른메뉴 -->
        <div class="col-lg-12 my-4">
          <!-- 빠른메뉴 -->
          <hr style="color: #000; margin: 0 0 0.7rem" />
          <div class="container quick">
            <div class="row gx-2 text-center">
              <div class="col-3">
                <a href="/customerAsk">
                  <img src="../assets/img/new-test/m-ask.png" />
                  <p>1:1 문의</p>
                </a>
              </div>
              <div class="col-3">
                <a href="/requestQuotation">
                  <img src="../assets/img/new-test/m-group.png" />
                  <p>기업/단체 문의</p>
                </a>
              </div>
              <div class="col-3">
                <a href="/customerService">
                  <img src="../assets/img/new-test/m-question.png" />
                  <p>자주하는 질문</p>
                </a>
              </div>
              <div class="col-3">
                <img src="../assets/img/new-test/m-point.png" style="cursor: pointer" @click="goLink('page', 'pointList_client', '', '')" />
                <p>포인트 안내</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import MainRtRemote from "../components/Main_rtRemote.vue";
import { recentView } from "../assets/js/recentView";
import { toRaw } from 'vue'
import dayjs from 'dayjs';
import { nextTick } from 'vue';
import NoticeModal_hp from '@/components/NoticeModal_hp.vue';

import HotelSearchBar from '@/components/HotelSearchBar.vue';          // 라쿠텐제휴호텔검색

export default {
  components: {
    MainRtRemote,
    NoticeModal_hp,
    HotelSearchBar     //라쿠텐제휴호텔검색
  },
  data() {
    return {
      showNotice: false,          //공지노출여부
      noticeModals: [],           //공지모달관리

      //PC 메인캐러샐 이미지 정보
      slides: [
        //호시노리조트
        {
          image: require("@/assets/img/carousel/hoshino_pc.jpg"),
          // imageTxt: require("@/assets/img/carousel/bloodEvent_title.png"),
          alt: "Slide 0",
          type: "page",
          link: "hoshinoresort",
          pId: "",
          sRoute: "",
          text1: "",
          text2: "",
        },
        //멤버십
        {
          image: require("@/assets/img/carousel/membership_pc.jpg"),
          // imageTxt: require("@/assets/img/carousel/bloodEvent_title.png"),
          alt: "Slide 0",
          type: "page",
          link: "ndaytrip_membership_page",
          pId: "",
          sRoute: "",
          text1: "",
          text2: "",
        },
        //부관-신칸센2
        {
          image: require("@/assets/img/carousel/puk_shin2_pc.png"),
          // imageTxt: require("@/assets/img/carousel/samsunZZ_title.png"),
          alt: "Slide 1",
          type: "product",
          link: "",
          pId: "F-2681372XZC",
          sRoute: "F",
          text1: "",
          text2: "",
        },
        //소방관 감사
        {
          image: require("@/assets/img/carousel/ffBanner_PC.png"),
          // imageTxt: require("@/assets/img/carousel/bloodEvent_title.png"),
          alt: "Slide 0",
          type: "page",
          link: "fireFighter",
          pId: "",
          sRoute: "",
          text1: "",
          text2: "",
        },
        //가와구치호
        {
          image: require("@/assets/img/carousel/gawaguchi_pc.jpg"),
          // imageTxt: require("@/assets/img/carousel/bloodEvent_title.png"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "L-264859BPC",
          sRoute: "L",
          text1: "",
          text2: "",
        },
        //비와호히코네성
        {
          image: require("@/assets/img/carousel/biwahonagoya_pc.jpg"),
          // imageTxt: require("@/assets/img/carousel/bloodEvent_title.png"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "L-2652846GQC",
          sRoute: "L",
          text1: "",
          text2: "",
        },
        //비와호교토
        {
          image: require("@/assets/img/carousel/biwaho_pc.jpg"),
          // imageTxt: require("@/assets/img/carousel/bloodEvent_title.png"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "L-2652858ALC",
          sRoute: "L",
          text1: "",
          text2: "",
        },
        //금상첨카
        {
          image: require("@/assets/img/carousel/gcCar_pc.png"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "L-2621037NYC",
          sRoute: "L",
          text1: "",
          text2: "",
        },
        //효도한척
        {
          image: require("@/assets/img/carousel/retro_pc.gif"),
          // imageTxt: require("@/assets/img/carousel/samsunZZ_title.png"),
          alt: "Slide 1",
          type: "page",
          link: "retroShip",
          pId: "",
          sRoute: "",
          text1: "",
          text2: "",
        },
      ],

      //모바일 탑캐러샐 이미지 정보
      topSlides: [
        //호시노리조트
        {
          image: require("@/assets/img/AppImg/topCarousel/hoshino_mo.jpg"),
          alt: "Slide 0",
          type: "page",
          link: "hoshinoresort",
          pId: "",
          sRoute: "",
          text1: "",
          text2: "",
        },        
        //멤버십
        {
          image: require("@/assets/img/AppImg/topCarousel/membership_mo.jpg"),
          alt: "Slide 0",
          type: "page",
          link: "ndaytrip_membership_page",
          pId: "",
          sRoute: "",
          text1: "",
          text2: "",
        },
        //부관-신칸센2
        {
          image: require("@/assets/img/AppImg/topCarousel/puk_shin2_mo.png"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "F-2681372XZC",
          sRoute: "F",
          text1: "",
          text2: "",
        },
        //소방관 감사
        {
          image: require("@/assets/img/AppImg/topCarousel/ffBanner_MO.png"),
          alt: "Slide 0",
          type: "page",
          link: "fireFighter",
          pId: "",
          sRoute: "",
          text1: "",
          text2: "",
        },
        //가와구치호
        {
          image: require("@/assets/img/AppImg/topCarousel/gawaguchi_mo.jpg"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "L-264859BPC",
          sRoute: "L",
          text1: "",
          text2: "",
        },
        //비와호히코네성
        {
          image: require("@/assets/img/AppImg/topCarousel/biwahonagoya_mo.jpg"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "L-2652846GQC",
          sRoute: "L",
          text1: "",
          text2: "",
        },
        //비와호교토
        {
          image: require("@/assets/img/AppImg/topCarousel/biwaho_mo.jpg"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "L-2652858ALC",
          sRoute: "L",
          text1: "",
          text2: "",
        },
        //금상첨카
        {
          image: require("@/assets/img/AppImg/topCarousel/gcCar_mo.jpg"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "L-2621037NYC",
          sRoute: "L",
          text1: "",
          text2: "",
        },
        //효도한척
        {
          image: require("@/assets/img/AppImg/topCarousel/retro_mo.gif"),
          alt: "Slide 0",
          type: "page",
          link: "retroShip",
          pId: "",
          sRoute: "",
          text1: "",
          text2: "",
        },
      ],

      //모바일 미들캐러샐 이미지 정보
      midSlides: [
        {
          image: require("@/assets/img/AppImg/midCarousel/midBanner01.png"),
          alt: "Slide 0",
          type: "product",
          link: "",
          pId: "L-2023220-1676865317720",
          sRoute: "L",
        },
        {
          image: require("@/assets/img/AppImg/midCarousel/midBanner02.png"),
          alt: "Slide 1",
          type: "product",
          link: "",
          pId: "L-2023221-1676943535719",
          sRoute: "L",
        },
        {
          image: require("@/assets/img/AppImg/midCarousel/midBanner03.png"),
          alt: "Slide 2",
          type: "product",
          link: "",
          pId: "L-202346-1680743217094",
          sRoute: "L",
        },
      ],

      // 모바일 그루핑 테마 캐러셀 이미지 정보
      grSlides: [
        {
          image: require("@/assets/img/AppImg/grCarousel/grp1.jpg"),
          alt: "Slide 1",
          grNo: "1",
          text1: "오사카",
          text2: "Fot Family Trip!",
        },
        {
          image: require("@/assets/img/AppImg/grCarousel/grp03.png"),
          alt: "Slide 3",
          grNo: "2",
          text1: "배",
          text2: "Fot Sweet Couple♡",
        },        
        {
          image: require("@/assets/img/AppImg/grCarousel/grp3.png"),
          alt: "Slide 0",
          grNo: "3",
          text1: "온천이미지",
          text2: "Fot Hot Winter!",
        },
      ],

      grIndex: 0,
      currentSlideIndex: 0, //모바일 그루핑캐러셀의 현재화면인덱스
      productListForSales_grFin: [],
      productListForSales_gr: [], //그루핑상품 리스트

      ////PC 그루핑 상품 스크롤베너
      currentIndex: 0,
      rotationInterval: null,
      isPaused: false,
      hoveredIndex: null, //마우스가 올라간 배너이미지 인덱스

      // 상품상하스크롤처리
      currentPage: 1,
      itemsPerPage: 4, // 페이지당 표시할 상품 수(카테고리 연동상품)
      animationDirection: "slide-up", // 기본 애니메이션 방향


      // new 가격옵션 시스템 기반
      new_productListForSales: [],                                // 게시상품 리스트
      pdt_bustour: [],                                            //버스투어 상품리스트
      new_productListForSales_mid: [],                            //엔데트 상품정보

      new_productListForSales_golf: [],                           //골프팩
      new_productListForSales_golf_mdChoice: [],                  //추천골프팩

      new_productListForSales_ntabi: [],                          //엔타비단독기획
      new_productListForSales_ntabi_mdChoice: [],                 //엔타비추천상품

      new_productListForSales_ship: [],                           //선박상품
      new_productListForSales_ship_mdChoice: [],                  //선박추천상품

      new_productListForSales_best: [],                           //베스트아이템
      new_productListForSales_ndaytrip_mdChoice: [],              //엔데트추천상품
      new_productListForSales_new: [],                            //티켓패스상품(신규오픈에서 변경됨) 

      //상품 좌측리스트
      ////엔데트
      pCode: "",                                                  //상품코드
      pName: "",                                                  //상품명
      pArName: "",                                                //지역명
      pImgName: "",                   
      badgeF1: "",                                                //상품1뱃지 여부
      badgeF2: "",                                                //상품2뱃지 여부
      badge1: "",                                                 //상품1뱃지
      badge2: "",                                                 //상품2뱃지

      sellerFlag: "", //판매처(nt / nd)

      selectedPdtInfo: [],                     //엔데트 선택된 상품정보
      productListForSales_mid: [],             //엔데트 상품정보
      selFlag: "N",                            //엔데트 상품선택플래그


      recentFlag: "Y",                        //최근구경

      b2bTag: "",
      b2cTag: "",

      bustourArea: [],                        //선택가능한 버스투어지역
      ntToAr: {},                             //버스투어지역

      transportList: [],                      //선택가능한 교통편정보
      spToDt: {},                             //선박운항지

      tktPassArea: [],                        //선택가능한 티켓패스
      tpNtToAr: {},                           //티켓패스 이용지역

      recentViewInfo_m: [],                   //최근 본 상품정보(Mobile)

      touchStartX: 0,
      touchEndX: 0,
      scrollStartX: 0,

      noticeList: [], //공지사항 리스트
      showNoticeFlag: "N",
      nContent: "",
      ingEvent: [], //진행 중인 이벤트

      fixedPR: [], //홍보고정

      isTouched: false, //터치처리

      isOpenNo: 0,        //오픈회수

      more_nt: "N",
      more_nd: "",
      more_nr: "",
      more_vr: "",
      more_be: "N", //베스트상품


      vBannerIdx: 1,            //비디오배너 인덱스
      vBannerCnt: 1,            //비디오배너 갯수

      pushAri: false,           //푸시알림여부
      showAdBar_mo: true,       //앱다운로드바 표시여부
      showAdBar_pc: true,       //앱다운로드바 표시여부

      // 동영상 배너소스
      videos: [
        { src: require("@/assets/img/main/banner/ndtAdLow.mp4") },
        { src: require("@/assets/img/main/banner/membership_mid.mp4") },
        { src: require("@/assets/img/main/banner/newcamellia.mp4") },
      ],
      videoCsInstance: null,      // PC 캐러셀 인스턴스
      videoCsInstance_m: null,    // 모바일 캐러셀 인스턴스

      new_productListForSales_now: [],   //지금 뜨는 여행

      tsCurrentPage: 0,

      AccHotel: "No",                    // 호텔테스트용 임시플래그

      // 인스타그램 컨텐츠 (2026-10-30 / 관리자메뉴 Ma_InstaList에서 관리)
      instaProfileUrl: "https://www.instagram.com/ntabi_insta/",      // 엔타비 공식 인스타그램
      instaPostList: [],    // DB에서 조회한 게시중 리스트

      igCurrentPage: 0,     // 모바일 인스타 현재 카드 인덱스      
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    
    isActiveMember() {
      return this.$store.state.user?.isActiveMember === true
    },

    //모바일 탑캐러셀배너용
    visibleSlides() {
      const slides = this.slides;
      const prev = (this.currentIndex - 1 + slides.length) % slides.length;
      const next = (this.currentIndex + 1) % slides.length;
      return [slides[prev], slides[this.currentIndex], slides[next]];
    },

    pagedProductList() {
      if (!this.mobileDisplay) 
      {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return {
          mid: this.new_productListForSales_mid.slice(start, end)
          // mid: this.productListForSales_mid.slice(start, end),
        }
      }
     // 모바일에서는 그루핑 상품을 보여준다
      else 
      {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.productListForSales_grFin.slice(start, end);
      }
    },

    totalPages() {
      if (!this.mobileDisplay) 
      {
        return {
          mid: Math.ceil(this.new_productListForSales_mid.length / this.itemsPerPage),
          // mid: Math.ceil(this.productListForSales_mid.length / this.itemsPerPage),
        }
      } 
      else 
      {
        return Math.ceil(
          this.productListForSales_grFin.length / this.itemsPerPage
        );
      }
    },

    //pc그뤂핑 상품배너
    trackStyle() {
      return {
        transform: `translateX(-${this.activeIndex * 33.33}%)`,
      };
    },

    activeImageIndex() {
      return this.currentIndex;
    },

    // 모바일그루핑 활성화 배너인덱스
    activeGrIndex() {
      return this.currentSlideIndex;
    },

    //그루핑에서 호버된 인덱스
    activeIndex() {
      return this.hoveredIndex !== null ? this.hoveredIndex : this.currentIndex;
    },

    //공지팝업 노출여부 판단용 필터(v-for에 v-if병행 사용불가에 대응)
    filteredNoticeModals() {
      return this.noticeModals.filter(modal => this.shouldShowNotice(modal.content));
    },

    instaPosts() {
      return this.instaPostList.map((item) => ({
        id: item.igCode,
        url: `https://www.instagram.com/${item.igType}/${item.igCode}/`,
      }));
    },

    // 인스타그램 게시물 목록 (2026-10-13)
    // // URL에서 유형(p/reel/tv)과 shortcode를 추출하고, 공유용 파라미터(?utm_source 등)는 제거
    // instaPosts() {
    //   return this.instaUrls
    //     .map((url) => {
    //       const match = url.match(/instagram\.com\/(p|reel|tv)\/([^/?#]+)/);
    //       if (!match) return null;                 // 형식이 잘못된 주소는 제외
    //       const [, type, id] = match;
    //       return { id, url: `https://www.instagram.com/${type}/${id}/` };
    //     })
    //     .filter(Boolean);
    // },
  },

  created() {
    this.height = 700;

    // 호텔테스트용
    if(this.user.email === "paeksh@ntabi.co.kr") 
    {
      this.AccHotel = "OK"
      alert("호텔예약테스트용 계정으로 접속하셨습니다")
    }

    // 유저디바이스체크 (모바일처리용)
    if (this.$isMobile()) 
    {
      this.mobileDisplay = true;
    } 
    else 
    {
      this.mobileDisplay = false;
    }

    // path에서 사용된 productId
    this.user = this.$store.state.user;
    this.conEmail = this.user.email;
    //console.log("user:", this.user, "/", this.memberId, "/", this.conEmail);\

    this.getBasicPdtInfoList();       //판매상품 기본정보

    this.getInstaList();              //인스타그램 게시리스트 (2026-10-30)    

    //this.getProductList();
    this.getBustourArea();
    this.getTransportInfo();
    this.getTktPassArea()
    this.getNoticeList();             //공지&이벤트 리스트

    const today_tmp = dayjs();
    this.today = today_tmp.format('YYYY-MM-DD')

    // 컴포넌트 마운트 시, 노출 판단
    if (this.shouldShowNotice(this.noticeModals)) {
      this.showNotice = true;
    }    
  },

  mounted() {
    //console.log("isActiveMember:", this.isActiveMember)
    // 메인배너 이미지 엘리먼트 찾기(모바일X)
    if (!this.mobileDisplay) 
    {
      document.documentElement.style.setProperty("--topBanner-height", "700px");

      this.updateTopBannerHeight();
      window.addEventListener("resize", this.updateTopBannerHeight);

      window.addEventListener("scroll", this.handleScroll);

      //this.showNdt("ND"); //페이지 초기오픈

      //그루핑상품
      this.startRotation();

      // // 인스타그램 임베드 로딩
      // this.loadInstagramEmbed();
      this.$nextTick(() => {
        const vcEl = document.getElementById('videoCarousel');
        if (vcEl) 
        {
          // 캐러셀 인스탄스 생성
          this.videoCsInstance = new window.bootstrap.Carousel(vcEl, {
            interval: false,  // 타이머 자동전환 OFF
            ride: false       // 마운트 시 자동시작 OFF
          });

          // 슬라이드 전환 시 이전 영상 pause → 새 영상 play
          vcEl.addEventListener('slid.bs.carousel', (e) => {
            // 이전 영상 정지
            const prevRef = this.$refs[`videoRef_${e.from}`];
            const prevEl = Array.isArray(prevRef) ? prevRef[0] : prevRef;

            if (prevEl) { prevEl.pause(); prevEl.currentTime = 0; }

            // 현재 영상 재생
            const currRef = this.$refs[`videoRef_${e.to}`];
            const currEl = Array.isArray(currRef) ? currRef[0] : currRef;

            // 동영상 배너가 하나인 경우 복수인 경우 분기
            if (currEl) 
            {
              currEl.loop = this.videos.length === 1;
              currEl.play();
            }
          });

          // 첫 번째 영상 재생
          const firstRef = this.$refs['videoRef_0'];
          const firstEl = Array.isArray(firstRef) ? firstRef[0] : firstRef;
          if (firstEl) 
          {
            // 영상이 1개면 loop, 여러 개면 ended로 다음 전환
            firstEl.loop = this.videos.length === 1;
            firstEl.play();
          }
        }
      });
    } 
    else if (this.mobileDisplay) 
    {
      this.getBasicPdtInfoList();         //판매상품 기본정보
      //this.getProductList("X", "", "NT"); //엔타비가 추천하는 상품추출용

      const myCarousel = document.getElementById("carouselExampleControls_gr");
      myCarousel.addEventListener("slide.bs.carousel", (event) => {
        this.currentSlideIndex = event.to;

        // console.log("currentSlideIndex:::::::", this.currentSlideIndex)
        if (this.currentSlideIndex == 0) 
        {
          this.productListForSales_grFin = this.productListForSales_gr;
        } 
        else if (this.currentSlideIndex == 1) 
        {
          this.productListForSales_grFin = this.productListForSales_gr2;
        } 
        else if (this.currentSlideIndex == 2) 
        {
          this.productListForSales_grFin = this.productListForSales_gr3;
        } 
        else 
        {
          this.productListForSales_grFin = []
        }
      });
      // console.log("productListForSales_grFin:>>>>>", this.productListForSales_grFin)

      //모바일 탑캐러셀
      this.startTimer();

      // // 인스타그램 임베드 로딩 (모바일)
      // this.loadInstagramEmbed();

      this.$nextTick(() => {
        const vcEl_m = document.getElementById('videoCarousel_m');
        if (vcEl_m) 
        {
          this.videoCsInstance_m = new window.bootstrap.Carousel(vcEl_m, {
            interval: false,
            ride: false
          });

          vcEl_m.addEventListener('slid.bs.carousel', (e) => {
            const prevRef = this.$refs[`videoRef_m_${e.from}`];
            const prevEl = Array.isArray(prevRef) ? prevRef[0] : prevRef;
            if (prevEl) { prevEl.pause(); prevEl.currentTime = 0; }

            const currRef = this.$refs[`videoRef_m_${e.to}`];
            const currEl = Array.isArray(currRef) ? currRef[0] : currRef;
            if (currEl) currEl.play();
          });

          const firstRef = this.$refs['videoRef_m_0'];
          const firstEl = Array.isArray(firstRef) ? firstRef[0] : firstRef;
          if (firstEl) 
          {
            // 영상이 1개면 loop, 여러 개면 ended로 다음 전환
            firstEl.loop = this.videos.length === 1;
            firstEl.play();
          }
        }
      });
    }

    // nextTick을 써서 DOM이 v-for 등으로 완전히 그려진 뒤에 실행(모바일용 탑캐러셀 스와이핑처리용)
    nextTick(() => {
      const mTopCarousel = document.getElementById('carouselExampleControls');
      if (mTopCarousel) {
        new window.bootstrap.Carousel(mTopCarousel, {
          interval: 3000,
          touch: true,
          ride: 'carousel'
        });
      }
    });
    
    // 구동환경 체크
    if (window.Nachocode.env.isApp()) 
    {
      this.isApp = true;
      //console.log('isApp:', this.isApp);
    }
    else 
    {
      this.isApp = false;
      //console.log('isApp:', this.isApp);
    }

    if(window.Nachocode.device.isIOS()) 
    {
      this.iosFlag = true
      //console.log('iosFlag:', this.iosFlag);
    }
    else 
    {
      this.iosFlag = false
      //console.log('iosFlag:', this.iosFlag);
    }

    if (this.conEmail != undefined) {
      this.getRecentViewProduct(this.conEmail);
    }

    this.getIdxNo(); //비디오배너 인덱스 랜덤으로 선택

    // 푸시알림 확인
    this.checkPushHistory()

    // 공지팝업체크
    this.checkNotice();
  },

  beforeUnmount() {
    if (!this.mobileDisplay) 
    {
      window.removeEventListener("resize", this.updateTopBannerHeight);
      window.removeEventListener("scroll", this.handleScroll);
      clearInterval(this.rotationInterval);
    } 
    else if (this.mobileDisplay) 
    {
      //모바일 탑캐러샐
      this.stopTimer();
    }
  },

  watch: {
    topSlides() {
      nextTick(() => {
        const mTopCarousel = document.getElementById('carouselExampleControls');
        if (mTopCarousel) {
          new window.bootstrap.Carousel(mTopCarousel, {
            interval: 3000,
            touch: true,
            ride: 'carousel'
          });
        }
      });
    }
  },

  methods: {

    // 인스타그램 게시리스트 조회 → 데이터 반영 후 embed 처리
    async getInstaList() {
      let instaList = await this.$api("/api/selInstaList_main", {});
      this.instaPostList = Array.isArray(instaList) ? instaList : [];

      if (this.instaPostList.length > 0) {
        this.loadInstagramEmbed();    // 내부에서 nextTick으로 DOM 렌더 후 처리
      }
    },

    // 인스타그램 embed.js 로드 및 렌더링
    loadInstagramEmbed() {
      const render = () => {
        this.$nextTick(() => {
          if (window.instgrm && window.instgrm.Embeds) {
            window.instgrm.Embeds.process();
          }
        });
      };

      // 이미 로드된 경우 (SPA에서 메인으로 재진입 시)
      if (window.instgrm) {
        render();
        return;
      }

      // 로딩 중인 스크립트가 있으면 완료 후 렌더링
      const existing = document.getElementById("instagram-embed-js");
      if (existing) {
        existing.addEventListener("load", render);
        return;
      }

      const script = document.createElement("script");
      script.id = "instagram-embed-js";
      script.async = true;
      script.src = "https://www.instagram.com/embed.js";
      script.onload = render;
      document.body.appendChild(script);
    },

    // 모바일 인스타: 스와이프 시 현재 페이지 갱신
    igUpdatePage() {
      const wrap = this.$refs.igScroll_m;
      if (!wrap || !wrap.children.length) return;
      const cardW = wrap.children[0].offsetWidth + 12;   // gap 포함
      this.igCurrentPage = Math.round(wrap.scrollLeft / cardW);
    },

    // 모바일 인스타: 이전/다음 버튼
    igMovePage(dir) {
      const wrap = this.$refs.igScroll_m;
      if (!wrap || !wrap.children.length) return;
      const total = this.instaPosts.length;
      const next = Math.max(0, Math.min(total - 1, this.igCurrentPage + dir));
      const cardW = wrap.children[0].offsetWidth + 12;
      wrap.scrollTo({ left: next * cardW, behavior: "smooth" });
      this.igCurrentPage = next;
    },
    //지금 뜨는 여행 모바일용
    updatePage() {
      const wrap = this.$refs.tsScroll;
      if (!wrap || !wrap.children.length) return;
      const cardW = wrap.children[0].offsetWidth + 10; // gap 포함
      this.tsCurrentPage = Math.round(wrap.scrollLeft / cardW);
    },

    movePage(dir) {
      const wrap = this.$refs.tsScroll;
      const total = this.new_productListForSales_now.length;
      const next = Math.max(0, Math.min(total - 1, this.tsCurrentPage + dir));
      const cardW = wrap.children[0].offsetWidth + 10;
      wrap.scrollTo({ left: next * cardW, behavior: 'smooth' });
      this.tsCurrentPage = next;
    },

    // getRemainTime(endDate) {
    //   // endDate가 없으면 빈 문자열
    //   if (!endDate) return '';
    //   const diff = new Date(endDate) - new Date();
    //   if (diff <= 0) return '마감';
    //   const d = Math.floor(diff / 86400000);
    //   const h = Math.floor((diff % 86400000) / 3600000).toString().padStart(2,'0');
    //   const m = Math.floor((diff % 3600000) / 60000).toString().padStart(2,'0');
    //   const s = Math.floor((diff % 60000) / 1000).toString().padStart(2,'0');
    //   return d > 0 ? `${d}일 ${h}:${m}:${s} 남음` : `${h}:${m}:${s} 남음`;
    // },


    // video banner 종료 후 다음으로
    onVideoEnded() {
      if (this.videoCsInstance) 
      {
        this.videoCsInstance.next();
      }
    },

    onVideoEnded_m() {
      if (this.videoCsInstance_m) 
      {
        this.videoCsInstance_m.next();
      }
    },

    // 공지제목 표시제한
    formatTitle(title) {
      if (!title) return '';
      const max = 30; // 30자 기준
      return title.length > max ? title.slice(0, max) + '...' : title;
    },

    //공지모달 팝업열기체크 (그만보기관련)
    shouldShowNotice(content) {
      const key = `hideNotice_${content}`;
      const expire = localStorage.getItem(key);
      if (expire) {
        // 값이 있고 아직 오늘 안 지났으면 안 띄움
        return new Date().getTime() > Number(expire);
      }
      // 값이 없으면 항상 띄움
      return true;
    },

    // 공지사항 표시 처리 (쿠키 기능 제거)
    async checkNotice() {
      let checkNotice = await this.$api("/api/checkNotice_pop", {});
      //console.log("checkNotice::::", checkNotice);

      if (checkNotice.length > 0) 
      {
        const newModals = checkNotice.map((notice) => ({
          id: notice.noticeCode,
          content: notice.noticeCode+".md"
        }));

        // 기존 배열을 완전히 비우고 새로운 데이터로 채우기
        this.noticeModals.splice(0, this.noticeModals.length, ...newModals);
      } 
      else 
      {
        // 데이터가 없으면 배열 비우기
        this.noticeModals.splice(0, this.noticeModals.length);
      }
      //console.log("noticeModal:>>>>", this.noticeModals);
    },

    // 닫기 이벤트: 해당 인덱스의 팝업만 제거
    handleNoticeClose(id) {
      this.noticeModals = this.noticeModals.filter(m => m.id !== id);
    },

    // adBar닫기
    closeAdBar() {
      this.showAdBar_mo = false
      this.showAdBar_pc = false
    },

    async checkPushHistory() {
      let pushList_tmp = await this.$api("/api/selPushHistory_unRead", { param: [this.conEmail] });
      if(pushList_tmp.length > 0) 
      {
        this.pushAri = true
      }
    },

    // 판매상품 기본정보
    async getBasicPdtInfoList() {
      let new_productListForSales = await this.$api("/api/productPrcInfo_m_new", {})

      let new_productListForSalesForGR = []

      if(new_productListForSales.length > 0 ) {
        new_productListForSalesForGR = new_productListForSales;
        this.new_productListForSales = new_productListForSales;
      }
      //("new_productListForSales:", this.new_productListForSales);

      //엔데이트립 버스투어 분리추출
      let newPdt_l = this.new_productListForSales.filter((item) => {
        // return item.salesRoute === "L";
        return item.pdtCate && item.pdtCate.includes("L");          // 판매카테고리 자유화 대응
      });
      if(newPdt_l.length > 0) {
        this.pdt_bustour = newPdt_l;
        this.new_productListForSales_mid = newPdt_l
      }
      //console.log("new_productListForSales_mid:", this.new_productListForSales_mid); 

      //엔데이트립 추천(mobile)
      this.new_productListForSales_ndaytrip_mdChoice = this.new_productListForSales_mid.filter((item) => {
        return item.mdChoice === "Y";
      });

      //상품선택이 없는 경우, 기본상품표시처리
      //// 엔데트
      if (this.new_productListForSales_mid.length > 0) 
      {
        if(this.selFlag === "N")
        {
          this.selectedPdtInfo = this.new_productListForSales_mid[0];
        }
        else
        {
          this.selectedPdtInfo = this.new_productListForSales_mid
        }
      }

      //골프팩
      let new_productListForSales_golf = this.new_productListForSales.filter((item) => {
        return item.golfFlag == "Y" || (item.pdtCate && item.pdtCate.includes("G"));          // 판매카테고리 자유화 대응
        // return (item.golfFlag == "Y")   //only golfFlag
      });
      if(new_productListForSales_golf.length > 0) 
      {
        this.new_productListForSales_golf = new_productListForSales_golf;
      }
      // console.log("new_productListForSales_golf:>>>>", this.new_productListForSales_golf)


       // 골프팩 + 추천상품
      let new_productListForSales_golf_mdChoice = this.new_productListForSales_golf.filter((item) => {
        return item.mdChoice === "Y";
      });
      if(new_productListForSales_golf_mdChoice.length > 0) 
      {
        this.new_productListForSales_golf_mdChoice = new_productListForSales_golf_mdChoice;
      }
      // console.log("new_productListForSales_golf_mdChoice::::", this.new_productListForSales_golf_mdChoice)


      //엔타비 + 버라이어티팩
      let new_productListForSales_ntabi = this.new_productListForSales.filter((item) => {
        // return ((item.golfFlag == null || item.golfFlag == 'N') && item.salesRoute == 'T');   //골프상품X + 엔데트X + 엔타비O
        // return (item.sellerCode_nt === "Y" && item.vrFlag === "Y" && item.salesRoute != "F" && item.salesRoute != "E" && item.salesRoute != "L");   //선박과 기타상품 제외
        return (item.vrFlag === "Y");   //선박과 기타상품 제외
      });
      this.new_productListForSales_ntabi = new_productListForSales_ntabi;
      //console.log("new_productListForSales_ntabi:>>>>", this.new_productListForSales_ntabi)

      //this.productListForSales_mid_vr = this.productListForSales_ntabi;

       // 엔타비+버라이어티 추천
      this.new_productListForSales_ntabi_mdChoice = this.new_productListForSales_ntabi.filter((item) => {
        return item.mdChoice === "Y";
      });

      //일본선박
      let new_productListForSales_ship = this.new_productListForSales.filter((item) => {
        //return (item.salesRoute == "F")   //only F Route
        return item.pdtCate && item.pdtCate.includes("F");          // 판매카테고리 자유화 대응
      });
      this.new_productListForSales_ship = new_productListForSales_ship;
      //console.log("productListForSales_ship:>>>>", this.new_productListForSales_ship)

      //베스트상품
      let new_productListForSales_best = this.new_productListForSales.filter((item) => {
        return item.bestFlag === "Y";
      });
      this.new_productListForSales_best = new_productListForSales_best;

      //지금 뜨는 여행
      let new_productListForSales_now = this.new_productListForSales.filter((item) => {
        return item.uSetFlag === "Y";
      });
      this.new_productListForSales_now = new_productListForSales_now;

      //console.log("new_productListForSales_now:>>>>", this.new_productListForSales_now)

      //그루핑된 상품정보 추출(3개 그룹)
      //필터링 후 시간역순으로 정렬하고 4개까지만 추출
      this.productListForSales_gr = new_productListForSalesForGR
        .filter(item => item.grNo === "Y")
        .sort((a, b) => new Date(b.grDate) - new Date(a.grDate))
        .slice(0, 4);

      this.productListForSales_gr2 = new_productListForSalesForGR
        .filter(item => item.grNo2 === "Y")
        .sort((a, b) => new Date(b.grDate2) - new Date(a.grDate2))
        .slice(0, 4);

      this.productListForSales_gr3 = new_productListForSalesForGR
        .filter(item => item.grNo3 === "Y")
        .sort((a, b) => new Date(b.grDate3) - new Date(a.grDate3))
        .slice(0, 4);

      //금월추천 -> 패스류로 변경(20250331)
      // this.productListForSales_new = productListForSales_tmp.filter((item) => {
      //   return (item.newFlag === "Y" && new Date(item.newDate).getMonth() === new Date().getMonth() && new Date(item.newDate).getFullYear() === new Date().getFullYear());
      // });

      this.new_productListForSales_new = new_productListForSalesForGR.filter((item) => {
        return (item.salesRoute == "E");
      });
    },

     // 상품문의
    inquiryProduct(pCode, sRoute) {
      this.$router.push({path: '/inquiryProduct', query: {productId: pCode, salesRoute:sRoute}});
    },


    //동영상 배너선택
    getIdxNo(){
      if(this.vBannerCnt === 1)
      {
        this.vBannerIdx = 0;
      }
      else if(this.vBannerCnt === 2)
      {
        let vBannerIdx =  Math.floor(Math.random() * 2);
        this.vBannerIdx = vBannerIdx == 0 ? 1 : 0;
      }
    },

    //PC 그루핑상품
    startRotation() {
      this.rotationInterval = setInterval(() => {
        if (!this.isPaused) {
          this.currentIndex = (this.currentIndex + 1) % this.grSlides.length;
        }
      }, 10000);
    },

    //배너이미지에 마우스 호버시 호출
    handleMouseOver(index) {
      this.hoveredIndex = index;
      this.currentIndex = index;
      this.pauseRotation();
    },

    handleMouseLeave() {
      this.hoveredIndex = null;
      this.resumeRotation();
    },

    pauseRotation() {
      this.isPaused = true;
    },
    resumeRotation() {
      this.isPaused = false;
    },

    //모바일 탑캐러샐
    startTimer() {
      this.timer = setInterval(this.nextSlide, 5000);
    },
    stopTimer() {
      clearInterval(this.timer);
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    },

    updateTopBannerHeight() {
      this.height = this.$refs.mainBanner.offsetHeight;
      document.documentElement.style.setProperty(
        "--topBanner-height",
        `${this.height}px`
      );
    },

    async getNoticeList() {
      let noticeList_tmp = await this.$api("/api/noticeList_new_new", {});
      this.noticeList = noticeList_tmp

      //이벤트이미지 -> 썸네일 표시로 변경(20251029)
      let ingEvent = await this.$api("/api/thumbNailOfNotice", {});

      if (ingEvent.length > 0) 
      {
        this.ingEvent = ingEvent;
      }
      //console.log("ingEvent:", this.ingEvent)

      //상단고정홍보추출
      this.fixedPR = this.ingEvent.filter((item) => {
        return item.fixedPRFlag === "Y";
      });
    },

    goToLink(link) {
      window.open(link, "_blank");
    },

    //페이지이동
    goToPage(path) {
      switch (path) {
        case "JShip":
          this.$router.push({ path: "/shipTour" });
          break;

        case "MShip":
          this.$router.push({ path: "/ndaytrip_membership_page" });
          break;

        case "TkPass":
          this.$router.push({ path: "/tktPass" });
          break;

        case "BsTour":
          this.$router.push({ path: "/bustour" });
          break;

        case "NBus":
          this.$router.push({ path: "/nbus_mainpage" });
          break;

        case "NtVr":
          // this.$router.push({ path: "/subList", query: { nt: "JP"} });
          this.$router.push({ path: "/exhibitionEvent"});
          break;

          case "PKG":
          this.$router.push({ path: "/subList", query: { nt: "JP"} });
          break;

          case "Golf":
          this.$router.push({ path: "/golfTour" });
          break;

          case "EVT":
          this.$router.push({ path: "/bloodevent" });
          break;
      }
    },

    //선택가능한 버스투어 지역정보
    async getBustourArea() {
      let salesRoute = "L"
      let bustourArea = await this.$api("/api/getBustourArea", {param: [ salesRoute ]});

      let ntToAr = {};

      if (bustourArea.length > 0) {
        this.bustourArea = bustourArea;
        //국가별 지역으로 정리
        bustourArea.forEach((item) => {
          if (!ntToAr[item.ntCd]) {
            ntToAr[item.ntCd] = [];
          }
          ntToAr[item.ntCd].push({
            ntCd: item.ntCd,
            arCd: item.arCd,
            NT: item.NT,
            AR: item.AR,
          });
        });
      }
      this.ntToAr = ntToAr;
      //console.log("ntToAr:", this.ntToAr);
    },

    //선택가능한 티켓패스 지역정보
    async getTktPassArea() {
      let salesRoute = "E";
      let tktPassArea = await this.$api("/api/getTktPassArea", {
        param: [salesRoute],
      });

      let tkNtToAr = {};

      if (tktPassArea.length > 0) {
        this.tktPassArea = tktPassArea;
        //국가별 지역으로 정리
        tktPassArea.forEach((item) => {
          if (!tkNtToAr[item.ntCd]) {
            tkNtToAr[item.ntCd] = [];
          }
          tkNtToAr[item.ntCd].push({
            ntCd: item.ntCd,
            arCd: item.arCd,
            NT: item.NT,
            AR: item.AR,
          });
        });
      }
      this.tkNtToAr = tkNtToAr;
      //console.log("tkNtToAr:>>>>>>", this.tkNtToAr);
    },

    //선택가능한 선박
    async getTransportInfo() {
      //선박상품용 변수
      let ctCode = "SHP";
      let uFlag = "Y";
      let rtCode = "JP";

      let transportList = await this.$api("/api/transportList", {
        param: [ctCode, uFlag, rtCode],
      });

      let spToDt = {};

      if (transportList.length > 0) {
        //console.log("transportList:", transportList)
        this.transportList = transportList;
        //운항지별로 정리
        transportList.forEach((item) => {
          if (!spToDt[item.dtCode]) {
            spToDt[item.dtCode] = [];
          }
          spToDt[item.dtCode].push({
            dtCd: item.dtCode, //운항지코드
            trCd: item.transCode, //선박코드
            DT: item.destName, //운항지명
            TR: item.transName, //선박명
          });
        });
      }
      this.spToDt = spToDt;
      //console.log("spToDt:", this.spToDt)
    },

    // goToBustour() {
    //   this.$router.push({ path: "/bustour", query: {} });
    // },

    // 최근 본 상품
    async getRecentViewProduct(mId) {
      let recentViewInfo = await this.$api("/api/proc_viewRecentProduct", {
        param: [mId],
      });

      //console.log("recentViewInfo:", recentViewInfo)

      if (recentViewInfo.length > 0) {
        this.recentViewInfo = recentViewInfo[0];
        this.recentViewInfo_m = recentViewInfo[0].slice(0, 2);
      }
    },

    // //중간상품이미지 상하스크롤처리
    // nextPage() {
    //   if (this.currentPage < this.totalPages) {
    //     this.currentPage++;
    //   }
    // },
    // prevPage() {
    //   if (this.currentPage > 1) {
    //     this.currentPage--;
    //   }
    // },

    changePage(direction) {
      if (direction === "prev" && this.currentPage > 1) 
      {
        this.animationDirection = "slide-down"; // 이전 버튼: 아래로 이동
        this.currentPage--;
      } 
      else if (direction === "next" && (this.currentPage < this.totalPages.mid || this.currentPage < this.totalPages.mid_vr)) 
      {
        this.animationDirection = "slide-up"; // 다음 버튼: 위로 이동
        this.currentPage++;
      }
    },

    //엔타비 마우스오버
    setHoveredProduct(pCode, pName, pArName, pImgName, badgeF1, badge1, badgeF2, badge2) {   //pCat: 상품카테고리(ND,VR,SH)
      this.selFlag = "Y"
      this.pCode = pCode;
      this.pName = pName;
      this.pArName = pArName;
      this.pImgName = pImgName;
      this.badgeF1 = badgeF1 ?? "";
      this.badge1 = (this.badgeF1 == "N" || this.badgeF1 == "" || !this.badgeF1) ? null : badge1;
      this.badgeF2 = badgeF2 ?? "";
      this.badge2 = (this.badgeF2 == "N" || this.badgeF2 == "" || !this.badgeF2) ? null : badge2;

      let selectedPdtInfo = this.new_productListForSales_mid.filter((item) => {
        return item.pdtCode === pCode
      });

      // //old code
      // let selectedPdtInfo = this.productListForSales_mid.filter((item) => {
      //   return item.pdtCode === pCode
      // });

      //proxy해제
      this.selectedPdtInfo = toRaw(selectedPdtInfo[0]);
      
      //console.log("selectedPdtInfo:", this.selectedPdtInfo, "badge:", this.badge1, this.badge2)
    },

    handleScroll() {
      const rtRemoteContainer = this.$refs.rtRemoteContainer;
      const bannerEnd = document.getElementById("bannerEnd");

      if (rtRemoteContainer && bannerEnd) {
        const bannerEndPosition =
          bannerEnd.getBoundingClientRect().top + window.scrollY;
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const containerHeight = rtRemoteContainer.offsetHeight;

        if (scrollPosition + windowHeight > bannerEndPosition) {
          const newBottomPosition = Math.max(
            30,
            bannerEndPosition - scrollPosition - containerHeight
          );
          rtRemoteContainer.style.bottom = `${newBottomPosition}px`;
          rtRemoteContainer.style.position = "absolute";
        } else {
          rtRemoteContainer.style.bottom = "30px";
          rtRemoteContainer.style.position = "fixed";
        }
      }
    },

    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    toB2CLoginPage() {
      location.href = "/b2cLogin";
    },

    //to-do: 일단 통합로그아웃(향후 분기하여 네이버 전용로그아웃 구성할 것-20220616)
    toB2CLogout() {
      window.Kakao.Auth.logout(() => {
        this.$store.commit("user", {}); // 로그아웃->카카오유저 정보를 빈값으로 대체

        window.sessionStorage.clear(); // 로그아웃->세션스토리지를 모두 삭제
        window.localStorage.clear();
        //console.log(response);
      });
      this.$api("/api/logoutB2C", {});

      // //나쵸코드 푸시용
      // this.onLogout(this.conEmail);
      var swal = require("sweetalert2");
      swal.fire({
        text: "안전하게 로그아웃되었습니다.",
        icon: "success",
      });

      //로그아웃 후, 리로드를 시킨 후 메인으로 보낸다
      //location.href = "/"
      localStorage.setItem("reloadCheck", "true");
      this.$router.push({ path: "/" }); // 로그아웃->메인페이지로
    },

    onLogout(userId) {
      alert(userId + "님의 푸시토큰을 삭제합니다.")
      window.Nachocode.push.deletePushToken(userId).then((result) => {
        if (result.status === 'success') 
        {
          console.log('유저 푸시 토큰이 성공적으로 삭제되었습니다.');
        } 
        else 
        {
          console.error(`푸시 토큰 삭제 실패: ${result.message}`);
        }
      });
    },

    toMembership() {
      location.href = "/membership";
    },

    kakaoLogin() {
      window.Kakao.Auth.login({
        scope: "profile, account_email, gender, birthday",
        success: this.getProfile,
      });
    },

    goLink(type, link, pId, sR) {
      if (type === "page") 
      {
        this.$router.push({ path: `/${link}` });
      } 
      else if (type === "product") 
      {
        this.$router.push({
          path: "/detail",
          query: { productId: pId, salesRoute: sR },
        });
      } 
      else if (type === "Ntabi") 
      {
        this.$router.push({ path: "/subList", query: { nt: "JP" } });
      }
      else if (type === "asso_jinair") 
      {
        this.$router.push({ path: "/bustour_asso", query: { assoFlag: "lj" } });
      }
      // else if (type === "earlyBus") 
      // {
      //   this.$router.push({ path: "/bustour", query: { nt: "JP", ar: "OSA" } });
      // }
    },

    // 화면해상도 1300px 이하에서 작동
    goLink2(type, link, pId, sR) {
      if (window.innerWidth <= 1300) 
      {
        if (type === "page") 
        {
          this.$router.push({ path: `/${link}` });
        } 
        else if (type === "product") 
        {
          this.$router.push({
            path: "/detail",
            query: { productId: pId, salesRoute: sR },
          });
        } 
        else if (type === "Ntabi") 
        {
          this.$router.push({ path: "/subList", query: { nt: "JP" } });
        }
        else if (type === "asso_jinair") 
        {
          this.$router.push({ path: "/bustour_asso", query: { assoFlag: "lj" } });
        }
        // else if (type === "earlyBus") 
        // {
        //   this.$router.push({ path: "/bustour", query: { nt: "JP", ar: "OSA" } });
        // }
      }
    },

    toMyPage() {
      location.href = "/myPage";
    },

    //기업/단체문의
    toReqQuotation() {
      location.href = "/requestQuotation";
    },

    async goToDetail(productId, salesRoute) {
      if (this.user.email != undefined) 
      {
        await recentView(this.$api, this.user.email, productId);
      
      }
      this.$router.push({
        path: "/detail",
        query: { productId: productId, salesRoute: salesRoute },
      });
    },

    //상단 메뉴카테고리 선택 대응
    // showNdt(flag) {
    //   this.selFlag = "N"; //상품선택플래그
    //   this.currentPage = 1; //1페이지로 이동
    //   this.sellerFlag = this.sellerFlag == "" ? "ND" : flag;
    //   this.getProductList("", "", this.sellerFlag);
    // },

    scrollToElement(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
   

    onTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.scrollStartX = this.$refs.scrollingContent_m.scrollLeft;
    },

    onTouchMove(event) {
      event.preventDefault(); // 기본 스크롤 동작 방지
      const touchCurrentX = event.touches[0].clientX;
      const diff = this.touchStartX - touchCurrentX;
      this.$refs.scrollingContent_m.scrollLeft = this.scrollStartX + diff;
    },

    onTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > 50) {
        // 50px 이상 스와이프 했을 때만 페이지 전환
        if (diff > 0) {
          // 왼쪽으로 스와이프
          console.log("Swiped left");
        } else {
          // 오른쪽으로 스와이프
          console.log("Swiped right");
        }
      }
    },

    onTouchStart_nday(event) {
      this.touchStartX = event.touches[0].clientX;
      this.scrollStartX = this.$refs.scrollingContent_nday.scrollLeft;
    },

    onTouchMove_nday(event) {
      event.preventDefault(); // 기본 스크롤 동작 방지
      const touchCurrentX = event.touches[0].clientX;
      const diff = this.touchStartX - touchCurrentX;
      this.$refs.scrollingContent_nday.scrollLeft = this.scrollStartX + diff;
    },

    onTouchEnd_nday(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > 50) {
        // 50px 이상 스와이프 했을 때만 페이지 전환
        if (diff > 0) {
          // 왼쪽으로 스와이프
          console.log("Swiped left");
        } else {
          // 오른쪽으로 스와이프
          console.log("Swiped right");
        }
      }
    },

    onTouchStart_new(event) {
      this.touchStartX = event.touches[0].clientX;
      this.scrollStartX = this.$refs.scrollingContent_new.scrollLeft;
    },

    onTouchMove_new(event) {
      event.preventDefault(); // 기본 스크롤 동작 방지
      const touchCurrentX = event.touches[0].clientX;
      const diff = this.touchStartX - touchCurrentX;
      this.$refs.scrollingContent_new.scrollLeft = this.scrollStartX + diff;
    },

    onTouchEnd_new(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > 50) {
        // 50px 이상 스와이프 했을 때만 페이지 전환
        if (diff > 0) {
          // 왼쪽으로 스와이프
          console.log("Swiped left");
        } else {
          // 오른쪽으로 스와이프
          console.log("Swiped right");
        }
      }
    },

    onTouchStart_ship(event) {
      this.touchStartX = event.touches[0].clientX;
      this.scrollStartX = this.$refs.scrollingContent_ship.scrollLeft;
    },

    onTouchMove_ship(event) {
      event.preventDefault(); // 기본 스크롤 동작 방지
      const touchCurrentX = event.touches[0].clientX;
      const diff = this.touchStartX - touchCurrentX;
      this.$refs.scrollingContent_ship.scrollLeft = this.scrollStartX + diff;
    },

    onTouchEnd_ship(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > 50) {
        // 50px 이상 스와이프 했을 때만 페이지 전환
        if (diff > 0) {
          // 왼쪽으로 스와이프
          console.log("Swiped left");
        } else {
          // 오른쪽으로 스와이프
          console.log("Swiped right");
        }
      }
    },


    scrollLeft_btn(pCat) {
      let container = ""
      let itemWidth = ""

      if(pCat === "BE")
      {
        container = this.$refs.scrollingContent_best.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".bestItems").offsetWidth;
      }

      if(pCat === "VR")
      {
        container = this.$refs.scrollingContent_VR.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".vrItems").offsetWidth;
      }

      if(pCat === "SH")
      {
        container = this.$refs.scrollingContent_SH.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".shItems").offsetWidth;
      }

      //신규골프상품
      if(pCat === "GF")
      {
        container = this.$refs.scrollingContent_GF.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".gfItems").offsetWidth;
      }

      //지금 뜨는 여행
      if(pCat === "NW")
      {
        container = this.$refs.scrollingContent_NW.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".nwItems").offsetWidth;
      }
      
      //인스타그램
      if(pCat === "IG")
      {
        container = this.$refs.scrollingContent_IG.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".igItems").offsetWidth;
      }

      container.scrollBy({
        left: -itemWidth,
        behavior: "smooth",
      });
    },


    scrollRight_btn(pCat) {
      let container = ""
      let itemWidth = ""

      if(pCat === "BE")
      {
        container = this.$refs.scrollingContent_best.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".bestItems").offsetWidth;
      }

      if(pCat === "VR")
      {
        container = this.$refs.scrollingContent_VR.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".vrItems").offsetWidth;
      }

      if(pCat === "SH")
      {
        container = this.$refs.scrollingContent_SH.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".shItems").offsetWidth;
      }

      if(pCat === "GF")
      {
        container = this.$refs.scrollingContent_GF.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".gfItems").offsetWidth;
      }

      if(pCat === "NW")
      {
        container = this.$refs.scrollingContent_NW.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".nwItems").offsetWidth;
      }

      //인스타그램
      if(pCat === "IG")
      {
        container = this.$refs.scrollingContent_IG.querySelector(".scrolling-content");
        itemWidth = container.querySelector(".igItems").offsetWidth;
      }
      container.scrollBy({
        left: itemWidth,
        behavior: "smooth",
      });
    },

    //공지화면에 보이기 -> 공지리스트로 이동
    showArea(j) {
      this.$router.push({path: "/customerNotice", query: { nCode: j }});

      // 아코디언식 표시는 삭제(20250708)
      // document.querySelectorAll(".nContent").forEach((item) => {
      //   item.style.display = "none";
      // });

      // this.showNoticeFlag = this.showNoticeFlag === "Y" ? "N" : "Y";

      // //선택된 항목만 보이도록
      // if (this.showNoticeFlag == "Y") {
      //   document.getElementById(j).style.display = "block";
      // } else {
      //   document.getElementById(j).style.display = "none";
      // }
    },
  },
};
</script>

<style>
:root {
  --color-primary:    #86cd53;
  --color-primary-light: #B8E88A;
  --color-primary-pale:  #EDF7E3;

  --color-dark:       #1A2E0A;
  --color-dark-mid:   #2A4A14;
  --color-dark-light: #3D6B1F;

  --color-cream:      #F8FBF4;
  --color-white:      #FFFFFF;
  --color-text:       #1E2A14;
  --color-text-muted: #6B8A5A;
  --color-border:     #D4EAC0;

  --color-shadow:     rgba(26, 46, 10, 0.10);
  --color-shadow-md:  rgba(26, 46, 10, 0.18);
  --color-shadow-lg:  rgba(26, 46, 10, 0.28);

  /* 기존 navy 변수명도 매핑 (기존 CSS 호환) */
  --color-navy:       #1A2E0A;
  --color-navy-mid:   #2A4A14;
  --color-navy-light: #3D6B1F;
  --color-gold:       #86cd53;
  --color-gold-light: #B8E88A;
  --color-gold-pale:  #EDF7E3;

  --font-display: 'Cormorant Garamond', 'Noto Serif KR', serif;
  --font-body:    'Pretendard-Regular', 'SUIT-Regular', sans-serif;
  --font-accent:  'Freesentation-9Black', sans-serif;

  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 20px;
  --radius-xl: 30px;

  --transition:      all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: all 0.65s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>


<style scoped>

/* Bootstrap 우선순위 오버라이드 */
#newMain .card {
  border-radius: var(--radius-lg) !important;
  border: none !important;
  box-shadow: 0 4px 20px var(--color-shadow) !important;
}

#newMain .card-body {
  background: transparent !important;
}

/* ============================================================
   NTABI MAIN PAGE — REDESIGNED STYLE
   Aesthetic: Luxury Editorial Travel | Navy × Cream × Gold
   ============================================================ */

@import url("https://cdn.rawgit.com/moonspam/NanumSquare/master/nanumsquare.css");
@import url("https://fonts.googleapis.com/css2?family=Noto+Serif+KR:wght@300;400;600;700&family=Cormorant+Garamond:ital,wght@0,300;0,500;0,700;1,300;1,500&display=swap");
@import "../assets/css/style.css";

@font-face {
  font-family: "Pretendard-Regular";
  src: url("https://fastly.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "SUIT-Regular";
  src: url("https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_suit@1.0/SUIT-Regular.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Freesentation-9Black";
  src: url("https://fastly.jsdelivr.net/gh/projectnoonnu/2404@1.0/Freesentation-9Black.woff2") format("woff2");
  font-weight: 900;
  font-style: normal;
}

/**
  * Rakuten Logo Font
  * Source: https://fonts.google.com/specimen/Poppins
*/
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@700;800&display=swap');

.rakuten-logo {
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  color: #00BA00;
  letter-spacing: -0.5px;
}

/* ============================================================
   BASE RESET
   ============================================================ */
html, body {
  background-color: var(--color-cream) !important;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  overflow-x: hidden;
  font-family: var(--font-body) !important;
  color: var(--color-text) !important;
}

/* ============================================================
   LAYOUT
   ============================================================ */
#app .main-container {
  width: 100%;
  background-color: var(--color-cream);
}

.pc-container {
  display: flex;
  width: 100%;
  background-color: var(--color-cream);
}

.side { flex: 1; }

.center {
  width: 1200px;
  flex-shrink: 0;
}

/* ============================================================
   AD BAR
   ============================================================ */
.adBar {
  background: var(--color-navy);
}

.adBar_closeBtn_pc {
  position: absolute;
  top: 4px;
  right: 35%;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  color: var(--color-white);
  font-size: 0.85rem;
  cursor: pointer;
  width: 26px;
  height: 26px;
  line-height: 1;
  text-align: center;
  z-index: 10;
  transition: var(--transition);
}
.adBar_closeBtn_pc:hover {
  background: rgba(255,255,255,0.35);
}

/* ============================================================
   HEADER / TOP MENU
   ============================================================ */
#app .top-menu {
  padding: 0 20%;
  background: var(--color-white);
  border-bottom: 1px solid var(--color-border);
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px var(--color-shadow);
}

#app .mlogo {
  display: block;
  padding: 8px 0;
}
#app .mlogo .logo {
  width: 90px;
  height: auto;
  transition: var(--transition);
}
#app .mlogo .logo:hover {
  opacity: 0.8;
  transform: translateY(-1px);
}

#app .top-menu .nav .nav-item .nav-link {
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.05em;
  color: var(--color-navy) !important;
  padding: 8px 14px;
  border-radius: var(--radius-sm);
  transition: var(--transition);
  text-decoration: none;
}
#app .top-menu .nav .nav-item .nav-link:hover {
  background: var(--color-gold-pale);
  color: var(--color-gold) !important;
}

.blink {
  animation: blinker 1.8s ease-in-out infinite;
}
@keyframes blinker {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* ============================================================
   TOP BANNER CAROUSEL (PC)
   ============================================================ */
.topBanner #carouselExampleControls {
  max-width: 3000px;
  width: 100%;
}

.topBanner .carousel-inner,
.carousel-item {
  height: 100%;
}

.topBanner .carousel-image-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-navy);
  overflow: hidden;
}

.topBanner .carousel-image-container img {
  max-width: 3000px;
  height: 700px;
  object-fit: cover;
  width: 100%;
  transition: transform 8s ease;
}

.topBanner .carousel-item.active .carousel-image-container img {
  transform: scale(1.04);
}

/* Thumbnail indicators */
.topBanner .thumbnail-indicators {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  z-index: 2;
  gap: 8px;
}

.topBanner .thumbnail-indicators button {
  width: 90px;
  height: 54px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: var(--radius-sm);
  opacity: 0.4;
  overflow: hidden;
  padding: 0;
  background: none;
  text-indent: 0 !important;
  transition: var(--transition);
}

.thumbnail-indicators button.active {
  opacity: 1;
  border-color: var(--color-gold);
  transform: scale(1.08);
}

.thumbnail-indicators button:hover {
  opacity: 0.85;
  border-color: rgba(255,255,255,0.7);
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Carousel overlay text */
.topCarousel { position: relative; overflow: hidden; }

.carousel-text-box {
  position: absolute;
  top: 0;
  left: 20%;
  width: 380px;
  height: 80%;
  padding: 24px;
  background: linear-gradient(135deg, rgba(13,27,42,0.75), rgba(13,27,42,0.4));
  backdrop-filter: blur(4px);
  color: var(--color-white);
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.carouselText1 {
  font-family: var(--font-display);
  font-size: 44px;
  font-weight: 600;
  margin-top: 60px;
  margin-bottom: 10px;
  white-space: pre-wrap;
  line-height: 3.4rem;
  letter-spacing: -0.01em;
}

.carouselText2 {
  font-size: 18px;
  font-weight: 400;
  margin-top: auto;
  padding-bottom: 40px;
  letter-spacing: 0.03em;
  opacity: 0.9;
}

.carousel-blur-overlay {
  position: absolute;
  top: 0;
  left: 20%;
  width: 380px;
  height: 80%;
  backdrop-filter: blur(8px);
  z-index: 1;
}

/* Carousel controls */
.carousel-control-prev, .carousel-control-next {
  opacity: 0.6;
  transition: var(--transition);
}
.carousel-control-prev:hover, .carousel-control-next:hover {
  opacity: 1;
}

/* ============================================================
   CATEGORY MENU SECTION
   ============================================================ */
.menu_backgorund_color {
  background: var(--color-white) !important;
  border-radius: var(--radius-lg);
  padding: 16px !important;
  box-shadow: 0 4px 24px var(--color-shadow);
  margin-top: 20px !important;
}

.mainCategory {
  padding: 6px !important;
}

.cateButton {
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
  border-radius: var(--radius-md);
  overflow: hidden;
  transition: var(--transition);
  box-shadow: 0 2px 12px var(--color-shadow);
  display: block;
  width: 100%;
}

.cateButton img {
  width: 100%;
  height: 72px;
  display: block;
  object-fit: cover;
  transition: var(--transition-slow);
}

.cateButton:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px var(--color-shadow-md);
}

.cateButton:hover img {
  transform: scale(1.04);
}

.cateButton:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px var(--color-shadow);
}

/* ============================================================
   뱃지표시제어 (Shared)
     - badge-wrapper: 뱃지 전체 컨테이너 (뱃지1 + 뱃지2)
     - ts-badge-wrapper: 티켓/쿠폰 뱃지 전용 컨테이너 (뱃지1 + 뱃지2)
   ============================================================ */
#saleitemSection .badge-wrapper,
#vrItemSection .badge-wrapper,
#shItemSection .badge-wrapper,
#gfItemSection .badge-wrapper,
#nwItemSection .badge-wrapper,
#best-item .badge-wrapper {
  position: absolute !important;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding: 14px;
  z-index: 2;
}

#saleitemSection .badge-wrapper .badge1,
#saleitemSection .badge-wrapper .badge2,
#vrItemSection .badge-wrapper .badge1,
#vrItemSection .badge-wrapper .badge2,
#shItemSection .badge-wrapper .badge1,
#shItemSection .badge-wrapper .badge2,
#gfItemSection .badge-wrapper .badge1,
#gfItemSection .badge-wrapper .badge2,
#nwItemSection .badge-wrapper .badge1,
#nwItemSection .badge-wrapper .badge2,
#best-item .badge-wrapper .badge1,
#best-item .badge-wrapper .badge2 {
  position: static !important;
  margin: 0 !important;
  padding: 6px 12px !important;  /* ← 내부 여백 복원 */
}

/* 뱃지2 그라데이션 추가 */
#saleitemSection .badge-wrapper .badge2,
#vrItemSection .badge-wrapper .badge2,
#shItemSection .badge-wrapper .badge2,
#gfItemSection .badge-wrapper .badge2,
#nwItemSection .badge-wrapper .badge2,
#best-item .badge-wrapper .badge2 {
  background: linear-gradient(135deg, #4A90D9, #7B5EA7) !important;
  border: none !important;
  backdrop-filter: none !important;
}

/* 뱃지2 텍스트 색상 흰색으로 */
#saleitemSection .badge-wrapper .badge2 .badge2-text,
#vrItemSection .badge-wrapper .badge2 .badge2-text,
#shItemSection .badge-wrapper .badge2 .badge2-text,
#gfItemSection .badge-wrapper .badge2 .badge2-text,
#nwItemSection .badge-wrapper .badge2 .badge2-text,
#best-item .badge-wrapper .badge2 .badge2-text {
  color: #ffffff !important;
}

/** 모바일용 뱃지 */
.ts-badge-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;  /* 8px → 5px */
  margin-top: 8px;
  flex-wrap: wrap;
}

/* ============================================================
   SECTION TITLES (Shared)
   ============================================================ */
.section-title h2,
.section-title {
  font-family: var(--font-body);
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-navy);
  letter-spacing: -0.02em;
  margin-bottom: 4px;
}

.section-description {
  font-size: 0.95rem;
  color: var(--color-text-muted);
  margin-bottom: 0;
  font-weight: 400;
  line-height: 1.6;
}

.section-title a,
#more a {
  font-size: 0.85rem;
  color: var(--color-gold);
  text-decoration: none;
  font-weight: 600;
  letter-spacing: 0.03em;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: var(--transition);
  border-bottom: 1px solid transparent;
}
.section-title a:hover,
#more a:hover {
  border-bottom-color: var(--color-gold);
  color: var(--color-gold);
}

/* Section decorative line */
#saleitemSection::before,
#vrItemSection::before,
#shItemSection::before,
#gfItemSection::before,
#nwItemSection::before,
#best-item::before {
  content: '';
  display: block;
  width: 40px;
  height: 3px;
  background: var(--color-gold);
  border-radius: 2px;
  margin-bottom: 12px;
}

/* ============================================================
   SALE ITEM SECTION (엔데이트립 리스트)
   ============================================================ */
#saleitemSection {
  background: var(--color-white) !important;
  border-radius: var(--radius-lg);
  padding: 28px !important;
  box-shadow: 0 4px 32px var(--color-shadow);
}

#saleitemSection .section-title,
#vrItemSection .section-title,
#gfItemSection .section-title,
#nwItemSection .section-title,
#shItemSection .section-title {
  font-size: 1.45rem;
  font-weight: 700;
  color: var(--color-navy);
  margin-bottom: 4px;
}

#saleitemSection .c-content {
  height: 120px;            /* 부모 요소의 고정 높이 */
  display: flex;            /* 플렉스 박스를 사용하여 정렬 */
  align-items: flex-start;  /* 텍스트를 상단에 정렬 */
  padding-top: 0;           /* 상단 여백 제거 */
}

#saleitemSection .product-title {
  margin-top: 0;            /* 상단 마진 제거 */
  line-height: 1.2;         /* 줄 간격 고정 */
}

#saleitemSection .section-description,
#vrItemSection .section-description,
#gfItemSection .section-description,
#nwItemSection .section-description,
#shItemSection .section-description {
  font-size: 0.92rem;
  color: var(--color-text-muted);
  margin-bottom: 16px;
}

#saleitemSection .saleitemTable {
  height: 620px;
  vertical-align:top;
  margin: 0 !important;
  padding: 0 !important;
}

#saleitemSection .saleitemTable,
#saleitemSection .saleitemTable-2 {
  border-bottom: 1px solid var(--color-border);
}

/* Product left card */
#saleitemSection .product-detail {
  border: none;
  background: transparent;
  border-width: 0;
}

#saleitemSection .product-detail .rightPdtImage {
  padding-top: 0 !important;
  margin-top: 0 !important;
  width: 570px;
  height: 500px;  
  object-fit: cover; 
  /* width: 600px;
  height: 500px;
  object-fit: cover; */
  border-radius: var(--radius-lg);
  transition: var(--transition-slow);
}

#saleitemSection .nday-body {
  position: absolute;
  bottom: 20%;
  left: 5%;
  color: var(--color-white);
}

#saleitemSection .nday-body h5 {
  font-family: var(--font-accent);
  font-size: 3.4rem;
  margin-bottom: 0;
  text-align: start;
  text-shadow: 0 2px 12px rgba(0,0,0,0.4);
}

#saleitemSection .nday-body .showPdtName {
  font-size: 1.4rem;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-wrap: break-word;
  white-space: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: start;
  padding-right: 20px;
  font-weight: 600;
  text-shadow: 0 1px 8px rgba(0,0,0,0.3);
}

/* Badge */
#saleitemSection .badge { text-align: center; }

/* Product price display */
#saleitemSection .ndayPrice {
  font-family: var(--font-body);
  font-weight: 700;
}

#saleitemSection .card-body {
  padding: 12px 0 0 0;
  background: transparent;
}

#saleitemSection .nday-price {
  text-align: left;
}

/* Right product list */
#saleitemSection .saleitemTable-1 .saleList {
  padding: 0 12px;
}

#saleitemSection .saleitemTable-1 .pdt-img {
  object-fit: cover;
  display: block;
  border-radius: var(--radius-md) !important;
  transition: var(--transition);
}

#saleitemSection .saleitemTable-1 .pdt-img:hover {
  transform: scale(1.03);
  box-shadow: 0 6px 18px var(--color-shadow-md);
}
#saleitemSection .saleitemTable-1 .product-title {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--color-navy);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

#saleitemSection .saleitemTable-1 .product-description {
  font-size: 0.9rem;
  color: var(--color-text-muted);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Pagination */
#saleitemSection .pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 10px;
  gap: 8px;
}

#saleitemSection .pagination button {
  width: 34px;
  height: 34px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  background: var(--color-white);
  color: var(--color-navy);
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

#saleitemSection .pagination button:hover:not(:disabled) {
  background: var(--color-navy);
  color: var(--color-white);
  border-color: var(--color-navy);
}

#saleitemSection .pagination button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

#saleitemSection .pagination span {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--color-text-muted);
  letter-spacing: 0.05em;
}

/* Slide animation */
.slide-up-enter-active, .slide-up-leave-active,
.slide-down-enter-active, .slide-down-leave-active {
  transition: var(--transition);
}
.slide-up-enter-from { transform: translateY(16px); opacity: 0; }
.slide-up-leave-to   { transform: translateY(-16px); opacity: 0; }
.slide-down-enter-from { transform: translateY(-16px); opacity: 0; }
.slide-down-leave-to   { transform: translateY(16px); opacity: 0; }

/* 엔데이트립 좌측 이미지 카드 — 라운드/그림자 제거 */
#saleitemSection .nday .product-detail {
  border-radius: 0 !important;
  box-shadow: none !important;
}

/* ============================================================
   PRODUCT BADGES (Global shared)
   ============================================================ */
.badge { text-align: center; }

.badge .badge1 {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(135deg, var(--color-gold), #D4732A);
  opacity: 0.92 !important;
  padding: 6px 12px;
  border-radius: 0 0 var(--radius-sm) 0;
  width: auto !important;
  min-width: 100px;
}

.badge .badge1 .badge1-text {
  color: var(--color-white);
  font-size: 0.82rem !important;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.badge .badge2 {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255,255,255,0.92);
  backdrop-filter: blur(4px);
  padding: 6px 12px;
  border-radius: 0 0 var(--radius-sm) 0;
  min-width: 100px;
  border-right: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
}

.badge .badge2 .badge2-text {
  color: var(--color-navy);
  font-size: 0.82rem !important;
  font-weight: 700;
}

/* ============================================================
   VR ITEM / SH ITEM / GF ITEM SECTIONS / NW 
   ============================================================ */
#vrItemSection,
#shItemSection,
#nwItemSection,
#gfItemSection {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 28px !important;
  box-shadow: 0 4px 32px var(--color-shadow);
}

.vrItem .card,
.gfItem .card,
.nwItem .card,
.shItem .card {
  position: relative;
  border: none;
  overflow: hidden;
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 20px var(--color-shadow);
  transition: var(--transition);
  background: var(--color-navy);
}

.vrItem .card:hover,
.gfItem .card:hover,
.nwItem .card:hover,
.shItem .card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 40px var(--color-shadow-lg);
}

.vrItem .vrPdtImage,
.gfItem .gfPdtImage,
.nwItem .gfPdtImage,
.shItem .shPdtImage {
  width: 100%;
  height: 320px;
  object-fit: cover;
  transition: var(--transition-slow);
  opacity: 0.9;
}

.vrItem .card:hover .vrPdtImage,
.shItem .card:hover .shPdtImage,
.nwItem .card:hover .shPdtImage,
.gfItem .card:hover .gfPdtImage {
  transform: scale(1.05);
  opacity: 1;
}

#vrItemSection .vrItem .card-body,
#nwItemSection .nwItem .card-body,
#gfItemSection .gfItem .card-body,
#shItemSection .shItem .card-body {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: linear-gradient(to top,
    rgba(13,27,42,0.95) 0%,
    rgba(13,27,42,0.7) 60%,
    transparent 100%);
  padding: 20px 16px 16px;
}

#vrItemSection .vrItem .card-title,
#shItemSection .shItem .card-title,
#nwItemSection .nwItem .card-title,
#gfItemSection .gfItem .card-title {
  color: var(--color-white);
  font-weight: 600;
  font-size: 1.3rem;
  /* height: auto; */
  height: 20px;
  line-height: 1.6;
}

.vrItem .card-title .b-height,
.gfItem .card-title .b-height,
.shItem .card-title .b-height {
  height: auto;
  min-height: 5.5rem;
}

#vrItemSection .pdtName,
#gfItemSection .pdtName,
#nwItemSection .pdtName,
#shItemSection .pdtName {
  height: 3.7rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4em;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-white);
  margin-bottom: 4px;
}

#vrItemSection .pdtRemarks,
#gfItemSection .pdtRemarks,
#nwItemSection .pdtRemarks,
#shItemSection .pdtRemarks {
  font-size: 1rem;
  color: rgba(255,255,255,0.75);
  height: 3rem;
  min-height: 2.2rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4em;
  margin-bottom: 1px;
}

#vrItemSection .priceSection,
#gfItemSection .priceSection,
#nwItemSection .priceSection,
#shItemSection .priceSection {
  padding-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  border-top: 1px solid rgba(255,255,255,0.15);
  margin-top: 8px;
}

#vrItemSection .priceSection .ndayPrice,
#gfItemSection .priceSection .ndayPrice,
#nwItemSection .priceSection .ndayPrice,
#shItemSection .priceSection .ndayPrice {
  color: rgba(255,255,255,0.75);
}

/* Horizontal scroll */
#vrItemSection .scrolling-wrapper,
#gfItemSection .scrolling-wrapper,
#nwItemSection .scrolling-wrapper,
#shItemSection .scrolling-wrapper {
  position: relative;
  overflow-x: hidden;
  border-radius: var(--radius-md);
}

#vrItemSection .scrolling-content,
#gfItemSection .scrolling-content,
#nwItemSection .scrolling-content,
#shItemSection .scrolling-content {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 0;
}

#vrItemSection .scrolling-content::-webkit-scrollbar,
#gfItemSection .scrolling-content::-webkit-scrollbar,
#nwItemSection .scrolling-content::-webkit-scrollbar,
#shItemSection .scrolling-content::-webkit-scrollbar { display: none; }

#vrItemSection .vrItems,
#gfItemSection .gfItems,
#nwItemSection .nwItems,
#shItemSection .shItems {
  flex: 0 0 33.333%;
  max-width: 33.333%;
  padding: 6px;
}

#vrItemSection .scroll-btn,
#gfItemSection .scroll-btn,
#nwItemSection .scroll-btn,
#shItemSection .scroll-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: linear-gradient(135deg, var(--color-navy), var(--color-navy-light));
  border: 2px solid rgba(255,255,255,0.2);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
}

#vrItemSection .scroll-btn:hover,
#gfItemSection .scroll-btn:hover,
#nwItemSection .scroll-btn:hover,
#shItemSection .scroll-btn:hover {
  background: var(--color-gold);
  border-color: var(--color-gold);
  transform: translateY(-50%) scale(1.08);
}

#vrItemSection .scroll-btn.left,
#gfItemSection .scroll-btn.left,
#nwItemSection .scroll-btn.left,
#shItemSection .scroll-btn.left { left: 8px; }

#vrItemSection .scroll-btn.right,
#gfItemSection .scroll-btn.right,
#nwItemSection .scroll-btn.right,
#shItemSection .scroll-btn.right { right: 8px; }

/* ============================================================
   PC GROUPING PRODUCTS
   ============================================================ */
#groupProducts {
  background: var(--color-cream) !important;
  padding: 20px 0;
}

#groupProducts .image-container {
  display: flex;
  width: 1200px;
  height: 460px;
  justify-content: center;
  gap: 8px;
}

#groupProducts .group-image {
  width: 390px;
  height: 420px;
  object-fit: cover;
  transition: var(--transition-slow);
  filter: blur(1px) brightness(0.75);
  opacity: 0.65;
  margin: 0;
  border-radius: var(--radius-lg);
  cursor: pointer;
}

#groupProducts .group-image.active,
#groupProducts .group-image:hover {
  filter: blur(0) brightness(1);
  opacity: 1;
  transform: scale(1.03) translateY(-6px);
  box-shadow: 0 20px 48px var(--color-shadow-lg);
}

#groupProducts .image-container:hover .group-image:not(:hover) {
  filter: blur(2px) brightness(0.65);
  opacity: 0.5;
}

#groupProducts .blur-transition-enter-active,
#groupProducts .blur-transition-leave-active {
  transition: var(--transition-slow);
}

#groupProducts .blur-transition-enter-from,
#groupProducts .blur-transition-leave-to {
  filter: blur(12px);
  opacity: 0;
}

#groupProducts .progress-indicator {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 16px;
}

#groupProducts .progress-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-border);
  transition: var(--transition);
}

#groupProducts .progress-dot.active {
  background: var(--color-gold);
  transform: scale(1.4);
}

/* ============================================================
   GROUPING PRODUCT LIST
   ============================================================ */
#grProductList {
  background: var(--color-cream) !important;
  padding: 0 10px 20px !important;
}

#grProductList .grProductLsitContainer {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1200px;
  height: auto;
  gap: 0;
}

#grProductList .grProductCard {
  flex: 0 0 auto;
  width: calc(25% - 16px);
  margin: 8px;
  padding: 0;
}

#grProductList .card {
  border: none !important;
  border-radius: var(--radius-lg) !important;
  overflow: hidden;
  box-shadow: 0 4px 20px var(--color-shadow);
  transition: var(--transition);
  background: var(--color-white) !important;
}

#grProductList .card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 40px var(--color-shadow-md);
}

#grProductList .card > img {
  transition: var(--transition-slow);
}

#grProductList .card:hover > img {
  transform: scale(1.04);
}

#grProductList .grCardBody {
  padding: 14px 16px !important;
  background: var(--color-white);
}

#grProductList .grCardBody .grProductTitle {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.98rem;
  color: var(--color-navy);
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 6px;
}

#grProductList .grCardBody .grProductRemarks {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
  font-size: 0.83rem;
  color: var(--color-text-muted);
  white-space: normal;
  height: 64px;
  text-overflow: ellipsis;
  word-break: break-all;
}

#grProductList .card-price {
  padding-top: 8px;
  border-top: 1px solid var(--color-border);
  margin-top: 8px;
}

#grProductList .ndayPrice {
  font-size: 1.05rem;
  font-weight: 700;
  /* color: var(--color-navy); */
}

/* ============================================================
   MID BANNER
   ============================================================ */
#midBanner {
  display: flex !important;
  justify-content: space-between !important;
  align-items: stretch !important;
  gap: 16px !important;
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}

#midBanner .mid-banner1,
#midBanner .mid-banner2 {
  width: calc(50% - 8px) !important;
  border-radius: var(--radius-lg) !important;
  overflow: hidden !important;
  box-shadow: 0 4px 20px var(--color-shadow) !important;
}

#midBanner .mid-banner1:hover,
#midBanner .mid-banner2:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px var(--color-shadow-md);
}

#midBanner .mid-banner1 img,
#midBanner .mid-banner2 img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  display: block !important;
}

#midBanner .mid-banner1:hover img,
#midBanner .mid-banner2:hover img {
  transform: scale(1.03);
}

/* ============================================================
   BEST ITEM SECTION
   ============================================================ */
.bestitem {
  margin-bottom: 2rem;
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 28px !important;
  box-shadow: 0 4px 32px var(--color-shadow);
}

.bestitem .card {
  border: none;
  overflow: hidden;
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 20px var(--color-shadow);
  transition: var(--transition);
}

.bestitem .card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 48px var(--color-shadow-lg);
}

.bestitem .card img {
  width: 100%;
  height: 35rem;
  object-fit: cover;
  transition: var(--transition-slow);
}

.bestitem .card:hover img {
  transform: scale(1.06);
}

.bestitem .card-body {
  position: absolute;
  bottom: 0;
  background: linear-gradient(to top,
    rgba(13,27,42,0.97) 0%,
    rgba(13,27,42,0.65) 55%,
    transparent 100%);
  width: 100%;
  padding: 24px 20px 16px;
}

.bestitem .card-title {
  color: var(--color-white);
  height: auto;
  font-weight: 600;
  font-size: 1.1rem;
  line-height: 1.5;
}

.bestitem .card-title .b-height {
  min-height: 3rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

#best-item .pdtName {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--color-white);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 4px;
}

#best-item .pdtRemarks {
  font-size: 0.83rem;
  color: rgba(255,255,255,0.7);
  height: auto;
  min-height: 1.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
  margin-top: 4px;
}

#best-item .priceSection {
  border-top: 1px solid rgba(255,255,255,0.15);
  padding-top: 10px;
  margin-top: 8px;
}

/* Horizontal scroll — BEST */
#best-item .scrolling-wrapper {
  position: relative;
  overflow-x: hidden;
}

#best-item .scrolling-content {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

#best-item .scrolling-content::-webkit-scrollbar { display: none; }

#best-item .bestItems {
  flex: 0 0 33.333%;
  max-width: 33.333%;
  padding: 6px;
}

#best-item .scroll-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: linear-gradient(135deg, var(--color-navy), var(--color-navy-light));
  border: 2px solid rgba(255,255,255,0.2);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
}

#best-item .scroll-btn:hover {
  background: var(--color-gold);
  border-color: var(--color-gold);
  transform: translateY(-50%) scale(1.1);
}

#best-item .scroll-btn.left { left: 10px; }
#best-item .scroll-btn.right { right: 10px; }

/* ============================================================
   LIVE SECTION
   ============================================================ */
#liveSection {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 28px !important;
  box-shadow: 0 4px 32px var(--color-shadow);
}

#liveSection .section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-border);
  margin-bottom: 20px;
}

.iframe-container {
  position: relative;
  width: 100%;
  height: 550px;
  overflow-x: auto;
  overflow-y: hidden;
  border-radius: var(--radius-md);
}

.iframe-container iframe {
  position: absolute;
  top: -350px;
  left: 0;
  width: 1400px;
  height: 1300px;
  border: none;
}

/* ============================================================
   NOTICE / EVENT SECTION
   ============================================================ */
#notice {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 28px !important;
  box-shadow: 0 4px 32px var(--color-shadow);
  margin-bottom: 40px;
}

#notice .section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#notice * { margin: 0; padding: 0; }

/* 공지 캐러셀: 위 리셋으로 사라진 Bootstrap 기본값 복원 */
#notice .carousel-item {
  margin-right: -100%;
}

.text-touch {
  transition: var(--transition);
}

#notice .noticeTable .leftImg {
  max-width: 100%;
  width: 100%;
  height: 600px;
  object-fit: cover;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: var(--transition);
}

#notice .noticeTable .leftImg:hover {
  transform: scale(1.01);
}

#notice .noticeTable td,
#notice .noticeTable tr {
  padding: 0 !important;
}

#notice .noticePrev,
#notice .noticeNext {
  font-size: 1.8rem;
  color: var(--color-gold);
}

/* Notice list */
#notice .post-entry {
  text-align: left;
  padding: 10px 16px;
  font-size: 0.88rem;
  border-bottom: 1px solid var(--color-border);
  transition: var(--transition);
}

#notice .post-entry:last-child { border-bottom: none; }

#notice .post-entry:hover {
  background: var(--color-gold-pale);
  border-radius: var(--radius-sm);
}

#notice .notice-header {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
}

#notice .notice-header b {
  flex-shrink: 0;
  font-size: 1.0rem;
  padding: 2px 8px;
  border-radius: var(--radius-sm);
  font-weight: 600;
}

#notice .noticeTitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1 auto;
  font-size: 1.0rem;
  color: var(--color-text);
  font-weight: 600;
}

#notice .post-entry .date-read {
  font-size: 0.75rem;
  color: var(--color-text-muted);
  letter-spacing: 0.03em;
}

/* Quick menu */
#notice .quick {
  margin-top: 20px;
  padding: 16px;
  background: var(--color-cream);
  border-radius: var(--radius-md);
}

#notice .quick img {
  width: 4rem;
  height: auto;
  transition: var(--transition);
}

#notice .quick .col-3:hover img {
  transform: translateY(-3px) scale(1.05);
}

#notice .quickTitle {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-navy);
  margin-top: 6px;
}

/* ============================================================
   REMOTE CONTROL SIDE
   ============================================================ */
.side.right { position: relative; }

.rt-remote-container {
  position: fixed;
  left: calc(50% + 640px) !important;
  top: calc(72px + var(--topBanner-height) + 20px) !important;
  transition: top 0.3s ease;
  z-index: 99;
}

@media only screen and (max-width: 1859px) {
  .rt-remote-container { display: none !important; }
}
@media only screen and (min-width: 1860px) {
  .rt-remote-container { display: block !important; }
}

/* ============================================================
   MOBILE: Base
   ============================================================ */
#main-app {
  font-family: var(--font-body);
  max-width: 500px;
  margin: 0 auto;
  background: var(--color-cream);
  margin-top: 55px;
}

/* ============================================================
   MOBILE: Menu bar
   ============================================================ */
#main-app .mobile-menu {
  display: block;
  background: var(--color-white);
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  border-bottom: 1px solid var(--color-border);
  box-shadow: 0 2px 16px var(--color-shadow);
  padding-bottom: 4px;
  z-index: 999;
}

#main-app .mobile-menu .mmenu .toolbar-login a {
  display: inline-block;
  color: var(--color-navy);
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0 10px;
  letter-spacing: 0.02em;
}

#main-app .mobile-menu .mmenu .mbtn-close {
  padding-right: 30px;
}

#main-app .mobile-menu .mmenu .navbar-nav .nav-item a {
  color: var(--color-navy);
  font-size: 0.98rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  line-height: 48px;
  transition: var(--transition);
}

#main-app .mobile-menu .mmenu .navbar .nav-item .nav-link:hover {
  color: var(--color-gold);
}

#main-app .mobile-menu .mmenu .dropdown .dropdown-menu {
  position: sticky !important;
  transform: translateY(0px) !important;
  margin-top: -20px !important;
  border: none;
  background: var(--color-cream);
  border-radius: var(--radius-md);
}

#main-app .hr-line {
  border-top: 8px solid var(--color-border);
}

@media (min-width: 992px) {
  #main-app .mobile-menu { display: none; }
}

/* ============================================================
   MOBILE: AD BAR close button
   ============================================================ */
.adBar_closeBtn_mo {
  position: absolute;
  top: 8px;
  right: 6px;
  background: rgba(255,255,255,0.85);
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: var(--color-navy);
  z-index: 10;
  width: 28px;
  height: 28px;
  line-height: 1;
  text-align: center;
  border-radius: 50%;
  transition: var(--transition);
}
.adBar_closeBtn_mo:hover {
  background: var(--color-white);
}

/* ============================================================
   MOBILE: Top Carousel
   ============================================================ */
#topBanner-m .carousel-indicators {
  position: absolute;
  bottom: 12px;
  display: flex;
  justify-content: center;
  gap: 6px;
}

#topBanner-m .carousel-indicators button {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-white);
  opacity: 0.4;
  border: none;
  transition: var(--transition);
}

#topBanner-m .carousel-indicators button.active {
  opacity: 1;
  background: var(--color-gold);
  transform: scale(1.3);
}

#main-app .carousel-item {
  transition: transform 0.25s ease-in-out;
}

/* ============================================================
   MOBILE: Category Menu
   ============================================================ */
#main-app .main-menu {
  text-align: center;
  padding: 16px 0 0;
  background: var(--color-white);
}

#main-app .icon-menu {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding-inline: 10px;
  height: 130px;
}

#main-app .icon-item {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 130px;
  padding-top: 8px;
}

#main-app .icon-item img {
  width: 56px !important;
  height: 56px !important;
  object-fit: fill;
  margin-bottom: 8px;
  border-radius: var(--radius-md);
  transition: var(--transition);
}

#main-app .icon-item:active img {
  transform: scale(0.93);
}

#main-app .icon-text {
  font-size: 0.78rem;
  font-weight: 700;
  text-align: center;
  color: var(--color-navy);
  line-height: 1.25;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ============================================================
   MOBILE: Grouping Products
   ============================================================ */
.product-title_mo {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.92rem;
  color: var(--color-navy);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.grProductRemarks_mo {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.35;
  max-height: calc(1.35rem * 2);
  word-break: break-all;
  text-overflow: ellipsis;
  font-size: 0.8rem;
  font-weight: 400;
  color: var(--color-text-muted);
  white-space: normal;
  height: 40px;
}

.priceSection_mo {
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-size: 0.85rem;
}

/* ============================================================
   MOBILE: ntabi-recommend / ndaytrip-recommend / ship-recommend
   ============================================================ */
#main-app .ntabi-recommend,
#main-app .ndaytrip-recommend,
#main-app .ship-recommend {
  padding: 20px 16px;
  background: var(--color-white);
  border-radius: var(--radius-lg);
  margin: 8px;
  box-shadow: 0 2px 12px var(--color-shadow);
}

#main-app .ntabi-recommend h2,
#main-app .ndaytrip-recommend h2,
#main-app .ship-recommend h2 {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--color-navy);
  margin-bottom: 14px !important;
  letter-spacing: -0.02em;
}

#main-app .ntabi {
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-md);
  width: 140px;
  height: 140px;
  box-shadow: 0 3px 12px var(--color-shadow);
  transition: var(--transition);
}

#main-app .ntabi:active {
  transform: scale(0.96);
}

#main-app .ntabi img {
  width: 140px;
  height: 140px;
  object-fit: cover;
  border-radius: var(--radius-md);
  transition: var(--transition-slow);
}

#main-app .ntabi .ntabi-body {
  position: absolute;
  bottom: 5%;
  left: 6%;
  color: var(--color-white);
}

#main-app .ntabi .ntabi-body h5 {
  font-family: var(--font-body);
  font-size: 0.95rem;
  font-weight: 800;
  margin-bottom: 0;
  text-shadow: 0 1px 6px rgba(0,0,0,0.5);
}

#main-app .ntabi .showPdtName {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(255,255,255,0.9);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  padding-right: 10px;
  text-shadow: 0 1px 4px rgba(0,0,0,0.4);
}

/* scroll wrapper */
#main-app .scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#main-app .scrolling-wrapper::-webkit-scrollbar { display: none; }

#main-app .scrolling-content {
  display: inline-flex;
  gap: 10px;
  padding: 4px 2px;
}

#main-app .ntabi-pdt {
  flex: 0 0 auto;
  width: 150px;
}

/* ============================================================
   MOBILE: LIVE SECTION
   ============================================================ */
#liveSection-m {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  margin: 8px;
  padding: 16px !important;
  box-shadow: 0 2px 12px var(--color-shadow);
}

#liveSection-m .section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-inline: 0;
  margin-bottom: 12px;
}

#liveSection-m .ndayliveThumb {
  width: 50%;
  border: none;
}

#liveSection-m .ndayliveTable {
  padding: 0;
}

#liveSection-m .cardImg .nliveThumb {
  width: 100%;
  object-fit: cover;
  border-radius: var(--radius-md);
  transition: var(--transition);
}

#liveSection-m .cardText .p1 {
  font-size: 0.82rem;
  padding: 6px 4px 2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-family: var(--font-body);
  color: var(--color-text);
  line-height: 1.45;
  margin-bottom: 2px;
}

#liveSection-m .cardText .p2 {
  padding: 0 4px 16px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--color-navy);
}

#liveSection-m .cardText .dcRate {
  color: var(--color-gold);
  font-weight: 800;
}

/* ============================================================
   MOBILE: NOTICE SECTION
   ============================================================ */
#notice-m {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  margin: 8px;
  padding: 16px !important;
  box-shadow: 0 2px 12px var(--color-shadow);
}

#notice-m .section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-inline: 0;
}

.noticeTable-m .ntImg_m {
  width: 100%;
  height: 280px;
  object-fit: cover;
  border-radius: var(--radius-md);
}

#notice-m .post-entry {
  text-align: left;
  padding: 8px 0;
  font-size: 0.83rem;
  border-bottom: 1px solid var(--color-border);
}

#notice-m .notice-header {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  white-space: nowrap;
}

#notice-m .noticeTitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  font-size: 0.85rem;
  color: var(--color-text);
}

#notice-m .post-entry .date-read {
  font-size: 0.7rem;
  color: var(--color-text-muted);
}

/* Quick menu mobile */
#notice-m .quick {
  margin-top: 16px;
  padding: 12px;
  background: var(--color-cream);
  border-radius: var(--radius-md);
}

#notice-m .quick img {
  width: 2.4rem;
  height: auto;
  transition: var(--transition);
}

#notice-m .quick p {
  color: var(--color-navy);
  font-size: 0.72rem;
  font-weight: 600;
  margin-top: 4px;
  transition: var(--transition);
}

/* ============================================================
   MOBILE: VIDEO SECTION
   ============================================================ */
.video-section {
  background: var(--color-navy);
  border-radius: var(--radius-lg);
  overflow: hidden;
  margin: 8px;
  box-shadow: 0 4px 20px var(--color-shadow-md);
}

.video-carousel-item {
  width: 100%;
  height: 500px;
  overflow: hidden;
  display: block;
}

#videoCarousel .carousel-control-prev,
#videoCarousel .carousel-control-next,
#videoCarousel_m .carousel-control-prev,
#videoCarousel_m .carousel-control-next {
  background: rgba(13,27,42,0.5);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  top: 50%;
  transform: translateY(-50%);
  border: 1px solid rgba(255,255,255,0.2);
  transition: var(--transition);
}

#videoCarousel .carousel-control-prev:hover,
#videoCarousel .carousel-control-next:hover,
#videoCarousel_m .carousel-control-prev:hover,
#videoCarousel_m .carousel-control-next:hover {
  background: var(--color-gold);
  border-color: var(--color-gold);
}

#videoCarousel .carousel-control-prev,
#videoCarousel_m .carousel-control-prev { left: 10px; right: unset; }
#videoCarousel .carousel-control-next,
#videoCarousel_m .carousel-control-next { right: 10px; left: unset; }

@media (max-width: 768px) {
  .video-carousel-item { height: 250px; }
}
@media (max-width: 500px) {
  .video-carousel-item { height: 200px; }
}

/* ============================================================
   MOBILE: MID CAROUSEL
   ============================================================ */
#midBanner-m {
  margin: 8px;
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: 0 2px 12px var(--color-shadow);
}

/* ============================================================
   MOBILE: Product Banner
   ============================================================ */
.product-banner {
  margin: 8px;
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: 0 2px 12px var(--color-shadow);
}

.product-banner .border {
  border-radius: var(--radius-lg) !important;
  overflow: hidden;
  border: none !important;
}

.product-banner img {
  border-radius: var(--radius-lg);
  transition: var(--transition);
}

/* ============================================================
   MOBILE: GROUPING CAROUSEL
   ============================================================ */
#groupProducts.groupProduct {
  background: var(--color-cream) !important;
  border-radius: var(--radius-lg);
  margin: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px var(--color-shadow);
}

#groupProducts.groupProduct .product-list {
  padding: 12px;
}

#groupProducts.groupProduct .product-list .row {
  background: var(--color-white);
  border-radius: var(--radius-md);
  margin: 6px 0;
  padding: 8px 4px;
  box-shadow: 0 2px 8px var(--color-shadow);
  transition: var(--transition);
}

#groupProducts.groupProduct .product-list .row:active {
  transform: scale(0.98);
}

/* ============================================================
   PRICE DISPLAY (Global)
   ============================================================ */
.ndayPrice {
  font-weight: 700;
  font-family: var(--font-body);
  color: var(--color-navy);
}

.text-danger {
  color: #E03A3A !important;
}

.text-warning {
  color: var(--color-gold) !important;
}

.mbus-icon {
  width: 2.2rem !important;
  height: auto !important;
  opacity: 0.7;
}

/* ============================================================
   UTILITY
   ============================================================ */
.hover-zoom {
  transition: var(--transition-slow);
}
.hover-zoom:hover {
  transform: scale(1.04);
}

h2 { margin-bottom: 20px !important; }

/* Touch feedback */
#carouselExampleControls,
#midCsControls,
#carouselExampleControls_gr {
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
}

/* ============================================================
   MOBILE: Recent items offcanvas
   ============================================================ */
#main-app .mobile-menu .mrecent img {
  width: 5.5rem;
  height: 5.5rem;
  object-fit: cover;
  border-radius: var(--radius-md);
}

#main-app .mobile-menu .mrecent .recent p {
  text-align: left;
  font-size: 0.85rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: var(--color-text);
  margin-bottom: 0;
}

/* ============================================================
   MISC INPUT / TYPOGRAPHY
   ============================================================ */
.slide-text { font-family: var(--font-accent); text-align: left; }

#newMain .cap { font-family: var(--font-body); }

.ct-position { width: 100%; }

.searchBox {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding-left: 28px;
  font-size: 0.85rem;
  background: var(--color-cream);
  transition: var(--transition);
}

.searchBox:focus {
  border-color: var(--color-gold);
  box-shadow: 0 0 0 3px rgba(200,150,62,0.12);
  outline: none;
}

.input-with-icon { position: relative; }

.input-with-icon::before {
  content: "🔍";
  position: absolute;
  left: 7px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 13px;
  pointer-events: none;
}

/* Membership icons */
.memLabel {
  padding: 2px 8px;
  font-size: 0.82rem;
  border-radius: 20px;
  color: var(--color-white);
  font-weight: 700;
}

.memLabel-m {
  padding: 1px 6px;
  font-size: 0.7rem;
  border-radius: 20px;
  color: var(--color-white);
  font-weight: 700;
}

/* Overlap fix */
#grProductList {
  margin-bottom: 2rem;
}

/* section spacing */
.mt-5 {
  margin-top: 2.5rem !important;
}

/**********
  * 지금 뜨는 여행 : 모바일
**********/
.ts-section {
  background: #EEF3FA;
  padding: 16px 0 20px;
}
.ts-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 10px;
}
.ts-title {
  font-size: 20px;
  font-weight: 800;
  color: #111;
  letter-spacing: -0.5px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ts-clock-icon {
  color: #FF4B7B;
  font-size: 18px;
}
.ts-more {
  font-size: 13px;
  color: #888;
  cursor: pointer;
}
.ts-scroll-wrap {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding: 4px 16px 4px;
  scrollbar-width: none;
}
.ts-scroll-wrap::-webkit-scrollbar { display: none; }

.ts-card {
  flex: 0 0 82%;        /* 좌우 peek 효과 */
  scroll-snap-align: center;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}
.ts-card-img {
  width: 100%;
  height: 160px;
  object-fit: cover;
  display: block;
  cursor: pointer;
}
.ts-card-body {
  padding: 12px 14px 14px;
}
.ts-timer {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #4A8DFF;
  margin-bottom: 6px;
}
.ts-timer-dot {
  width: 6px;
  height: 6px;
  background: #4A8DFF;
  border-radius: 50%;
  animation: tsBlink 1s infinite;
}
@keyframes tsBlink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.2; }
}
.ts-pdt-name {
  font-size: 14px;
  font-weight: 700;
  color: #111;
  line-height: 1.4;
  letter-spacing: -0.3px;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
}
.ts-pdt-tags {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ts-price-row {
  display: flex;
  align-items: baseline;
  gap: 5px;
  flex-wrap: wrap;
  cursor: pointer;
}
.ts-discount {
  font-size: 16px;
  font-weight: 800;
  color: #FF4B7B;
}
.ts-final-price {
  font-size: 17px;
  font-weight: 800;
  color: #111;
}
.ts-won {
  font-size: 13px;
  font-weight: 400;
}
.ts-original {
  font-size: 12px;
  color: #bbb;
  text-decoration: line-through;
}
.ts-coupon-badge {
  margin-top: 8px;
  display: inline-block;
  border: 1px solid #FF4B7B;
  color: #FF4B7B;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 600;
}
.ts-coupon-badge2 {
  margin-top: 8px;
  display: inline-block;
  border: 1px solid #5a4bff;
  color: #1322f7;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 600;
}
.ts-no-price {
  font-size: 13px;
  color: #aaa;
}
.ts-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 14px;
}
.ts-page-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: #fff;
  color: #555;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ts-page-info {
  font-size: 14px;
  font-weight: 600;
  color: #444;
  min-width: 40px;
  text-align: center;
}

/**
  일본라쿠텐 제휴호텔 검색
*/
.hotel-search-section {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 28px !important;
  box-shadow: 0 4px 32px var(--color-shadow);
}

/**
  일본라쿠텐 제휴호텔 검색 (모바일)
*/
.hotel-search-section-mo {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 12px !important;    /* 16px → 12px */
  box-shadow: 0 2px 12px var(--color-shadow);
}

/* ============================================================
   INSTAGRAM SECTION (2026-10-13)
   ============================================================ */
   #igItemSection {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 28px !important;
  box-shadow: 0 4px 32px var(--color-shadow);
}

#igItemSection::before {
  content: '';
  display: block;
  width: 40px;
  height: 3px;
  background: var(--color-gold);
  border-radius: 2px;
  margin-bottom: 12px;
}

#igItemSection .section-title {
  font-size: 1.45rem;
  font-weight: 700;
  color: var(--color-navy);
  margin-bottom: 4px;
}

#igItemSection .section-description {
  font-size: 0.92rem;
  color: var(--color-text-muted);
  margin-bottom: 16px;
}

/* 가로 스크롤 */
#igItemSection .scrolling-wrapper {
  position: relative;
  overflow-x: hidden;
  border-radius: var(--radius-md);
}

#igItemSection .scrolling-content {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  align-items: flex-start;   /* 게시물마다 높이가 달라도 상단 정렬 */
  scrollbar-width: none;
}
#igItemSection .scrolling-content::-webkit-scrollbar { display: none; }

#igItemSection .igItems {
  flex: 0 0 33.333%;
  max-width: 33.333%;
  padding: 6px;
}

/* 카드 */
#igItemSection .ig-card {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 20px var(--color-shadow);
  overflow: hidden;
  transition: var(--transition);
}

#igItemSection .ig-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 40px var(--color-shadow-lg);
}

/* embed.js 로딩 전 placeholder */
#igItemSection .ig-card :deep(blockquote.instagram-media) {
  margin: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  min-height: 480px;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  background: var(--color-cream) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* embed.js가 치환한 iframe */
#igItemSection .ig-card :deep(iframe.instagram-media) {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

#igItemSection .ig-fallback {
  color: var(--color-dark-light);
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
}

/* 스크롤 버튼 (다른 섹션과 동일) */
#igItemSection .scroll-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: linear-gradient(135deg, var(--color-navy), var(--color-navy-light));
  border: 2px solid rgba(255,255,255,0.2);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
}

#igItemSection .scroll-btn:hover {
  background: var(--color-gold);
  border-color: var(--color-gold);
  transform: translateY(-50%) scale(1.08);
}

#igItemSection .scroll-btn.left  { left: 8px; }
#igItemSection .scroll-btn.right { right: 8px; }

/* ============================================================
   MOBILE: INSTAGRAM SECTION (2026-10-13)
   ============================================================ */
   #igSection-m {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  margin: 8px;
  padding: 20px 0 16px;
  box-shadow: 0 2px 12px var(--color-shadow);
}

#igSection-m .ig-header-m {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 12px;
}

#igSection-m .ig-header-m h2 {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--color-navy);
  letter-spacing: -0.02em;
  margin-bottom: 0 !important;
  display: flex;
  align-items: center;
  gap: 6px;
}

#igSection-m .ig-icon-m {
  font-size: 1.25rem;
  background: linear-gradient(45deg, #f09433, #dc2743, #bc1888);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

#igSection-m .ig-more-m {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--color-dark-light);
  text-decoration: none;
  white-space: nowrap;
}

/* 가로 스와이프 (좌우 peek) */
#igSection-m .ig-scroll-wrap-m {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding: 4px 16px 8px;
  align-items: flex-start;
  scrollbar-width: none;
}
#igSection-m .ig-scroll-wrap-m::-webkit-scrollbar { display: none; }

#igSection-m .ig-card-m {
  flex: 0 0 88%;
  scroll-snap-align: center;
  background: var(--color-white);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  box-shadow: 0 2px 12px var(--color-shadow);
  overflow: hidden;
}

/* embed.js 로딩 전 placeholder */
#igSection-m .ig-card-m :deep(blockquote.instagram-media) {
  margin: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  min-height: 420px;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  background: var(--color-cream) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* embed.js가 치환한 iframe (좁은 폰 대응: min-width 해제) */
#igSection-m .ig-card-m :deep(iframe.instagram-media) {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

#igSection-m .ig-fallback-m {
  color: var(--color-dark-light);
  font-weight: 600;
  font-size: 0.88rem;
  text-decoration: none;
}

/* 페이지 버튼 */
#igSection-m .ig-pagination-m {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 10px;
}

#igSection-m .ig-page-btn-m {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid var(--color-border);
  background: var(--color-white);
  color: var(--color-navy);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
}

#igSection-m .ig-page-btn-m:disabled {
  opacity: 0.3;
}

#igSection-m .ig-page-info-m {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text-muted);
  min-width: 40px;
  text-align: center;
}

/* ============================================================
   INSTAGRAM: 카드 높이 통일 (PC + 모바일 공통)
   ============================================================ */
   #igItemSection .ig-card,
#igSection-m .ig-card-m {
  position: relative;
}

/* 고정 비율 프레임: 2:3 (폭에 비례해서 높이 자동 계산) */
#igItemSection .ig-frame,
#igSection-m .ig-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 2 / 3;
  overflow: hidden;
  background: var(--color-cream);
}

/* 로딩 전 placeholder도 프레임 높이에 맞춤 */
#igItemSection .ig-card .ig-frame :deep(blockquote.instagram-media),
#igSection-m .ig-card-m .ig-frame :deep(blockquote.instagram-media) {
  min-height: 0 !important;
  height: 100% !important;
}

/* 하단 페이드 + 버튼 */
#igItemSection .ig-more-overlay,
#igSection-m .ig-more-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 96px;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 14px;
  text-decoration: none;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.92) 55%,
    #ffffff 100%
  );
}

#igItemSection .ig-more-overlay span,
#igSection-m .ig-more-overlay span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 999px;
  background: linear-gradient(45deg, #f09433, #dc2743, #bc1888);
  color: #ffffff;
  font-size: 0.85rem;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(220, 39, 67, 0.3);
  transition: var(--transition);
}

#igItemSection .ig-more-overlay:hover span {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(220, 39, 67, 0.4);
}

/* 모바일은 페이드 영역 조금 작게 */
#igSection-m .ig-more-overlay {
  height: 80px;
  padding-bottom: 12px;
}

#igSection-m .ig-more-overlay span {
  font-size: 0.8rem;
  padding: 6px 14px;
}

/* ============================================================
   MOBILE INSTAGRAM: 섹션 제목 한 줄 고정 (2026-10-15)
   ============================================================ */
#igSection-m .ig-header-m {
  gap: 8px;
}

#igSection-m .ig-header-m h2 {
  display: block !important;          /* 말줄임(…) 적용을 위해 flex → block */
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: clamp(0.9rem, 4.1vw, 1.15rem) !important;   /* 화면 폭에 따라 자동 축소 */
}

#igSection-m .ig-header-m h2 .ig-icon-m {
  margin-right: 4px;
  vertical-align: -1px;
}

#igSection-m .ig-more-m {
  flex-shrink: 0;                     /* 전체보기는 줄어들지 않게 */
  font-size: 0.75rem;
}
</style>